import * as Apollo from "@apollo/client";
import { gql } from "@apollo/client";
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  BigInt: { input: any; output: any };
  Date: { input: any; output: any };
  DateTime: { input: any; output: any };
  DateTimeRangeScalar: { input: any; output: any };
  Decimal: { input: any; output: any };
  GenericScalar: { input: any; output: any };
  JSONString: { input: any; output: any };
  NotEmptyID: { input: any; output: any };
  Time: { input: any; output: any };
  Upload: { input: any; output: any };
};

/** An enumeration. */
export enum AcademyCourseResultStatusChoices {
  /** Completed */
  COMPLETED = "COMPLETED",
  /** Failed */
  FAILED = "FAILED",
  /** In Progress */
  IN_PROGRESS = "IN_PROGRESS",
  /** Not Started */
  NOT_STARTED = "NOT_STARTED",
}

export type AcademyMutation = {
  __typename?: "AcademyMutation";
  startCourse?: Maybe<CourseResultCreateMutation>;
};

export type AcademyMutationStartCourseArgs = {
  input: UpdateCourseResultInput;
};

export type AcademyQuery = {
  __typename?: "AcademyQuery";
  courses?: Maybe<CourseNodeConnection>;
};

export type AcademyQueryCoursesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  results_Status?: InputMaybe<AcademyCourseResultStatusChoices>;
};

export type AcceptJobSuggestionMutation = {
  __typename?: "AcceptJobSuggestionMutation";
  created?: Maybe<Scalars["Boolean"]["output"]>;
  jobPositionAssignment?: Maybe<JobPositionAssignmentNode>;
};

export type AccessType = {
  __typename?: "AccessType";
  id: Scalars["ID"]["output"];
  slug: Scalars["String"]["output"];
  title?: Maybe<Scalars["String"]["output"]>;
};

export type AccountMutation = {
  __typename?: "AccountMutation";
  admin?: Maybe<AdminMutation>;
  canadaVisa?: Maybe<CanadaVisaMutation>;
  certificateAndLicense?: Maybe<CertificateAndLicenseMutation>;
  education?: Maybe<EducationMutation>;
  employment?: Maybe<EmploymentMutation>;
  googleAuth?: Maybe<GoogleAuth>;
  languageCertificate?: Maybe<LanguageCertificateMutation>;
  linkedinAuth?: Maybe<LinkedInAuth>;
  organization?: Maybe<OrganizationMutation>;
  passwordReset?: Maybe<PasswordReset>;
  performOnboardingJobSuggestion?: Maybe<PerformOnboardingJobSuggestionMutation>;
  profile?: Maybe<ProfileMutation>;
  refreshToken?: Maybe<RefreshToken>;
  register?: Maybe<UserRegister>;
  resendActivationEmail?: Maybe<ResendActivationEmail>;
  revokeToken?: Maybe<RevokeTokenMutation>;
  sendPasswordResetEmail?: Maybe<SendPasswordResetEmail>;
  supportTicket?: Maybe<SupportTicketMutation>;
  tokenAuth?: Maybe<ObtainJsonWebToken>;
  verify?: Maybe<VerifyAccount>;
  workExperience?: Maybe<WorkExperienceMutation>;
};

export type AccountMutationGoogleAuthArgs = {
  accessToken: Scalars["String"]["input"];
  deviceId: Scalars["String"]["input"];
  jobReferralCode?: InputMaybe<Scalars["String"]["input"]>;
  referralCode?: InputMaybe<Scalars["String"]["input"]>;
};

export type AccountMutationLinkedinAuthArgs = {
  code: Scalars["String"]["input"];
  deviceId: Scalars["String"]["input"];
  jobReferralCode?: InputMaybe<Scalars["String"]["input"]>;
  redirectUri: Scalars["String"]["input"];
  referralCode?: InputMaybe<Scalars["String"]["input"]>;
};

export type AccountMutationPasswordResetArgs = {
  gRecaptchaToken: Scalars["String"]["input"];
  newPassword1: Scalars["String"]["input"];
  newPassword2: Scalars["String"]["input"];
  token: Scalars["String"]["input"];
};

export type AccountMutationPerformOnboardingJobSuggestionArgs = {
  industry: Scalars["ID"]["input"];
  interestedJobs: Array<InputMaybe<Scalars["ID"]["input"]>>;
};

export type AccountMutationRefreshTokenArgs = {
  refreshToken?: InputMaybe<Scalars["String"]["input"]>;
};

export type AccountMutationRegisterArgs = {
  email: Scalars["String"]["input"];
  emailCallbackUrl: Scalars["String"]["input"];
  firstName: Scalars["String"]["input"];
  gRecaptchaToken: Scalars["String"]["input"];
  jobReferralCode?: InputMaybe<Scalars["String"]["input"]>;
  lastName: Scalars["String"]["input"];
  referralCode?: InputMaybe<Scalars["String"]["input"]>;
  token?: InputMaybe<Scalars["String"]["input"]>;
};

export type AccountMutationResendActivationEmailArgs = {
  email: Scalars["String"]["input"];
  emailCallbackUrl: Scalars["String"]["input"];
  gRecaptchaToken: Scalars["String"]["input"];
};

export type AccountMutationRevokeTokenArgs = {
  refreshToken?: InputMaybe<Scalars["String"]["input"]>;
};

export type AccountMutationSendPasswordResetEmailArgs = {
  email: Scalars["String"]["input"];
  emailCallbackUrl: Scalars["String"]["input"];
  gRecaptchaToken: Scalars["String"]["input"];
};

export type AccountMutationTokenAuthArgs = {
  deviceId: Scalars["String"]["input"];
  email?: InputMaybe<Scalars["String"]["input"]>;
  gRecaptchaToken: Scalars["String"]["input"];
  password: Scalars["String"]["input"];
};

export type AccountMutationVerifyArgs = {
  token: Scalars["String"]["input"];
};

export type AdminAssessmentType = {
  __typename?: "AdminAssessmentType";
  description: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  remainingQuestions: Scalars["Int"]["output"];
  results?: Maybe<Array<Maybe<OrganizationAssessmentType>>>;
  skill?: Maybe<AssessmentSkillType>;
  status: Status;
  title: Scalars["String"]["output"];
  totalEstimatedTime: Scalars["Int"]["output"];
  totalQuestions: Scalars["Int"]["output"];
};

export type AdminCanadaVisaType = {
  __typename?: "AdminCanadaVisaType";
  citizenshipDocument?: Maybe<CitizenshipDocumentFileType>;
  id: Scalars["ID"]["output"];
  nationality?: Maybe<CountryNode>;
  status: AuthAccountCanadaVisaStatusChoices;
};

export type AdminCooperationType = {
  __typename?: "AdminCooperationType";
  createdAt: Scalars["DateTime"]["output"];
  endAt?: Maybe<Scalars["DateTime"]["output"]>;
  id: Scalars["ID"]["output"];
  jobPosition?: Maybe<AdminJobPositionNode>;
  platformMessages?: Maybe<OrganizationPlatformMessageNodeConnection>;
  startAt?: Maybe<Scalars["DateTime"]["output"]>;
  status: AuthAccountOrganizationEmployeeCooperationStatusChoices;
};

export type AdminCooperationTypePlatformMessagesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type AdminJobPositionAssignmentNode = {
  __typename?: "AdminJobPositionAssignmentNode";
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["ID"]["output"];
  interviews?: Maybe<Array<Maybe<JobPositionInterviewType>>>;
  jobPosition?: Maybe<AdminJobPositionNode>;
  jobSeeker?: Maybe<JobSeekerType>;
  status: AuthAccountJobPositionAssignmentStatusChoices;
  statusHistories?: Maybe<Array<Maybe<JobPositionAssignmentStatusHistoryType>>>;
};

export type AdminJobPositionAssignmentNodeConnection = {
  __typename?: "AdminJobPositionAssignmentNodeConnection";
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<AdminJobPositionAssignmentNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** A Relay edge containing a `AdminJobPositionAssignmentNode` and its cursor. */
export type AdminJobPositionAssignmentNodeEdge = {
  __typename?: "AdminJobPositionAssignmentNodeEdge";
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  node?: Maybe<AdminJobPositionAssignmentNode>;
};

export type AdminJobPositionNode = {
  __typename?: "AdminJobPositionNode";
  ageRange?: Maybe<Array<Scalars["Int"]["output"]>>;
  assignments?: Maybe<AdminJobPositionAssignmentNodeConnection>;
  assignmentsStatusCounts?: Maybe<JobPositionAssignmentStatusCountsType>;
  benefits?: Maybe<Array<JobBenefitType>>;
  cities: CityNodeConnection;
  contractType?: Maybe<AuthAccountOrganizationJobPositionContractTypeChoices>;
  daysOff?: Maybe<Array<Maybe<AuthAccountOrganizationJobPositionDaysOffChoices>>>;
  degrees?: Maybe<Array<Maybe<AuthAccountOrganizationJobPositionDegreesChoices>>>;
  description?: Maybe<Scalars["String"]["output"]>;
  employerQuestions?: Maybe<Array<Scalars["String"]["output"]>>;
  fields?: Maybe<Array<FieldType>>;
  hiringInCanada?: Maybe<Scalars["Boolean"]["output"]>;
  id: Scalars["ID"]["output"];
  interviewSlots: Array<JobPositionInterviewSlotType>;
  isEditable?: Maybe<Scalars["Boolean"]["output"]>;
  jobRestrictions?: Maybe<Scalars["String"]["output"]>;
  languages?: Maybe<Array<Maybe<AuthAccountOrganizationJobPositionLanguagesChoices>>>;
  locationType?: Maybe<AuthAccountOrganizationJobPositionLocationTypeChoices>;
  nativeLanguages?: Maybe<Array<Maybe<AuthAccountOrganizationJobPositionNativeLanguagesChoices>>>;
  organization?: Maybe<OrganizationType>;
  otherBenefits?: Maybe<Array<Scalars["String"]["output"]>>;
  paymentTerm?: Maybe<AuthAccountOrganizationJobPositionPaymentTermChoices>;
  performanceExpectation?: Maybe<Scalars["String"]["output"]>;
  report?: Maybe<OrganizationJobPositionReportType>;
  requiredDocuments?: Maybe<Array<Scalars["String"]["output"]>>;
  salaryRange?: Maybe<Array<Scalars["Int"]["output"]>>;
  skills?: Maybe<Array<SkillType>>;
  startAt?: Maybe<Scalars["Date"]["output"]>;
  status: AuthAccountOrganizationJobPositionStatusChoices;
  title?: Maybe<Scalars["String"]["output"]>;
  vaccancy?: Maybe<Scalars["Int"]["output"]>;
  validityDate?: Maybe<Scalars["Date"]["output"]>;
  validityDays?: Maybe<Scalars["Int"]["output"]>;
  workExperienceYearsRange?: Maybe<Array<Scalars["Int"]["output"]>>;
  workingEndAt?: Maybe<Scalars["Time"]["output"]>;
  workingStartAt?: Maybe<Scalars["Time"]["output"]>;
};

export type AdminJobPositionNodeAssignmentsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  createdAt_Gte?: InputMaybe<Scalars["DateTime"]["input"]>;
  createdAt_Lte?: InputMaybe<Scalars["DateTime"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  jobPosition_Status_In?: InputMaybe<Array<InputMaybe<AuthAccountOrganizationJobPositionStatusChoices>>>;
  jobSeekerFullName?: InputMaybe<Scalars["String"]["input"]>;
  jobSeeker_Profile_Score_Gte?: InputMaybe<Scalars["Int"]["input"]>;
  jobSeeker_Profile_Score_Lte?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<AuthAccountJobPositionAssignmentOrderByChoices>;
  status_In?: InputMaybe<Array<InputMaybe<AuthAccountJobPositionAssignmentStatusChoices>>>;
};

export type AdminJobPositionNodeCitiesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  country_Code2?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  name_Icontains?: InputMaybe<Scalars["String"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  region?: InputMaybe<Scalars["ID"]["input"]>;
};

export type AdminJobPositionNodeConnection = {
  __typename?: "AdminJobPositionNodeConnection";
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<AdminJobPositionNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** A Relay edge containing a `AdminJobPositionNode` and its cursor. */
export type AdminJobPositionNodeEdge = {
  __typename?: "AdminJobPositionNodeEdge";
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  node?: Maybe<AdminJobPositionNode>;
};

export type AdminJobPositionStatusUpdateInput = {
  status: AuthAccountOrganizationJobPositionStatusChoices;
};

export type AdminJobPositionStatusUpdateMutation = {
  __typename?: "AdminJobPositionStatusUpdateMutation";
  organizationJobPosition?: Maybe<AdminJobPositionNode>;
};

export type AdminJobSeekerType = {
  __typename?: "AdminJobSeekerType";
  assessments?: Maybe<Array<Maybe<OrganizationAssessmentType>>>;
  canadaVisa?: Maybe<AdminCanadaVisaType>;
  certificateandlicenses?: Maybe<Array<JobSeekerCertificateAndLicenseType>>;
  cv?: Maybe<JobSeekerGeneratedCvType>;
  educations?: Maybe<Array<JobSeekerEducationType>>;
  email: Scalars["String"]["output"];
  firstName: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  languagecertificates?: Maybe<Array<JobSeekerLanguageCertificateType>>;
  lastName: Scalars["String"]["output"];
  profile?: Maybe<ProfileType>;
  resume?: Maybe<ResumeType>;
  workexperiences?: Maybe<Array<JobSeekerWorkExperienceType>>;
};

export type AdminJobSeekerTypeConnection = {
  __typename?: "AdminJobSeekerTypeConnection";
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<AdminJobSeekerTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** A Relay edge containing a `AdminJobSeekerType` and its cursor. */
export type AdminJobSeekerTypeEdge = {
  __typename?: "AdminJobSeekerTypeEdge";
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  node?: Maybe<AdminJobSeekerType>;
};

export type AdminMutation = {
  __typename?: "AdminMutation";
  acceptJobSuggestion?: Maybe<AcceptJobSuggestionMutation>;
  assignJob?: Maybe<AssignJobMutation>;
  hijack?: Maybe<HijackUserMutation>;
  setOrganizationContacts?: Maybe<AdminSetOrganizationContactsMutation>;
  triggerJobSuggestion?: Maybe<TriggerJobSuggestionMutation>;
  unassignJob?: Maybe<UnassignJobMutation>;
  updateJobPositionStatus?: Maybe<AdminJobPositionStatusUpdateMutation>;
  updateOrganization?: Maybe<AdminOrganizationUpdateMutation>;
  updateOrganizationStatus?: Maybe<AdminOrganizationStatusUpdateMutation>;
};

export type AdminMutationAcceptJobSuggestionArgs = {
  suggestionItemId: Scalars["ID"]["input"];
};

export type AdminMutationAssignJobArgs = {
  jobPositionId: Scalars["ID"]["input"];
  userId: Scalars["ID"]["input"];
};

export type AdminMutationHijackArgs = {
  userId: Scalars["ID"]["input"];
};

export type AdminMutationSetOrganizationContactsArgs = {
  input: Array<InputMaybe<AdminSetOrganizationContactableInput>>;
};

export type AdminMutationTriggerJobSuggestionArgs = {
  jobPositionId: Scalars["ID"]["input"];
};

export type AdminMutationUnassignJobArgs = {
  id: Scalars["ID"]["input"];
};

export type AdminMutationUpdateJobPositionStatusArgs = {
  id: Scalars["ID"]["input"];
  input: AdminJobPositionStatusUpdateInput;
};

export type AdminMutationUpdateOrganizationArgs = {
  id: Scalars["ID"]["input"];
  input: PatchOrganizationInput;
};

export type AdminMutationUpdateOrganizationStatusArgs = {
  id: Scalars["ID"]["input"];
  input: AdminOrganizationStatusUpdateInput;
};

export type AdminOrganizationEmployeeNode = {
  __typename?: "AdminOrganizationEmployeeNode";
  cooperation?: Maybe<AdminCooperationType>;
  employee?: Maybe<EmployeeType>;
  id: Scalars["ID"]["output"];
};

export type AdminOrganizationEmployeeNodeConnection = {
  __typename?: "AdminOrganizationEmployeeNodeConnection";
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<AdminOrganizationEmployeeNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** A Relay edge containing a `AdminOrganizationEmployeeNode` and its cursor. */
export type AdminOrganizationEmployeeNodeEdge = {
  __typename?: "AdminOrganizationEmployeeNodeEdge";
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  node?: Maybe<AdminOrganizationEmployeeNode>;
};

export type AdminOrganizationNode = {
  __typename?: "AdminOrganizationNode";
  about?: Maybe<Scalars["String"]["output"]>;
  assessments?: Maybe<Array<Maybe<AdminAssessmentType>>>;
  businessType?: Maybe<AuthAccountOrganizationBusinessTypeChoices>;
  city?: Maybe<CityNode>;
  communicateorganizationmethod?: Maybe<CommunicateOrganizationMethodType>;
  contacts?: Maybe<Array<Maybe<ContactType>>>;
  dnstxtrecordmethod?: Maybe<DnstxtRecordMethodType>;
  email?: Maybe<Scalars["String"]["output"]>;
  employeeCooperationStatusCounts?: Maybe<OrganizationEmployeeCooperationStatusCountsType>;
  establishedAt?: Maybe<Scalars["Date"]["output"]>;
  hasFinancialData?: Maybe<Scalars["Boolean"]["output"]>;
  id: Scalars["ID"]["output"];
  industry?: Maybe<IndustryNode>;
  jobPositionLocationTypeCounts?: Maybe<JobPositionLocationTypeCountsType>;
  jobPositions?: Maybe<AdminJobPositionNodeConnection>;
  jobPositionsStatusCounts?: Maybe<JobPositionStatusCountsType>;
  logo?: Maybe<OrganizationLogoFileType>;
  name: Scalars["String"]["output"];
  nationalNumber?: Maybe<Scalars["String"]["output"]>;
  organizationEmployees?: Maybe<AdminOrganizationEmployeeNodeConnection>;
  platformMessages?: Maybe<OrganizationPlatformMessageNodeConnection>;
  shortName?: Maybe<Scalars["String"]["output"]>;
  size?: Maybe<AuthAccountOrganizationSizeChoices>;
  status: AuthAccountOrganizationStatusChoices;
  type?: Maybe<AuthAccountOrganizationTypeChoices>;
  uploadcompanycertificatemethod?: Maybe<UploadCompanyCertificateMethodType>;
  uploadfiletowebsitemethod?: Maybe<UploadFileToWebsiteMethodType>;
  user?: Maybe<OrganizationMembershipUserType>;
};

export type AdminOrganizationNodeJobPositionsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  cities_DisplayName?: InputMaybe<Scalars["String"]["input"]>;
  cities_DisplayName_Icontains?: InputMaybe<Scalars["String"]["input"]>;
  cities_Id?: InputMaybe<Scalars["ID"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<AuthAccountOrganizationJobPositionOrderByChoices>;
  organization?: InputMaybe<Scalars["ID"]["input"]>;
  organization_Name_Icontains?: InputMaybe<Scalars["String"]["input"]>;
  startAt_Gte?: InputMaybe<Scalars["Date"]["input"]>;
  startAt_Lte?: InputMaybe<Scalars["Date"]["input"]>;
  status?: InputMaybe<AuthAccountOrganizationJobPositionStatusChoices>;
  title_Icontains?: InputMaybe<Scalars["String"]["input"]>;
};

export type AdminOrganizationNodeOrganizationEmployeesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  cooperations_JobPositionAssignment_JobPosition_Fields_Name_Icontains?: InputMaybe<Scalars["String"]["input"]>;
  cooperations_JobPositionAssignment_JobPosition_LocationType?: InputMaybe<AuthAccountOrganizationJobPositionLocationTypeChoices>;
  cooperations_Status?: InputMaybe<AuthAccountOrganizationEmployeeCooperationStatusChoices>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type AdminOrganizationNodePlatformMessagesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type AdminOrganizationNodeConnection = {
  __typename?: "AdminOrganizationNodeConnection";
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<AdminOrganizationNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** A Relay edge containing a `AdminOrganizationNode` and its cursor. */
export type AdminOrganizationNodeEdge = {
  __typename?: "AdminOrganizationNodeEdge";
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  node?: Maybe<AdminOrganizationNode>;
};

export type AdminOrganizationStatisticsType = {
  __typename?: "AdminOrganizationStatisticsType";
  blockedCount?: Maybe<Scalars["Int"]["output"]>;
  completedCount?: Maybe<Scalars["Int"]["output"]>;
  draftedCount?: Maybe<Scalars["Int"]["output"]>;
  rejectedCount?: Maybe<Scalars["Int"]["output"]>;
  submittedCount?: Maybe<Scalars["Int"]["output"]>;
  totalCount?: Maybe<Scalars["Int"]["output"]>;
  verifiedCount?: Maybe<Scalars["Int"]["output"]>;
  withJobPositionsCount?: Maybe<Scalars["Int"]["output"]>;
};

export type AdminOrganizationStatusUpdateInput = {
  status?: InputMaybe<AuthAccountOrganizationStatusChoices>;
};

export type AdminOrganizationStatusUpdateMutation = {
  __typename?: "AdminOrganizationStatusUpdateMutation";
  organization?: Maybe<OrganizationType>;
};

export type AdminOrganizationUpdateMutation = {
  __typename?: "AdminOrganizationUpdateMutation";
  organization?: Maybe<AdminOrganizationNode>;
};

export type AdminQuery = {
  __typename?: "AdminQuery";
  jobPositionAssignments?: Maybe<AdminJobPositionAssignmentNodeConnection>;
  jobPositions?: Maybe<AdminJobPositionNodeConnection>;
  jobSeekers?: Maybe<AdminJobSeekerTypeConnection>;
  jobSuggestionResult?: Maybe<JobSuggestionResultNodeConnection>;
  organizationStatistics?: Maybe<AdminOrganizationStatisticsType>;
  organizations?: Maybe<AdminOrganizationNodeConnection>;
};

export type AdminQueryJobPositionAssignmentsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  createdAt_Gte?: InputMaybe<Scalars["DateTime"]["input"]>;
  createdAt_Lte?: InputMaybe<Scalars["DateTime"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  jobPosition_Status_In?: InputMaybe<Array<InputMaybe<AuthAccountOrganizationJobPositionStatusChoices>>>;
  jobSeekerFullName?: InputMaybe<Scalars["String"]["input"]>;
  jobSeeker_Profile_Score_Gte?: InputMaybe<Scalars["Int"]["input"]>;
  jobSeeker_Profile_Score_Lte?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<AuthAccountJobPositionAssignmentOrderByChoices>;
  status_In?: InputMaybe<Array<InputMaybe<AuthAccountJobPositionAssignmentStatusChoices>>>;
};

export type AdminQueryJobPositionsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  cities_DisplayName?: InputMaybe<Scalars["String"]["input"]>;
  cities_DisplayName_Icontains?: InputMaybe<Scalars["String"]["input"]>;
  cities_Id?: InputMaybe<Scalars["ID"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<AuthAccountOrganizationJobPositionOrderByChoices>;
  organization?: InputMaybe<Scalars["ID"]["input"]>;
  organization_Name_Icontains?: InputMaybe<Scalars["String"]["input"]>;
  startAt_Gte?: InputMaybe<Scalars["Date"]["input"]>;
  startAt_Lte?: InputMaybe<Scalars["Date"]["input"]>;
  status?: InputMaybe<AuthAccountOrganizationJobPositionStatusChoices>;
  title_Icontains?: InputMaybe<Scalars["String"]["input"]>;
};

export type AdminQueryJobSeekersArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  canadaVisa_Status_In?: InputMaybe<Array<InputMaybe<AuthAccountCanadaVisaStatusChoices>>>;
  educations_Degree_In?: InputMaybe<Array<InputMaybe<AuthAccountEducationDegreeChoices>>>;
  email_Icontains?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  fluentLanguages?: InputMaybe<Array<InputMaybe<AuthAccountUserFluentLanguagesChoices>>>;
  fullName?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["Decimal"]["input"]>;
  isAssessmentsDone?: InputMaybe<Scalars["Boolean"]["input"]>;
  jobCities?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  jobType?: InputMaybe<Array<InputMaybe<AuthAccountUserJobTypeChoices>>>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<AuthAccountUserOrderByChoices>;
  profile_BirthDate_Gte?: InputMaybe<Scalars["Date"]["input"]>;
  profile_BirthDate_Lte?: InputMaybe<Scalars["Date"]["input"]>;
  profile_City_Country_Id_In?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  profile_City_Id_In?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  profile_Contactable_Contacts_Value_Icontains?: InputMaybe<Scalars["String"]["input"]>;
  profile_EmploymentStatus_In?: InputMaybe<Array<InputMaybe<AuthAccountProfileEmploymentStatusChoices>>>;
  profile_Gender_In?: InputMaybe<Array<InputMaybe<AuthAccountProfileGenderChoices>>>;
  profile_Industry_Id_In?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  profile_InterestedJobs_Id_In?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  profile_NativeLanguage_In?: InputMaybe<Array<InputMaybe<AuthAccountProfileNativeLanguageChoices>>>;
  profile_Skills_Id_In?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  referredJobPositions_Id_In?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  workexperiences_Grade_In?: InputMaybe<Array<InputMaybe<AuthAccountWorkExperienceGradeChoices>>>;
};

export type AdminQueryJobSuggestionResultArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  jobPosition_Id?: InputMaybe<Scalars["ID"]["input"]>;
  jobPosition_Organization_Id?: InputMaybe<Scalars["ID"]["input"]>;
  jobPosition_Status_In?: InputMaybe<Array<InputMaybe<AuthAccountOrganizationJobPositionStatusChoices>>>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<AuthAccountJobSuggestionResultOrderByChoices>;
};

export type AdminQueryOrganizationsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  businessType?: InputMaybe<AuthAccountOrganizationBusinessTypeChoices>;
  city?: InputMaybe<Scalars["ID"]["input"]>;
  establishedAt_Gte?: InputMaybe<Scalars["Date"]["input"]>;
  establishedAt_Lte?: InputMaybe<Scalars["Date"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  hasJobPositionFrom?: InputMaybe<Scalars["Date"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  industry?: InputMaybe<Scalars["ID"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  name_Icontains?: InputMaybe<Scalars["String"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<AuthAccountOrganizationOrderByChoices>;
  organizationEmployeeId?: InputMaybe<Scalars["String"]["input"]>;
  organizationJobPositionId?: InputMaybe<Scalars["String"]["input"]>;
  organizationPhone?: InputMaybe<Scalars["String"]["input"]>;
  shortName_Icontains?: InputMaybe<Scalars["String"]["input"]>;
  size_Gte?: InputMaybe<AuthAccountOrganizationSizeChoices>;
  size_Lte?: InputMaybe<AuthAccountOrganizationSizeChoices>;
  status?: InputMaybe<AuthAccountOrganizationStatusChoices>;
  type?: InputMaybe<AuthAccountOrganizationTypeChoices>;
  user_Email?: InputMaybe<Scalars["String"]["input"]>;
};

export type AdminSetOrganizationContactableInput = {
  organizationId: Scalars["NotEmptyID"]["input"];
  type?: InputMaybe<AuthAccountContactTypeChoices>;
  value: Scalars["String"]["input"];
};

export type AdminSetOrganizationContactsMutation = {
  __typename?: "AdminSetOrganizationContactsMutation";
  contacts?: Maybe<Array<Maybe<ContactType>>>;
};

export type AssessmentMutation = {
  __typename?: "AssessmentMutation";
  generateAssessmentToken?: Maybe<GenerateAssessmentTokenMutation>;
};

export type AssessmentMutationGenerateAssessmentTokenArgs = {
  assessmentId: Scalars["String"]["input"];
};

export type AssessmentResultQuestionType = {
  __typename?: "AssessmentResultQuestionType";
  status: QuestionStatus;
  text: Scalars["String"]["output"];
};

export type AssessmentSkillType = {
  __typename?: "AssessmentSkillType";
  description: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  title: Scalars["String"]["output"];
};

export type AssessmentType = {
  __typename?: "AssessmentType";
  description: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  remainingQuestions: Scalars["Int"]["output"];
  results?: Maybe<Array<Maybe<JobSeekerAssessmentResultType>>>;
  skill?: Maybe<AssessmentSkillType>;
  status: Status;
  title: Scalars["String"]["output"];
  totalEstimatedTime: Scalars["Int"]["output"];
  totalQuestions: Scalars["Int"]["output"];
};

export type AssignJobMutation = {
  __typename?: "AssignJobMutation";
  created?: Maybe<Scalars["Boolean"]["output"]>;
  jobPositionAssignment?: Maybe<JobPositionAssignmentNode>;
};

/** An enumeration. */
export enum AttachmentType {
  /** Platform Message Attachment Course */
  COURSE = "COURSE",
  /** Platform Message Attachment Course Result */
  COURSE_RESULT = "COURSE_RESULT",
  /** Platform Message Attachment File */
  FILE = "FILE",
}

/** An enumeration. */
export enum AuthAccountCanadaVisaStatusChoices {
  /** Citizenship */
  CITIZENSHIP = "CITIZENSHIP",
  /** Electronic Travel Authorization (eTA) */
  ELECTRONIC_TRAVEL_AUTHORIZATION = "ELECTRONIC_TRAVEL_AUTHORIZATION",
  /** International Experience Canada (IEC) */
  INTERNATIONAL_EXPERIENCE_CANADA = "INTERNATIONAL_EXPERIENCE_CANADA",
  /** No Visa */
  NO_VISA = "NO_VISA",
  /** Permanent Resident (PR) */
  PERMANENT_RESIDENT = "PERMANENT_RESIDENT",
  /** Refugee (Work Permit) */
  REFUGEE_WORK_PERMIT = "REFUGEE_WORK_PERMIT",
  /** Seasonal Agricultural Worker Program (SAWP) */
  SEASONAL_AGRICULTURAL_WORKER_PROGRAM = "SEASONAL_AGRICULTURAL_WORKER_PROGRAM",
  /** Temporary Resident (Close Work Permit) */
  TEMPORARY_RESIDENT_CLOSE_WORK_PERMIT = "TEMPORARY_RESIDENT_CLOSE_WORK_PERMIT",
  /** Temporary Resident (Open Work Permit) */
  TEMPORARY_RESIDENT_OPEN_WORK_PERMIT = "TEMPORARY_RESIDENT_OPEN_WORK_PERMIT",
  /** Temporary Resident (Study Permit) */
  TEMPORARY_RESIDENT_STUDY_PERMIT = "TEMPORARY_RESIDENT_STUDY_PERMIT",
  /** Visitor Visa */
  VISITOR_VISA = "VISITOR_VISA",
}

/** An enumeration. */
export enum AuthAccountCertificateAndLicenseStatusChoices {
  /** Drafted */
  DRAFTED = "DRAFTED",
  /** Rejected */
  REJECTED = "REJECTED",
  /** Self Verified */
  SELF_VERIFIED = "SELF_VERIFIED",
  /** Submitted */
  SUBMITTED = "SUBMITTED",
  /** Verified */
  VERIFIED = "VERIFIED",
}

/** An enumeration. */
export enum AuthAccountContactTypeChoices {
  /** Address */
  ADDRESS = "ADDRESS",
  /** LinkedIn */
  LINKEDIN = "LINKEDIN",
  /** Phone */
  PHONE = "PHONE",
  /** Website */
  WEBSITE = "WEBSITE",
  /** WhatsApp */
  WHATSAPP = "WHATSAPP",
}

/** An enumeration. */
export enum AuthAccountEducationDegreeChoices {
  /** Associate */
  ASSOCIATE = "ASSOCIATE",
  /** Bachelors */
  BACHELORS = "BACHELORS",
  /** Certificate */
  CERTIFICATE = "CERTIFICATE",
  /** Diploma */
  DIPLOMA = "DIPLOMA",
  /** Masters */
  MASTERS = "MASTERS",
  /** PhD */
  PHD = "PHD",
}

/** An enumeration. */
export enum AuthAccountEducationStatusChoices {
  /** Drafted */
  DRAFTED = "DRAFTED",
  /** Rejected */
  REJECTED = "REJECTED",
  /** Self Verified */
  SELF_VERIFIED = "SELF_VERIFIED",
  /** Submitted */
  SUBMITTED = "SUBMITTED",
  /** Verified */
  VERIFIED = "VERIFIED",
}

/** An enumeration. */
export enum AuthAccountJobPositionAssignmentOrderByChoices {
  /** Created at */
  CREATED_AT = "CREATED_AT",
  /** Created at (descending) */
  _CREATED_AT = "_CREATED_AT",
}

/** An enumeration. */
export enum AuthAccountJobPositionAssignmentStatusChoices {
  /** Accepted */
  ACCEPTED = "ACCEPTED",
  /** Awaiting Interview Date */
  AWAITING_INTERVIEW_DATE = "AWAITING_INTERVIEW_DATE",
  /** Awaiting Jobseeker Approval */
  AWAITING_JOBSEEKER_APPROVAL = "AWAITING_JOBSEEKER_APPROVAL",
  /** Interview Canceled */
  INTERVIEW_CANCELED = "INTERVIEW_CANCELED",
  /** Interview Done */
  INTERVIEW_DONE = "INTERVIEW_DONE",
  /** Interview Scheduled */
  INTERVIEW_SCHEDULED = "INTERVIEW_SCHEDULED",
  /** Not Reviewed */
  NOT_REVIEWED = "NOT_REVIEWED",
  /** Rejected */
  REJECTED = "REJECTED",
  /** Rejected By Jobseeker */
  REJECTED_BY_JOBSEEKER = "REJECTED_BY_JOBSEEKER",
}

/** An enumeration. */
export enum AuthAccountJobPositionAssignmentStatusHistoryStatusChoices {
  /** Accepted */
  ACCEPTED = "ACCEPTED",
  /** Awaiting Interview Date */
  AWAITING_INTERVIEW_DATE = "AWAITING_INTERVIEW_DATE",
  /** Awaiting Jobseeker Approval */
  AWAITING_JOBSEEKER_APPROVAL = "AWAITING_JOBSEEKER_APPROVAL",
  /** Interview Canceled */
  INTERVIEW_CANCELED = "INTERVIEW_CANCELED",
  /** Interview Done */
  INTERVIEW_DONE = "INTERVIEW_DONE",
  /** Interview Scheduled */
  INTERVIEW_SCHEDULED = "INTERVIEW_SCHEDULED",
  /** Not Reviewed */
  NOT_REVIEWED = "NOT_REVIEWED",
  /** Rejected */
  REJECTED = "REJECTED",
  /** Rejected By Jobseeker */
  REJECTED_BY_JOBSEEKER = "REJECTED_BY_JOBSEEKER",
}

/** An enumeration. */
export enum AuthAccountJobSuggestionResultOrderByChoices {
  /** Created at */
  CREATED_AT = "CREATED_AT",
  /** Created at (descending) */
  _CREATED_AT = "_CREATED_AT",
}

/** An enumeration. */
export enum AuthAccountLanguageCertificateLanguageChoices {
  /** Afrikaans */
  AF = "AF",
  /** Arabic */
  AR = "AR",
  /** Algerian Arabic */
  AR_DZ = "AR_DZ",
  /** Asturian */
  AST = "AST",
  /** Azerbaijani */
  AZ = "AZ",
  /** Belarusian */
  BE = "BE",
  /** Bulgarian */
  BG = "BG",
  /** Bengali */
  BN = "BN",
  /** Breton */
  BR = "BR",
  /** Bosnian */
  BS = "BS",
  /** Catalan */
  CA = "CA",
  /** Central Kurdish (Sorani) */
  CKB = "CKB",
  /** Czech */
  CS = "CS",
  /** Welsh */
  CY = "CY",
  /** Danish */
  DA = "DA",
  /** German */
  DE = "DE",
  /** Lower Sorbian */
  DSB = "DSB",
  /** Greek */
  EL = "EL",
  /** English */
  EN = "EN",
  /** Australian English */
  EN_AU = "EN_AU",
  /** British English */
  EN_GB = "EN_GB",
  /** Esperanto */
  EO = "EO",
  /** Spanish */
  ES = "ES",
  /** Argentinian Spanish */
  ES_AR = "ES_AR",
  /** Colombian Spanish */
  ES_CO = "ES_CO",
  /** Mexican Spanish */
  ES_MX = "ES_MX",
  /** Nicaraguan Spanish */
  ES_NI = "ES_NI",
  /** Venezuelan Spanish */
  ES_VE = "ES_VE",
  /** Estonian */
  ET = "ET",
  /** Basque */
  EU = "EU",
  /** Persian */
  FA = "FA",
  /** Finnish */
  FI = "FI",
  /** French */
  FR = "FR",
  /** Frisian */
  FY = "FY",
  /** Irish */
  GA = "GA",
  /** Scottish Gaelic */
  GD = "GD",
  /** Galician */
  GL = "GL",
  /** Hebrew */
  HE = "HE",
  /** Hindi */
  HI = "HI",
  /** Croatian */
  HR = "HR",
  /** Upper Sorbian */
  HSB = "HSB",
  /** Hungarian */
  HU = "HU",
  /** Armenian */
  HY = "HY",
  /** Interlingua */
  IA = "IA",
  /** Indonesian */
  ID = "ID",
  /** Igbo */
  IG = "IG",
  /** Ido */
  IO = "IO",
  /** Icelandic */
  IS = "IS",
  /** Italian */
  IT = "IT",
  /** Japanese */
  JA = "JA",
  /** Georgian */
  KA = "KA",
  /** Kabyle */
  KAB = "KAB",
  /** Kazakh */
  KK = "KK",
  /** Khmer */
  KM = "KM",
  /** Kannada */
  KN = "KN",
  /** Korean */
  KO = "KO",
  /** Kyrgyz */
  KY = "KY",
  /** Luxembourgish */
  LB = "LB",
  /** Lithuanian */
  LT = "LT",
  /** Latvian */
  LV = "LV",
  /** Macedonian */
  MK = "MK",
  /** Malayalam */
  ML = "ML",
  /** Mongolian */
  MN = "MN",
  /** Marathi */
  MR = "MR",
  /** Malay */
  MS = "MS",
  /** Burmese */
  MY = "MY",
  /** Norwegian Bokmål */
  NB = "NB",
  /** Nepali */
  NE = "NE",
  /** Dutch */
  NL = "NL",
  /** Norwegian Nynorsk */
  NN = "NN",
  /** Ossetic */
  OS = "OS",
  /** Punjabi */
  PA = "PA",
  /** Polish */
  PL = "PL",
  /** Portuguese */
  PT = "PT",
  /** Brazilian Portuguese */
  PT_BR = "PT_BR",
  /** Romanian */
  RO = "RO",
  /** Russian */
  RU = "RU",
  /** Slovak */
  SK = "SK",
  /** Slovenian */
  SL = "SL",
  /** Albanian */
  SQ = "SQ",
  /** Serbian */
  SR = "SR",
  /** Serbian Latin */
  SR_LATN = "SR_LATN",
  /** Swedish */
  SV = "SV",
  /** Swahili */
  SW = "SW",
  /** Tamil */
  TA = "TA",
  /** Telugu */
  TE = "TE",
  /** Tajik */
  TG = "TG",
  /** Thai */
  TH = "TH",
  /** Turkmen */
  TK = "TK",
  /** Turkish */
  TR = "TR",
  /** Tatar */
  TT = "TT",
  /** Udmurt */
  UDM = "UDM",
  /** Uyghur */
  UG = "UG",
  /** Ukrainian */
  UK = "UK",
  /** Urdu */
  UR = "UR",
  /** Uzbek */
  UZ = "UZ",
  /** Vietnamese */
  VI = "VI",
  /** Simplified Chinese */
  ZH_HANS = "ZH_HANS",
  /** Traditional Chinese */
  ZH_HANT = "ZH_HANT",
}

/** An enumeration. */
export enum AuthAccountLanguageCertificateStatusChoices {
  /** Drafted */
  DRAFTED = "DRAFTED",
  /** Rejected */
  REJECTED = "REJECTED",
  /** Self Verified */
  SELF_VERIFIED = "SELF_VERIFIED",
  /** Submitted */
  SUBMITTED = "SUBMITTED",
  /** Verified */
  VERIFIED = "VERIFIED",
}

/** An enumeration. */
export enum AuthAccountOrganizationBusinessTypeChoices {
  /** Product */
  PRODUCT = "PRODUCT",
  /** Service */
  SERVICE = "SERVICE",
  /** Software */
  SOFTWARE = "SOFTWARE",
}

/** An enumeration. */
export enum AuthAccountOrganizationEmployeeCooperationStatusChoices {
  /** Active */
  ACTIVE = "ACTIVE",
  /** Awaiting */
  AWAITING = "AWAITING",
  /** Finished */
  FINISHED = "FINISHED",
  /** Fired */
  FIRED = "FIRED",
  /** Resigned */
  RESIGNED = "RESIGNED",
  /** Suspended */
  SUSPENDED = "SUSPENDED",
}

/** An enumeration. */
export enum AuthAccountOrganizationEmployeePerformanceReportStatusChoices {
  /** Completed */
  COMPLETED = "COMPLETED",
  /** Completed By Job Seeker */
  COMPLETED_BY_JOB_SEEKER = "COMPLETED_BY_JOB_SEEKER",
  /** Completed By Organization */
  COMPLETED_BY_ORGANIZATION = "COMPLETED_BY_ORGANIZATION",
  /** Created */
  CREATED = "CREATED",
}

/** An enumeration. */
export enum AuthAccountOrganizationEmployeePerformanceReportStatusHistoryStatusChoices {
  /** Completed */
  COMPLETED = "COMPLETED",
  /** Completed By Job Seeker */
  COMPLETED_BY_JOB_SEEKER = "COMPLETED_BY_JOB_SEEKER",
  /** Completed By Organization */
  COMPLETED_BY_ORGANIZATION = "COMPLETED_BY_ORGANIZATION",
  /** Created */
  CREATED = "CREATED",
}

/** An enumeration. */
export enum AuthAccountOrganizationJobPositionContractTypeChoices {
  /** Apprenticeship */
  APPRENTICESHIP = "APPRENTICESHIP",
  /** Fix Term Contract */
  FIX_TERM_CONTRACT = "FIX_TERM_CONTRACT",
  /** Freelance */
  FREELANCE = "FREELANCE",
  /** Full Time */
  FULL_TIME = "FULL_TIME",
  /** Internship/Co-op */
  INTERNSHIP_CO_OP = "INTERNSHIP_CO_OP",
  /** Part Time */
  PART_TIME = "PART_TIME",
  /** Permanent */
  PERMANENT = "PERMANENT",
  /** Prince Edward Island */
  PRINCE_EDWARD_ISLAND = "PRINCE_EDWARD_ISLAND",
  /** Seasonal */
  SEASONAL = "SEASONAL",
}

/** An enumeration. */
export enum AuthAccountOrganizationJobPositionDaysOffChoices {
  /** Friday */
  FRIDAY = "FRIDAY",
  /** Monday */
  MONDAY = "MONDAY",
  /** Saturday */
  SATURDAY = "SATURDAY",
  /** Sunday */
  SUNDAY = "SUNDAY",
  /** Thursday */
  THURSDAY = "THURSDAY",
  /** Tuesday */
  TUESDAY = "TUESDAY",
  /** Wednesday */
  WEDNESDAY = "WEDNESDAY",
}

/** An enumeration. */
export enum AuthAccountOrganizationJobPositionDegreesChoices {
  /** Associate */
  ASSOCIATE = "ASSOCIATE",
  /** Bachelors */
  BACHELORS = "BACHELORS",
  /** Certificate */
  CERTIFICATE = "CERTIFICATE",
  /** Diploma */
  DIPLOMA = "DIPLOMA",
  /** Masters */
  MASTERS = "MASTERS",
  /** PhD */
  PHD = "PHD",
}

/** An enumeration. */
export enum AuthAccountOrganizationJobPositionLanguagesChoices {
  /** Afrikaans */
  AF = "AF",
  /** Arabic */
  AR = "AR",
  /** Algerian Arabic */
  AR_DZ = "AR_DZ",
  /** Asturian */
  AST = "AST",
  /** Azerbaijani */
  AZ = "AZ",
  /** Belarusian */
  BE = "BE",
  /** Bulgarian */
  BG = "BG",
  /** Bengali */
  BN = "BN",
  /** Breton */
  BR = "BR",
  /** Bosnian */
  BS = "BS",
  /** Catalan */
  CA = "CA",
  /** Central Kurdish (Sorani) */
  CKB = "CKB",
  /** Czech */
  CS = "CS",
  /** Welsh */
  CY = "CY",
  /** Danish */
  DA = "DA",
  /** German */
  DE = "DE",
  /** Lower Sorbian */
  DSB = "DSB",
  /** Greek */
  EL = "EL",
  /** English */
  EN = "EN",
  /** Australian English */
  EN_AU = "EN_AU",
  /** British English */
  EN_GB = "EN_GB",
  /** Esperanto */
  EO = "EO",
  /** Spanish */
  ES = "ES",
  /** Argentinian Spanish */
  ES_AR = "ES_AR",
  /** Colombian Spanish */
  ES_CO = "ES_CO",
  /** Mexican Spanish */
  ES_MX = "ES_MX",
  /** Nicaraguan Spanish */
  ES_NI = "ES_NI",
  /** Venezuelan Spanish */
  ES_VE = "ES_VE",
  /** Estonian */
  ET = "ET",
  /** Basque */
  EU = "EU",
  /** Persian */
  FA = "FA",
  /** Finnish */
  FI = "FI",
  /** French */
  FR = "FR",
  /** Frisian */
  FY = "FY",
  /** Irish */
  GA = "GA",
  /** Scottish Gaelic */
  GD = "GD",
  /** Galician */
  GL = "GL",
  /** Hebrew */
  HE = "HE",
  /** Hindi */
  HI = "HI",
  /** Croatian */
  HR = "HR",
  /** Upper Sorbian */
  HSB = "HSB",
  /** Hungarian */
  HU = "HU",
  /** Armenian */
  HY = "HY",
  /** Interlingua */
  IA = "IA",
  /** Indonesian */
  ID = "ID",
  /** Igbo */
  IG = "IG",
  /** Ido */
  IO = "IO",
  /** Icelandic */
  IS = "IS",
  /** Italian */
  IT = "IT",
  /** Japanese */
  JA = "JA",
  /** Georgian */
  KA = "KA",
  /** Kabyle */
  KAB = "KAB",
  /** Kazakh */
  KK = "KK",
  /** Khmer */
  KM = "KM",
  /** Kannada */
  KN = "KN",
  /** Korean */
  KO = "KO",
  /** Kyrgyz */
  KY = "KY",
  /** Luxembourgish */
  LB = "LB",
  /** Lithuanian */
  LT = "LT",
  /** Latvian */
  LV = "LV",
  /** Macedonian */
  MK = "MK",
  /** Malayalam */
  ML = "ML",
  /** Mongolian */
  MN = "MN",
  /** Marathi */
  MR = "MR",
  /** Malay */
  MS = "MS",
  /** Burmese */
  MY = "MY",
  /** Norwegian Bokmål */
  NB = "NB",
  /** Nepali */
  NE = "NE",
  /** Dutch */
  NL = "NL",
  /** Norwegian Nynorsk */
  NN = "NN",
  /** Ossetic */
  OS = "OS",
  /** Punjabi */
  PA = "PA",
  /** Polish */
  PL = "PL",
  /** Portuguese */
  PT = "PT",
  /** Brazilian Portuguese */
  PT_BR = "PT_BR",
  /** Romanian */
  RO = "RO",
  /** Russian */
  RU = "RU",
  /** Slovak */
  SK = "SK",
  /** Slovenian */
  SL = "SL",
  /** Albanian */
  SQ = "SQ",
  /** Serbian */
  SR = "SR",
  /** Serbian Latin */
  SR_LATN = "SR_LATN",
  /** Swedish */
  SV = "SV",
  /** Swahili */
  SW = "SW",
  /** Tamil */
  TA = "TA",
  /** Telugu */
  TE = "TE",
  /** Tajik */
  TG = "TG",
  /** Thai */
  TH = "TH",
  /** Turkmen */
  TK = "TK",
  /** Turkish */
  TR = "TR",
  /** Tatar */
  TT = "TT",
  /** Udmurt */
  UDM = "UDM",
  /** Uyghur */
  UG = "UG",
  /** Ukrainian */
  UK = "UK",
  /** Urdu */
  UR = "UR",
  /** Uzbek */
  UZ = "UZ",
  /** Vietnamese */
  VI = "VI",
  /** Simplified Chinese */
  ZH_HANS = "ZH_HANS",
  /** Traditional Chinese */
  ZH_HANT = "ZH_HANT",
}

/** An enumeration. */
export enum AuthAccountOrganizationJobPositionLocationTypeChoices {
  /** Global */
  GLOBAL = "GLOBAL",
  /** Hybrid */
  HYBRID = "HYBRID",
  /** On-site (Within a Limited Area) */
  LIMITED_AREA = "LIMITED_AREA",
  /** On the road */
  ON_THE_ROAD = "ON_THE_ROAD",
  /** On-site (Precise Location) */
  PRECISE_LOCATION = "PRECISE_LOCATION",
  /** Remote */
  REMOTE = "REMOTE",
}

/** An enumeration. */
export enum AuthAccountOrganizationJobPositionNativeLanguagesChoices {
  /** Afrikaans */
  AF = "AF",
  /** Arabic */
  AR = "AR",
  /** Algerian Arabic */
  AR_DZ = "AR_DZ",
  /** Asturian */
  AST = "AST",
  /** Azerbaijani */
  AZ = "AZ",
  /** Belarusian */
  BE = "BE",
  /** Bulgarian */
  BG = "BG",
  /** Bengali */
  BN = "BN",
  /** Breton */
  BR = "BR",
  /** Bosnian */
  BS = "BS",
  /** Catalan */
  CA = "CA",
  /** Central Kurdish (Sorani) */
  CKB = "CKB",
  /** Czech */
  CS = "CS",
  /** Welsh */
  CY = "CY",
  /** Danish */
  DA = "DA",
  /** German */
  DE = "DE",
  /** Lower Sorbian */
  DSB = "DSB",
  /** Greek */
  EL = "EL",
  /** English */
  EN = "EN",
  /** Australian English */
  EN_AU = "EN_AU",
  /** British English */
  EN_GB = "EN_GB",
  /** Esperanto */
  EO = "EO",
  /** Spanish */
  ES = "ES",
  /** Argentinian Spanish */
  ES_AR = "ES_AR",
  /** Colombian Spanish */
  ES_CO = "ES_CO",
  /** Mexican Spanish */
  ES_MX = "ES_MX",
  /** Nicaraguan Spanish */
  ES_NI = "ES_NI",
  /** Venezuelan Spanish */
  ES_VE = "ES_VE",
  /** Estonian */
  ET = "ET",
  /** Basque */
  EU = "EU",
  /** Persian */
  FA = "FA",
  /** Finnish */
  FI = "FI",
  /** French */
  FR = "FR",
  /** Frisian */
  FY = "FY",
  /** Irish */
  GA = "GA",
  /** Scottish Gaelic */
  GD = "GD",
  /** Galician */
  GL = "GL",
  /** Hebrew */
  HE = "HE",
  /** Hindi */
  HI = "HI",
  /** Croatian */
  HR = "HR",
  /** Upper Sorbian */
  HSB = "HSB",
  /** Hungarian */
  HU = "HU",
  /** Armenian */
  HY = "HY",
  /** Interlingua */
  IA = "IA",
  /** Indonesian */
  ID = "ID",
  /** Igbo */
  IG = "IG",
  /** Ido */
  IO = "IO",
  /** Icelandic */
  IS = "IS",
  /** Italian */
  IT = "IT",
  /** Japanese */
  JA = "JA",
  /** Georgian */
  KA = "KA",
  /** Kabyle */
  KAB = "KAB",
  /** Kazakh */
  KK = "KK",
  /** Khmer */
  KM = "KM",
  /** Kannada */
  KN = "KN",
  /** Korean */
  KO = "KO",
  /** Kyrgyz */
  KY = "KY",
  /** Luxembourgish */
  LB = "LB",
  /** Lithuanian */
  LT = "LT",
  /** Latvian */
  LV = "LV",
  /** Macedonian */
  MK = "MK",
  /** Malayalam */
  ML = "ML",
  /** Mongolian */
  MN = "MN",
  /** Marathi */
  MR = "MR",
  /** Malay */
  MS = "MS",
  /** Burmese */
  MY = "MY",
  /** Norwegian Bokmål */
  NB = "NB",
  /** Nepali */
  NE = "NE",
  /** Dutch */
  NL = "NL",
  /** Norwegian Nynorsk */
  NN = "NN",
  /** Ossetic */
  OS = "OS",
  /** Punjabi */
  PA = "PA",
  /** Polish */
  PL = "PL",
  /** Portuguese */
  PT = "PT",
  /** Brazilian Portuguese */
  PT_BR = "PT_BR",
  /** Romanian */
  RO = "RO",
  /** Russian */
  RU = "RU",
  /** Slovak */
  SK = "SK",
  /** Slovenian */
  SL = "SL",
  /** Albanian */
  SQ = "SQ",
  /** Serbian */
  SR = "SR",
  /** Serbian Latin */
  SR_LATN = "SR_LATN",
  /** Swedish */
  SV = "SV",
  /** Swahili */
  SW = "SW",
  /** Tamil */
  TA = "TA",
  /** Telugu */
  TE = "TE",
  /** Tajik */
  TG = "TG",
  /** Thai */
  TH = "TH",
  /** Turkmen */
  TK = "TK",
  /** Turkish */
  TR = "TR",
  /** Tatar */
  TT = "TT",
  /** Udmurt */
  UDM = "UDM",
  /** Uyghur */
  UG = "UG",
  /** Ukrainian */
  UK = "UK",
  /** Urdu */
  UR = "UR",
  /** Uzbek */
  UZ = "UZ",
  /** Vietnamese */
  VI = "VI",
  /** Simplified Chinese */
  ZH_HANS = "ZH_HANS",
  /** Traditional Chinese */
  ZH_HANT = "ZH_HANT",
}

/** An enumeration. */
export enum AuthAccountOrganizationJobPositionOrderByChoices {
  /** Created at */
  CREATED_AT = "CREATED_AT",
  /** Created at (descending) */
  _CREATED_AT = "_CREATED_AT",
}

/** An enumeration. */
export enum AuthAccountOrganizationJobPositionPaymentTermChoices {
  /** Bi-Weekly */
  BI_WEEKLY = "BI_WEEKLY",
  /** Daily */
  DAILY = "DAILY",
  /** Hourly */
  HOURLY = "HOURLY",
  /** Monthly */
  MONTHLY = "MONTHLY",
  /** Weekly */
  WEEKLY = "WEEKLY",
  /** Yearly */
  YEARLY = "YEARLY",
}

/** An enumeration. */
export enum AuthAccountOrganizationJobPositionStatusChoices {
  /** Capacity Filled */
  CAPACITY_FILLED = "CAPACITY_FILLED",
  /** Drafted */
  DRAFTED = "DRAFTED",
  /** Expired */
  EXPIRED = "EXPIRED",
  /** Published */
  PUBLISHED = "PUBLISHED",
  /** Rejected */
  REJECTED = "REJECTED",
  /** Submitted */
  SUBMITTED = "SUBMITTED",
  /** Suspended */
  SUSPENDED = "SUSPENDED",
}

/** An enumeration. */
export enum AuthAccountOrganizationOrderByChoices {
  /** Created at */
  CREATED_AT = "CREATED_AT",
  /** Created at (descending) */
  _CREATED_AT = "_CREATED_AT",
}

/** An enumeration. */
export enum AuthAccountOrganizationPlatformMessageAssigneeTypeChoices {
  /** Job Seeker */
  JOB_SEEKER = "JOB_SEEKER",
  /** Organization */
  ORGANIZATION = "ORGANIZATION",
}

/** An enumeration. */
export enum AuthAccountOrganizationPlatformMessageSourceChoices {
  /** AI */
  AI = "AI",
  /** Human */
  HUMAN = "HUMAN",
}

/** An enumeration. */
export enum AuthAccountOrganizationSizeChoices {
  /** Over 1000 */
  OVER_1000 = "OVER_1000",
  /** 1-10 */
  _1_10 = "_1_10",
  /** 10-50 */
  _10_50 = "_10_50",
  /** 50-100 */
  _50_100 = "_50_100",
  /** 100-500 */
  _100_500 = "_100_500",
  /** 500-1000 */
  _500_1000 = "_500_1000",
}

/** An enumeration. */
export enum AuthAccountOrganizationStatusChoices {
  /** Blocked */
  BLOCKED = "BLOCKED",
  /** Completed */
  COMPLETED = "COMPLETED",
  /** Drafted */
  DRAFTED = "DRAFTED",
  /** Rejected */
  REJECTED = "REJECTED",
  /** Submitted */
  SUBMITTED = "SUBMITTED",
  /** Verified */
  VERIFIED = "VERIFIED",
}

/** An enumeration. */
export enum AuthAccountOrganizationTypeChoices {
  /** Branch Office */
  BRANCH_OFFICE = "BRANCH_OFFICE",
  /** Cooperative */
  COOPERATIVE = "COOPERATIVE",
  /** General Partnership */
  GENERAL_PARTNERSHIP = "GENERAL_PARTNERSHIP",
  /** Limited Partnership */
  LIMITED_PARTNERSHIP = "LIMITED_PARTNERSHIP",
  /** Non-Profit Organization */
  NON_PROFIT_ORGANIZATION = "NON_PROFIT_ORGANIZATION",
  /** Private Corporation */
  PRIVATE_CORPORATION = "PRIVATE_CORPORATION",
  /** Public Corporation */
  PUBLIC_CORPORATION = "PUBLIC_CORPORATION",
  /** Sole Proprietorship */
  SOLE_PROPRIETORSHIP = "SOLE_PROPRIETORSHIP",
  /** Subsidiary */
  SUBSIDIARY = "SUBSIDIARY",
}

/** An enumeration. */
export enum AuthAccountProfileEmploymentStatusChoices {
  /** Employed */
  EMPLOYED = "EMPLOYED",
  /** Unemployed */
  UNEMPLOYED = "UNEMPLOYED",
}

/** An enumeration. */
export enum AuthAccountProfileEyeColorChoices {
  /** Green */
  _1CAC78 = "_1CAC78",
  /** Blue */
  _5DADEC = "_5DADEC",
  /** Brown */
  _6B4226 = "_6B4226",
  /** Hazel */
  _8E7618 = "_8E7618",
  /** Gray */
  _BEBEBE = "_BEBEBE",
  /** Amber */
  _FFBF00 = "_FFBF00",
}

/** An enumeration. */
export enum AuthAccountProfileFluentLanguagesChoices {
  /** Afrikaans */
  AF = "AF",
  /** Arabic */
  AR = "AR",
  /** Algerian Arabic */
  AR_DZ = "AR_DZ",
  /** Asturian */
  AST = "AST",
  /** Azerbaijani */
  AZ = "AZ",
  /** Belarusian */
  BE = "BE",
  /** Bulgarian */
  BG = "BG",
  /** Bengali */
  BN = "BN",
  /** Breton */
  BR = "BR",
  /** Bosnian */
  BS = "BS",
  /** Catalan */
  CA = "CA",
  /** Central Kurdish (Sorani) */
  CKB = "CKB",
  /** Czech */
  CS = "CS",
  /** Welsh */
  CY = "CY",
  /** Danish */
  DA = "DA",
  /** German */
  DE = "DE",
  /** Lower Sorbian */
  DSB = "DSB",
  /** Greek */
  EL = "EL",
  /** English */
  EN = "EN",
  /** Australian English */
  EN_AU = "EN_AU",
  /** British English */
  EN_GB = "EN_GB",
  /** Esperanto */
  EO = "EO",
  /** Spanish */
  ES = "ES",
  /** Argentinian Spanish */
  ES_AR = "ES_AR",
  /** Colombian Spanish */
  ES_CO = "ES_CO",
  /** Mexican Spanish */
  ES_MX = "ES_MX",
  /** Nicaraguan Spanish */
  ES_NI = "ES_NI",
  /** Venezuelan Spanish */
  ES_VE = "ES_VE",
  /** Estonian */
  ET = "ET",
  /** Basque */
  EU = "EU",
  /** Persian */
  FA = "FA",
  /** Finnish */
  FI = "FI",
  /** French */
  FR = "FR",
  /** Frisian */
  FY = "FY",
  /** Irish */
  GA = "GA",
  /** Scottish Gaelic */
  GD = "GD",
  /** Galician */
  GL = "GL",
  /** Hebrew */
  HE = "HE",
  /** Hindi */
  HI = "HI",
  /** Croatian */
  HR = "HR",
  /** Upper Sorbian */
  HSB = "HSB",
  /** Hungarian */
  HU = "HU",
  /** Armenian */
  HY = "HY",
  /** Interlingua */
  IA = "IA",
  /** Indonesian */
  ID = "ID",
  /** Igbo */
  IG = "IG",
  /** Ido */
  IO = "IO",
  /** Icelandic */
  IS = "IS",
  /** Italian */
  IT = "IT",
  /** Japanese */
  JA = "JA",
  /** Georgian */
  KA = "KA",
  /** Kabyle */
  KAB = "KAB",
  /** Kazakh */
  KK = "KK",
  /** Khmer */
  KM = "KM",
  /** Kannada */
  KN = "KN",
  /** Korean */
  KO = "KO",
  /** Kyrgyz */
  KY = "KY",
  /** Luxembourgish */
  LB = "LB",
  /** Lithuanian */
  LT = "LT",
  /** Latvian */
  LV = "LV",
  /** Macedonian */
  MK = "MK",
  /** Malayalam */
  ML = "ML",
  /** Mongolian */
  MN = "MN",
  /** Marathi */
  MR = "MR",
  /** Malay */
  MS = "MS",
  /** Burmese */
  MY = "MY",
  /** Norwegian Bokmål */
  NB = "NB",
  /** Nepali */
  NE = "NE",
  /** Dutch */
  NL = "NL",
  /** Norwegian Nynorsk */
  NN = "NN",
  /** Ossetic */
  OS = "OS",
  /** Punjabi */
  PA = "PA",
  /** Polish */
  PL = "PL",
  /** Portuguese */
  PT = "PT",
  /** Brazilian Portuguese */
  PT_BR = "PT_BR",
  /** Romanian */
  RO = "RO",
  /** Russian */
  RU = "RU",
  /** Slovak */
  SK = "SK",
  /** Slovenian */
  SL = "SL",
  /** Albanian */
  SQ = "SQ",
  /** Serbian */
  SR = "SR",
  /** Serbian Latin */
  SR_LATN = "SR_LATN",
  /** Swedish */
  SV = "SV",
  /** Swahili */
  SW = "SW",
  /** Tamil */
  TA = "TA",
  /** Telugu */
  TE = "TE",
  /** Tajik */
  TG = "TG",
  /** Thai */
  TH = "TH",
  /** Turkmen */
  TK = "TK",
  /** Turkish */
  TR = "TR",
  /** Tatar */
  TT = "TT",
  /** Udmurt */
  UDM = "UDM",
  /** Uyghur */
  UG = "UG",
  /** Ukrainian */
  UK = "UK",
  /** Urdu */
  UR = "UR",
  /** Uzbek */
  UZ = "UZ",
  /** Vietnamese */
  VI = "VI",
  /** Simplified Chinese */
  ZH_HANS = "ZH_HANS",
  /** Traditional Chinese */
  ZH_HANT = "ZH_HANT",
}

/** An enumeration. */
export enum AuthAccountProfileGenderChoices {
  /** Female */
  FEMALE = "FEMALE",
  /** Male */
  MALE = "MALE",
  /** Not Applicable */
  NOT_APPLICABLE = "NOT_APPLICABLE",
  /** Not Known */
  NOT_KNOWN = "NOT_KNOWN",
}

/** An enumeration. */
export enum AuthAccountProfileJobLocationTypeExcludeChoices {
  /** Global */
  GLOBAL = "GLOBAL",
  /** Hybrid */
  HYBRID = "HYBRID",
  /** On-site (Within a Limited Area) */
  LIMITED_AREA = "LIMITED_AREA",
  /** On the road */
  ON_THE_ROAD = "ON_THE_ROAD",
  /** On-site (Precise Location) */
  PRECISE_LOCATION = "PRECISE_LOCATION",
  /** Remote */
  REMOTE = "REMOTE",
}

/** An enumeration. */
export enum AuthAccountProfileJobTypeExcludeChoices {
  /** Apprenticeship */
  APPRENTICESHIP = "APPRENTICESHIP",
  /** Fix Term Contract */
  FIX_TERM_CONTRACT = "FIX_TERM_CONTRACT",
  /** Freelance */
  FREELANCE = "FREELANCE",
  /** Full Time */
  FULL_TIME = "FULL_TIME",
  /** Internship/Co-op */
  INTERNSHIP_CO_OP = "INTERNSHIP_CO_OP",
  /** Part Time */
  PART_TIME = "PART_TIME",
  /** Permanent */
  PERMANENT = "PERMANENT",
  /** Prince Edward Island */
  PRINCE_EDWARD_ISLAND = "PRINCE_EDWARD_ISLAND",
  /** Seasonal */
  SEASONAL = "SEASONAL",
}

/** An enumeration. */
export enum AuthAccountProfileNativeLanguageChoices {
  /** Afrikaans */
  AF = "AF",
  /** Arabic */
  AR = "AR",
  /** Algerian Arabic */
  AR_DZ = "AR_DZ",
  /** Asturian */
  AST = "AST",
  /** Azerbaijani */
  AZ = "AZ",
  /** Belarusian */
  BE = "BE",
  /** Bulgarian */
  BG = "BG",
  /** Bengali */
  BN = "BN",
  /** Breton */
  BR = "BR",
  /** Bosnian */
  BS = "BS",
  /** Catalan */
  CA = "CA",
  /** Central Kurdish (Sorani) */
  CKB = "CKB",
  /** Czech */
  CS = "CS",
  /** Welsh */
  CY = "CY",
  /** Danish */
  DA = "DA",
  /** German */
  DE = "DE",
  /** Lower Sorbian */
  DSB = "DSB",
  /** Greek */
  EL = "EL",
  /** English */
  EN = "EN",
  /** Australian English */
  EN_AU = "EN_AU",
  /** British English */
  EN_GB = "EN_GB",
  /** Esperanto */
  EO = "EO",
  /** Spanish */
  ES = "ES",
  /** Argentinian Spanish */
  ES_AR = "ES_AR",
  /** Colombian Spanish */
  ES_CO = "ES_CO",
  /** Mexican Spanish */
  ES_MX = "ES_MX",
  /** Nicaraguan Spanish */
  ES_NI = "ES_NI",
  /** Venezuelan Spanish */
  ES_VE = "ES_VE",
  /** Estonian */
  ET = "ET",
  /** Basque */
  EU = "EU",
  /** Persian */
  FA = "FA",
  /** Finnish */
  FI = "FI",
  /** French */
  FR = "FR",
  /** Frisian */
  FY = "FY",
  /** Irish */
  GA = "GA",
  /** Scottish Gaelic */
  GD = "GD",
  /** Galician */
  GL = "GL",
  /** Hebrew */
  HE = "HE",
  /** Hindi */
  HI = "HI",
  /** Croatian */
  HR = "HR",
  /** Upper Sorbian */
  HSB = "HSB",
  /** Hungarian */
  HU = "HU",
  /** Armenian */
  HY = "HY",
  /** Interlingua */
  IA = "IA",
  /** Indonesian */
  ID = "ID",
  /** Igbo */
  IG = "IG",
  /** Ido */
  IO = "IO",
  /** Icelandic */
  IS = "IS",
  /** Italian */
  IT = "IT",
  /** Japanese */
  JA = "JA",
  /** Georgian */
  KA = "KA",
  /** Kabyle */
  KAB = "KAB",
  /** Kazakh */
  KK = "KK",
  /** Khmer */
  KM = "KM",
  /** Kannada */
  KN = "KN",
  /** Korean */
  KO = "KO",
  /** Kyrgyz */
  KY = "KY",
  /** Luxembourgish */
  LB = "LB",
  /** Lithuanian */
  LT = "LT",
  /** Latvian */
  LV = "LV",
  /** Macedonian */
  MK = "MK",
  /** Malayalam */
  ML = "ML",
  /** Mongolian */
  MN = "MN",
  /** Marathi */
  MR = "MR",
  /** Malay */
  MS = "MS",
  /** Burmese */
  MY = "MY",
  /** Norwegian Bokmål */
  NB = "NB",
  /** Nepali */
  NE = "NE",
  /** Dutch */
  NL = "NL",
  /** Norwegian Nynorsk */
  NN = "NN",
  /** Ossetic */
  OS = "OS",
  /** Punjabi */
  PA = "PA",
  /** Polish */
  PL = "PL",
  /** Portuguese */
  PT = "PT",
  /** Brazilian Portuguese */
  PT_BR = "PT_BR",
  /** Romanian */
  RO = "RO",
  /** Russian */
  RU = "RU",
  /** Slovak */
  SK = "SK",
  /** Slovenian */
  SL = "SL",
  /** Albanian */
  SQ = "SQ",
  /** Serbian */
  SR = "SR",
  /** Serbian Latin */
  SR_LATN = "SR_LATN",
  /** Swedish */
  SV = "SV",
  /** Swahili */
  SW = "SW",
  /** Tamil */
  TA = "TA",
  /** Telugu */
  TE = "TE",
  /** Tajik */
  TG = "TG",
  /** Thai */
  TH = "TH",
  /** Turkmen */
  TK = "TK",
  /** Turkish */
  TR = "TR",
  /** Tatar */
  TT = "TT",
  /** Udmurt */
  UDM = "UDM",
  /** Uyghur */
  UG = "UG",
  /** Ukrainian */
  UK = "UK",
  /** Urdu */
  UR = "UR",
  /** Uzbek */
  UZ = "UZ",
  /** Vietnamese */
  VI = "VI",
  /** Simplified Chinese */
  ZH_HANS = "ZH_HANS",
  /** Traditional Chinese */
  ZH_HANT = "ZH_HANT",
}

/** An enumeration. */
export enum AuthAccountProfileSkinColorChoices {
  /** Very Dark */
  _3B260B = "_3B260B",
  /** Brown */
  _8D5524 = "_8D5524",
  /** Deep */
  _100C08 = "_100C08",
  /** Dark Brown */
  _60391C = "_60391C",
  /** Olive */
  _A86B33 = "_A86B33",
  /** Medium */
  _C68642 = "_C68642",
  /** Light Medium */
  _D9A377 = "_D9A377",
  /** Light */
  _E5B897 = "_E5B897",
  /** Fair */
  _F0D5B1 = "_F0D5B1",
  /** Very Fair */
  _FFDFC4 = "_FFDFC4",
}

/** An enumeration. */
export enum AuthAccountSupportTicketCategoryTypesChoices {
  /** Job Seeker */
  JOB_SEEKER = "JOB_SEEKER",
  /** Organization */
  ORGANIZATION = "ORGANIZATION",
}

/** An enumeration. */
export enum AuthAccountSupportTicketContactMethodChoices {
  /** Email */
  EMAIL = "EMAIL",
  /** Phone */
  PHONE = "PHONE",
  /** WhatsApp */
  WHATSAPP = "WHATSAPP",
}

/** An enumeration. */
export enum AuthAccountSupportTicketPriorityChoices {
  /** High */
  HIGH = "HIGH",
  /** Low */
  LOW = "LOW",
  /** Medium */
  MEDIUM = "MEDIUM",
  /** Urgent */
  URGENT = "URGENT",
}

/** An enumeration. */
export enum AuthAccountSupportTicketStatusChoices {
  /** Closed */
  CLOSED = "CLOSED",
  /** Open */
  OPEN = "OPEN",
}

/** An enumeration. */
export enum AuthAccountUserFluentLanguagesChoices {
  /** Afrikaans */
  AF = "AF",
  /** Arabic */
  AR = "AR",
  /** Algerian Arabic */
  AR_DZ = "AR_DZ",
  /** Asturian */
  AST = "AST",
  /** Azerbaijani */
  AZ = "AZ",
  /** Belarusian */
  BE = "BE",
  /** Bulgarian */
  BG = "BG",
  /** Bengali */
  BN = "BN",
  /** Breton */
  BR = "BR",
  /** Bosnian */
  BS = "BS",
  /** Catalan */
  CA = "CA",
  /** Central Kurdish (Sorani) */
  CKB = "CKB",
  /** Czech */
  CS = "CS",
  /** Welsh */
  CY = "CY",
  /** Danish */
  DA = "DA",
  /** German */
  DE = "DE",
  /** Lower Sorbian */
  DSB = "DSB",
  /** Greek */
  EL = "EL",
  /** English */
  EN = "EN",
  /** Australian English */
  EN_AU = "EN_AU",
  /** British English */
  EN_GB = "EN_GB",
  /** Esperanto */
  EO = "EO",
  /** Spanish */
  ES = "ES",
  /** Argentinian Spanish */
  ES_AR = "ES_AR",
  /** Colombian Spanish */
  ES_CO = "ES_CO",
  /** Mexican Spanish */
  ES_MX = "ES_MX",
  /** Nicaraguan Spanish */
  ES_NI = "ES_NI",
  /** Venezuelan Spanish */
  ES_VE = "ES_VE",
  /** Estonian */
  ET = "ET",
  /** Basque */
  EU = "EU",
  /** Persian */
  FA = "FA",
  /** Finnish */
  FI = "FI",
  /** French */
  FR = "FR",
  /** Frisian */
  FY = "FY",
  /** Irish */
  GA = "GA",
  /** Scottish Gaelic */
  GD = "GD",
  /** Galician */
  GL = "GL",
  /** Hebrew */
  HE = "HE",
  /** Hindi */
  HI = "HI",
  /** Croatian */
  HR = "HR",
  /** Upper Sorbian */
  HSB = "HSB",
  /** Hungarian */
  HU = "HU",
  /** Armenian */
  HY = "HY",
  /** Interlingua */
  IA = "IA",
  /** Indonesian */
  ID = "ID",
  /** Igbo */
  IG = "IG",
  /** Ido */
  IO = "IO",
  /** Icelandic */
  IS = "IS",
  /** Italian */
  IT = "IT",
  /** Japanese */
  JA = "JA",
  /** Georgian */
  KA = "KA",
  /** Kabyle */
  KAB = "KAB",
  /** Kazakh */
  KK = "KK",
  /** Khmer */
  KM = "KM",
  /** Kannada */
  KN = "KN",
  /** Korean */
  KO = "KO",
  /** Kyrgyz */
  KY = "KY",
  /** Luxembourgish */
  LB = "LB",
  /** Lithuanian */
  LT = "LT",
  /** Latvian */
  LV = "LV",
  /** Macedonian */
  MK = "MK",
  /** Malayalam */
  ML = "ML",
  /** Mongolian */
  MN = "MN",
  /** Marathi */
  MR = "MR",
  /** Malay */
  MS = "MS",
  /** Burmese */
  MY = "MY",
  /** Norwegian Bokmål */
  NB = "NB",
  /** Nepali */
  NE = "NE",
  /** Dutch */
  NL = "NL",
  /** Norwegian Nynorsk */
  NN = "NN",
  /** Ossetic */
  OS = "OS",
  /** Punjabi */
  PA = "PA",
  /** Polish */
  PL = "PL",
  /** Portuguese */
  PT = "PT",
  /** Brazilian Portuguese */
  PT_BR = "PT_BR",
  /** Romanian */
  RO = "RO",
  /** Russian */
  RU = "RU",
  /** Slovak */
  SK = "SK",
  /** Slovenian */
  SL = "SL",
  /** Albanian */
  SQ = "SQ",
  /** Serbian */
  SR = "SR",
  /** Serbian Latin */
  SR_LATN = "SR_LATN",
  /** Swedish */
  SV = "SV",
  /** Swahili */
  SW = "SW",
  /** Tamil */
  TA = "TA",
  /** Telugu */
  TE = "TE",
  /** Tajik */
  TG = "TG",
  /** Thai */
  TH = "TH",
  /** Turkmen */
  TK = "TK",
  /** Turkish */
  TR = "TR",
  /** Tatar */
  TT = "TT",
  /** Udmurt */
  UDM = "UDM",
  /** Uyghur */
  UG = "UG",
  /** Ukrainian */
  UK = "UK",
  /** Urdu */
  UR = "UR",
  /** Uzbek */
  UZ = "UZ",
  /** Vietnamese */
  VI = "VI",
  /** Simplified Chinese */
  ZH_HANS = "ZH_HANS",
  /** Traditional Chinese */
  ZH_HANT = "ZH_HANT",
}

/** An enumeration. */
export enum AuthAccountUserJobTypeChoices {
  /** Apprenticeship */
  APPRENTICESHIP = "APPRENTICESHIP",
  /** Fix Term Contract */
  FIX_TERM_CONTRACT = "FIX_TERM_CONTRACT",
  /** Freelance */
  FREELANCE = "FREELANCE",
  /** Full Time */
  FULL_TIME = "FULL_TIME",
  /** Internship/Co-op */
  INTERNSHIP_CO_OP = "INTERNSHIP_CO_OP",
  /** Part Time */
  PART_TIME = "PART_TIME",
  /** Permanent */
  PERMANENT = "PERMANENT",
  /** Prince Edward Island */
  PRINCE_EDWARD_ISLAND = "PRINCE_EDWARD_ISLAND",
  /** Seasonal */
  SEASONAL = "SEASONAL",
}

/** An enumeration. */
export enum AuthAccountUserOrderByChoices {
  /** Id */
  ID = "ID",
  /** Id (descending) */
  _ID = "_ID",
}

/** An enumeration. */
export enum AuthAccountUserTaskStatusChoices {
  /** Completed */
  COMPLETED = "COMPLETED",
  /** Failed */
  FAILED = "FAILED",
  /** In Progress */
  IN_PROGRESS = "IN_PROGRESS",
  /** Scheduled */
  SCHEDULED = "SCHEDULED",
  /** Timed-Out */
  TIMEDOUT = "TIMEDOUT",
}

/** An enumeration. */
export enum AuthAccountUserTaskTaskNameChoices {
  /** admin_perform_job_suggestion */
  ADMIN_PERFORM_JOB_SUGGESTION = "ADMIN_PERFORM_JOB_SUGGESTION",
  /** clean_revoked_tokens */
  CLEAN_REVOKED_TOKENS = "CLEAN_REVOKED_TOKENS",
  /** clean_unverified_expired_users */
  CLEAN_UNVERIFIED_EXPIRED_USERS = "CLEAN_UNVERIFIED_EXPIRED_USERS",
  /** extract_job_position_from_file_task */
  EXTRACT_JOB_POSITION_FROM_FILE_TASK = "EXTRACT_JOB_POSITION_FROM_FILE_TASK",
  /** get_certificate_text */
  GET_CERTIFICATE_TEXT = "GET_CERTIFICATE_TEXT",
  /** perform_job_suggestion */
  PERFORM_JOB_SUGGESTION = "PERFORM_JOB_SUGGESTION",
  /** render_cv_template */
  RENDER_CV_TEMPLATE = "RENDER_CV_TEMPLATE",
  /** self_verify_documents */
  SELF_VERIFY_DOCUMENTS = "SELF_VERIFY_DOCUMENTS",
  /** send_campaign_notifications */
  SEND_CAMPAIGN_NOTIFICATIONS = "SEND_CAMPAIGN_NOTIFICATIONS",
  /** send_email_async */
  SEND_EMAIL_ASYNC = "SEND_EMAIL_ASYNC",
  /** send_email_async_non_existing_user */
  SEND_EMAIL_ASYNC_NON_EXISTING_USER = "SEND_EMAIL_ASYNC_NON_EXISTING_USER",
  /** set_expiry */
  SET_EXPIRY = "SET_EXPIRY",
  /** set_job_position_cooperation_status */
  SET_JOB_POSITION_COOPERATION_STATUS = "SET_JOB_POSITION_COOPERATION_STATUS",
}

/** An enumeration. */
export enum AuthAccountWorkExperienceGradeChoices {
  /** Associate */
  ASSOCIATE = "ASSOCIATE",
  /** CEO */
  CEO = "CEO",
  /** CFO */
  CFO = "CFO",
  /** CTO */
  CTO = "CTO",
  /** Director */
  DIRECTOR = "DIRECTOR",
  /** Intern */
  INTERN = "INTERN",
  /** Junior */
  JUNIOR = "JUNIOR",
  /** Manager */
  MANAGER = "MANAGER",
  /** Mid-Level */
  MID_LEVEL = "MID_LEVEL",
  /** Senior */
  SENIOR = "SENIOR",
}

/** An enumeration. */
export enum AuthAccountWorkExperienceStatusChoices {
  /** Drafted */
  DRAFTED = "DRAFTED",
  /** Rejected */
  REJECTED = "REJECTED",
  /** Self Verified */
  SELF_VERIFIED = "SELF_VERIFIED",
  /** Submitted */
  SUBMITTED = "SUBMITTED",
  /** Verified */
  VERIFIED = "VERIFIED",
}

export type AvatarFileType = {
  __typename?: "AvatarFileType";
  file: Scalars["String"]["output"];
};

export type BaseFileModelType = {
  __typename?: "BaseFileModelType";
  file: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
};

export type BatchCreateContactInput = {
  type?: InputMaybe<AuthAccountContactTypeChoices>;
  value: Scalars["String"]["input"];
};

export type CvMutation = {
  __typename?: "CVMutation";
  generateResume?: Maybe<GenerateResumeMutation>;
};

export type CvMutationGenerateResumeArgs = {
  templateId?: InputMaybe<Scalars["NotEmptyID"]["input"]>;
};

export type CvQuery = {
  __typename?: "CVQuery";
  templates?: Maybe<CvTemplateNodeConnection>;
};

export type CvQueryTemplatesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  title_Icontains?: InputMaybe<Scalars["String"]["input"]>;
};

export type CvTemplateNode = {
  __typename?: "CVTemplateNode";
  id: Scalars["ID"]["output"];
  title: Scalars["String"]["output"];
};

export type CvTemplateNodeConnection = {
  __typename?: "CVTemplateNodeConnection";
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CvTemplateNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `CVTemplateNode` and its cursor. */
export type CvTemplateNodeEdge = {
  __typename?: "CVTemplateNodeEdge";
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  node?: Maybe<CvTemplateNode>;
};

export type CalendarEventAttendeeType = {
  __typename?: "CalendarEventAttendeeType";
  firstName?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  lastName?: Maybe<Scalars["String"]["output"]>;
};

/** An enumeration. */
export enum CalendarEventObjectType {
  job_position_interview = "job_position_interview",
}

export type CalendarEventRelatedObjectType = {
  __typename?: "CalendarEventRelatedObjectType";
  key?: Maybe<CalendarEventObjectType>;
  pk?: Maybe<Scalars["ID"]["output"]>;
};

export type CalendarEventStatusUpdateMutation = {
  __typename?: "CalendarEventStatusUpdateMutation";
  calendarEvent?: Maybe<CalendarEventType>;
};

export type CalendarEventType = {
  __typename?: "CalendarEventType";
  attendees?: Maybe<Array<Maybe<CalendarEventAttendeeType>>>;
  datetime?: Maybe<Scalars["DateTimeRangeScalar"]["output"]>;
  meetUrl?: Maybe<Scalars["String"]["output"]>;
  relatedObject?: Maybe<CalendarEventRelatedObjectType>;
  status: FlexCalendarCalendarEventStatusChoices;
};

export type CalendarQuery = {
  __typename?: "CalendarQuery";
  calendars?: Maybe<Array<Maybe<CalendarType>>>;
};

export type CalendarType = {
  __typename?: "CalendarType";
  events: Array<CalendarEventType>;
  id: Scalars["ID"]["output"];
};

export type CanadaVisaCreateOrUpdateMutation = {
  __typename?: "CanadaVisaCreateOrUpdateMutation";
  canadaVisa?: Maybe<CanadaVisaNode>;
};

export type CanadaVisaMutation = {
  __typename?: "CanadaVisaMutation";
  createOrUpdate?: Maybe<CanadaVisaCreateOrUpdateMutation>;
};

export type CanadaVisaMutationCreateOrUpdateArgs = {
  input: UpdateCanadaVisaInput;
};

export type CanadaVisaNode = {
  __typename?: "CanadaVisaNode";
  citizenshipDocument?: Maybe<CitizenshipDocumentFileType>;
  id: Scalars["ID"]["output"];
  nationality?: Maybe<CountryNode>;
  status: AuthAccountCanadaVisaStatusChoices;
};

export type CertificateAndLicenseAiType = {
  __typename?: "CertificateAndLicenseAIType";
  certifier?: Maybe<Scalars["String"]["output"]>;
  expiredAt?: Maybe<Scalars["Date"]["output"]>;
  issuedAt?: Maybe<Scalars["Date"]["output"]>;
  title?: Maybe<Scalars["String"]["output"]>;
};

export type CertificateAndLicenseAnalyseAndExtractDataMutation = {
  __typename?: "CertificateAndLicenseAnalyseAndExtractDataMutation";
  data?: Maybe<CertificateAndLicenseAiType>;
  isValid?: Maybe<Scalars["Boolean"]["output"]>;
  verificationMethodData?: Maybe<Scalars["String"]["output"]>;
};

export type CertificateAndLicenseCreateMutation = {
  __typename?: "CertificateAndLicenseCreateMutation";
  certificateAndLicense?: Maybe<CertificateAndLicenseNode>;
};

export type CertificateAndLicenseMutation = {
  __typename?: "CertificateAndLicenseMutation";
  analyseAndExtractData?: Maybe<CertificateAndLicenseAnalyseAndExtractDataMutation>;
  create?: Maybe<CertificateAndLicenseCreateMutation>;
  update?: Maybe<CertificateAndLicenseUpdateMutation>;
};

export type CertificateAndLicenseMutationAnalyseAndExtractDataArgs = {
  fileId: Scalars["NotEmptyID"]["input"];
};

export type CertificateAndLicenseMutationCreateArgs = {
  input: CreateCertificateAndLicenseAndSetVerificationMethodInput;
};

export type CertificateAndLicenseMutationUpdateArgs = {
  id: Scalars["ID"]["input"];
  input: PatchCertificateAndLicenseInput;
};

export type CertificateAndLicenseNode = {
  __typename?: "CertificateAndLicenseNode";
  allowSelfVerification: Scalars["Boolean"]["output"];
  certificateandlicenseofflineverificationmethod?: Maybe<CertificateAndLicenseOfflineVerificationMethodType>;
  certificateandlicenseonlineverificationmethod?: Maybe<CertificateAndLicenseOnlineVerificationMethodType>;
  certifier: Scalars["String"]["output"];
  expiredAt?: Maybe<Scalars["Date"]["output"]>;
  id: Scalars["ID"]["output"];
  issuedAt: Scalars["Date"]["output"];
  status: AuthAccountCertificateAndLicenseStatusChoices;
  title: Scalars["String"]["output"];
};

export type CertificateAndLicenseOfflineVerificationMethodType = {
  __typename?: "CertificateAndLicenseOfflineVerificationMethodType";
  certificateFile: CertificateFileType;
  id: Scalars["ID"]["output"];
};

export type CertificateAndLicenseOnlineVerificationMethodType = {
  __typename?: "CertificateAndLicenseOnlineVerificationMethodType";
  certificateLink: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
};

export type CertificateAndLicenseQuery = {
  __typename?: "CertificateAndLicenseQuery";
  get?: Maybe<CertificateAndLicenseNode>;
};

export type CertificateAndLicenseQueryGetArgs = {
  id: Scalars["NotEmptyID"]["input"];
};

export type CertificateAndLicenseUpdateMutation = {
  __typename?: "CertificateAndLicenseUpdateMutation";
  certificateAndLicense?: Maybe<CertificateAndLicenseNode>;
};

export type CertificateFileType = {
  __typename?: "CertificateFileType";
  file: Scalars["String"]["output"];
};

/** An enumeration. */
export enum CitiesLightCountryContinentChoices {
  /** Africa */
  AF = "AF",
  /** Antarctica */
  AN = "AN",
  /** Asia */
  AS = "AS",
  /** Europe */
  EU = "EU",
  /** North America */
  NA = "NA",
  /** Oceania */
  OC = "OC",
  /** South America */
  SA = "SA",
}

export type CitizenshipDocumentFileType = {
  __typename?: "CitizenshipDocumentFileType";
  file: Scalars["String"]["output"];
};

export type CityNode = {
  __typename?: "CityNode";
  alternateNames?: Maybe<Scalars["String"]["output"]>;
  country: CountryNode;
  displayName: Scalars["String"]["output"];
  featureCode?: Maybe<Scalars["String"]["output"]>;
  geonameId?: Maybe<Scalars["Int"]["output"]>;
  id: Scalars["ID"]["output"];
  latitude?: Maybe<Scalars["Decimal"]["output"]>;
  longitude?: Maybe<Scalars["Decimal"]["output"]>;
  name: Scalars["String"]["output"];
  nameAscii: Scalars["String"]["output"];
  population?: Maybe<Scalars["BigInt"]["output"]>;
  region?: Maybe<RegionNode>;
  searchNames: Scalars["String"]["output"];
  slug: Scalars["String"]["output"];
  subregion?: Maybe<SubRegionNode>;
  timezone?: Maybe<Scalars["String"]["output"]>;
};

export type CityNodeConnection = {
  __typename?: "CityNodeConnection";
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CityNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `CityNode` and its cursor. */
export type CityNodeEdge = {
  __typename?: "CityNodeEdge";
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  node?: Maybe<CityNode>;
};

/** An enumeration. */
export enum CommonIndustryOrderByChoices {
  /** Order */
  ORDER = "ORDER",
  /** Order (descending) */
  _ORDER = "_ORDER",
}

/** An enumeration. */
export enum CommonLanguageProficiencyTestLanguagesChoices {
  /** Afrikaans */
  AF = "AF",
  /** Arabic */
  AR = "AR",
  /** Algerian Arabic */
  AR_DZ = "AR_DZ",
  /** Asturian */
  AST = "AST",
  /** Azerbaijani */
  AZ = "AZ",
  /** Belarusian */
  BE = "BE",
  /** Bulgarian */
  BG = "BG",
  /** Bengali */
  BN = "BN",
  /** Breton */
  BR = "BR",
  /** Bosnian */
  BS = "BS",
  /** Catalan */
  CA = "CA",
  /** Central Kurdish (Sorani) */
  CKB = "CKB",
  /** Czech */
  CS = "CS",
  /** Welsh */
  CY = "CY",
  /** Danish */
  DA = "DA",
  /** German */
  DE = "DE",
  /** Lower Sorbian */
  DSB = "DSB",
  /** Greek */
  EL = "EL",
  /** English */
  EN = "EN",
  /** Australian English */
  EN_AU = "EN_AU",
  /** British English */
  EN_GB = "EN_GB",
  /** Esperanto */
  EO = "EO",
  /** Spanish */
  ES = "ES",
  /** Argentinian Spanish */
  ES_AR = "ES_AR",
  /** Colombian Spanish */
  ES_CO = "ES_CO",
  /** Mexican Spanish */
  ES_MX = "ES_MX",
  /** Nicaraguan Spanish */
  ES_NI = "ES_NI",
  /** Venezuelan Spanish */
  ES_VE = "ES_VE",
  /** Estonian */
  ET = "ET",
  /** Basque */
  EU = "EU",
  /** Persian */
  FA = "FA",
  /** Finnish */
  FI = "FI",
  /** French */
  FR = "FR",
  /** Frisian */
  FY = "FY",
  /** Irish */
  GA = "GA",
  /** Scottish Gaelic */
  GD = "GD",
  /** Galician */
  GL = "GL",
  /** Hebrew */
  HE = "HE",
  /** Hindi */
  HI = "HI",
  /** Croatian */
  HR = "HR",
  /** Upper Sorbian */
  HSB = "HSB",
  /** Hungarian */
  HU = "HU",
  /** Armenian */
  HY = "HY",
  /** Interlingua */
  IA = "IA",
  /** Indonesian */
  ID = "ID",
  /** Igbo */
  IG = "IG",
  /** Ido */
  IO = "IO",
  /** Icelandic */
  IS = "IS",
  /** Italian */
  IT = "IT",
  /** Japanese */
  JA = "JA",
  /** Georgian */
  KA = "KA",
  /** Kabyle */
  KAB = "KAB",
  /** Kazakh */
  KK = "KK",
  /** Khmer */
  KM = "KM",
  /** Kannada */
  KN = "KN",
  /** Korean */
  KO = "KO",
  /** Kyrgyz */
  KY = "KY",
  /** Luxembourgish */
  LB = "LB",
  /** Lithuanian */
  LT = "LT",
  /** Latvian */
  LV = "LV",
  /** Macedonian */
  MK = "MK",
  /** Malayalam */
  ML = "ML",
  /** Mongolian */
  MN = "MN",
  /** Marathi */
  MR = "MR",
  /** Malay */
  MS = "MS",
  /** Burmese */
  MY = "MY",
  /** Norwegian Bokmål */
  NB = "NB",
  /** Nepali */
  NE = "NE",
  /** Dutch */
  NL = "NL",
  /** Norwegian Nynorsk */
  NN = "NN",
  /** Ossetic */
  OS = "OS",
  /** Punjabi */
  PA = "PA",
  /** Polish */
  PL = "PL",
  /** Portuguese */
  PT = "PT",
  /** Brazilian Portuguese */
  PT_BR = "PT_BR",
  /** Romanian */
  RO = "RO",
  /** Russian */
  RU = "RU",
  /** Slovak */
  SK = "SK",
  /** Slovenian */
  SL = "SL",
  /** Albanian */
  SQ = "SQ",
  /** Serbian */
  SR = "SR",
  /** Serbian Latin */
  SR_LATN = "SR_LATN",
  /** Swedish */
  SV = "SV",
  /** Swahili */
  SW = "SW",
  /** Tamil */
  TA = "TA",
  /** Telugu */
  TE = "TE",
  /** Tajik */
  TG = "TG",
  /** Thai */
  TH = "TH",
  /** Turkmen */
  TK = "TK",
  /** Turkish */
  TR = "TR",
  /** Tatar */
  TT = "TT",
  /** Udmurt */
  UDM = "UDM",
  /** Uyghur */
  UG = "UG",
  /** Ukrainian */
  UK = "UK",
  /** Urdu */
  UR = "UR",
  /** Uzbek */
  UZ = "UZ",
  /** Vietnamese */
  VI = "VI",
  /** Simplified Chinese */
  ZH_HANS = "ZH_HANS",
  /** Traditional Chinese */
  ZH_HANT = "ZH_HANT",
}

export type CommonMutation = {
  __typename?: "CommonMutation";
  uploadFile?: Maybe<UploadFileMutation>;
};

export type CommonMutationUploadFileArgs = {
  file: Scalars["Upload"]["input"];
  type: UploadType;
};

export type CommonQuery = {
  __typename?: "CommonQuery";
  cities?: Maybe<CityNodeConnection>;
  countries?: Maybe<CountryNodeConnection>;
  fields?: Maybe<FieldNodeConnection>;
  industries?: Maybe<IndustryNodeConnection>;
  jobBenefits?: Maybe<JobBenefitNodeConnection>;
  jobs?: Maybe<JobNodeConnection>;
  languagesProficiencyTests?: Maybe<LanguageProficiencyTestNodeConnection>;
  regions?: Maybe<RegionNodeConnection>;
  skills?: Maybe<SkillNodeConnection>;
  universities?: Maybe<UniversityNodeConnection>;
};

export type CommonQueryCitiesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  country_Code2?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  name_Icontains?: InputMaybe<Scalars["String"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  region?: InputMaybe<Scalars["ID"]["input"]>;
};

export type CommonQueryCountriesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  name_Icontains?: InputMaybe<Scalars["String"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type CommonQueryFieldsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  name_Icontains?: InputMaybe<Scalars["String"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type CommonQueryIndustriesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<CommonIndustryOrderByChoices>;
  title_Icontains?: InputMaybe<Scalars["String"]["input"]>;
};

export type CommonQueryJobBenefitsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  name_Icontains?: InputMaybe<Scalars["String"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type CommonQueryJobsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  title_Icontains?: InputMaybe<Scalars["String"]["input"]>;
};

export type CommonQueryLanguagesProficiencyTestsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  languages_Contains?: InputMaybe<Array<InputMaybe<CommonLanguageProficiencyTestLanguagesChoices>>>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  title_Icontains?: InputMaybe<Scalars["String"]["input"]>;
};

export type CommonQueryRegionsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  country?: InputMaybe<Scalars["ID"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  name_Icontains?: InputMaybe<Scalars["String"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type CommonQuerySkillsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<CommonSkillOrderByChoices>;
  title_Icontains?: InputMaybe<Scalars["String"]["input"]>;
};

export type CommonQueryUniversitiesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  name_Icontains?: InputMaybe<Scalars["String"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

/** An enumeration. */
export enum CommonSkillOrderByChoices {
  /** Order */
  ORDER = "ORDER",
  /** Order (descending) */
  _ORDER = "_ORDER",
}

export type CommunicateOrganizationMethodInput = {
  email?: InputMaybe<Scalars["String"]["input"]>;
  phonenumber: Scalars["String"]["input"];
};

export type CommunicateOrganizationMethodType = {
  __typename?: "CommunicateOrganizationMethodType";
  email?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  phonenumber: Scalars["String"]["output"];
};

export type CommunicationMethodAiType = {
  __typename?: "CommunicationMethodAIType";
  department?: Maybe<Scalars["String"]["output"]>;
  email?: Maybe<Scalars["String"]["output"]>;
  person?: Maybe<Scalars["String"]["output"]>;
  website?: Maybe<Scalars["String"]["output"]>;
};

export type CommunicationMethodType = {
  __typename?: "CommunicationMethodType";
  degreeFile: DegreeFileType;
  department: Scalars["String"]["output"];
  email: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  person: Scalars["String"]["output"];
  website: Scalars["String"]["output"];
};

export type ContactType = {
  __typename?: "ContactType";
  id: Scalars["ID"]["output"];
  type: AuthAccountContactTypeChoices;
  value: Scalars["String"]["output"];
};

export type CountryNode = {
  __typename?: "CountryNode";
  alternateNames?: Maybe<Scalars["String"]["output"]>;
  code2?: Maybe<Scalars["String"]["output"]>;
  code3?: Maybe<Scalars["String"]["output"]>;
  continent: CitiesLightCountryContinentChoices;
  geonameId?: Maybe<Scalars["Int"]["output"]>;
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  nameAscii: Scalars["String"]["output"];
  phone?: Maybe<Scalars["String"]["output"]>;
  slug: Scalars["String"]["output"];
  tld: Scalars["String"]["output"];
};

export type CountryNodeConnection = {
  __typename?: "CountryNodeConnection";
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CountryNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `CountryNode` and its cursor. */
export type CountryNodeEdge = {
  __typename?: "CountryNodeEdge";
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  node?: Maybe<CountryNode>;
};

export type CourseNode = {
  __typename?: "CourseNode";
  description: Scalars["String"]["output"];
  externalId: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  industries: IndustryNodeConnection;
  isGeneral?: Maybe<Scalars["Boolean"]["output"]>;
  logo?: Maybe<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
  results: CourseResultTypeConnection;
};

export type CourseNodeIndustriesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<CommonIndustryOrderByChoices>;
  title_Icontains?: InputMaybe<Scalars["String"]["input"]>;
};

export type CourseNodeResultsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  status?: InputMaybe<AcademyCourseResultStatusChoices>;
};

export type CourseNodeConnection = {
  __typename?: "CourseNodeConnection";
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CourseNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** A Relay edge containing a `CourseNode` and its cursor. */
export type CourseNodeEdge = {
  __typename?: "CourseNodeEdge";
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  node?: Maybe<CourseNode>;
};

export type CourseResultCreateMutation = {
  __typename?: "CourseResultCreateMutation";
  courseResult?: Maybe<CourseResultType>;
  startUrl: Scalars["String"]["output"];
};

export type CourseResultType = {
  __typename?: "CourseResultType";
  course: CourseNode;
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["ID"]["output"];
  status: AcademyCourseResultStatusChoices;
  updatedAt: Scalars["DateTime"]["output"];
  user: UserNode;
};

export type CourseResultTypeConnection = {
  __typename?: "CourseResultTypeConnection";
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CourseResultTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** A Relay edge containing a `CourseResultType` and its cursor. */
export type CourseResultTypeEdge = {
  __typename?: "CourseResultTypeEdge";
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  node?: Maybe<CourseResultType>;
};

export type CreateCertificateAndLicenseAndSetVerificationMethodInput = {
  allowSelfVerification?: InputMaybe<Scalars["Boolean"]["input"]>;
  certificateandlicenseofflineverificationmethod?: InputMaybe<CreateCertificateAndLicenseAndSetVerificationMethodInputCreateCertificateandlicenseofflineverificationmethod>;
  certificateandlicenseonlineverificationmethod?: InputMaybe<CreateCertificateAndLicenseAndSetVerificationMethodInputCreateCertificateandlicenseonlineverificationmethod>;
  certifier: Scalars["String"]["input"];
  expiredAt?: InputMaybe<Scalars["Date"]["input"]>;
  issuedAt: Scalars["Date"]["input"];
  title: Scalars["String"]["input"];
};

export type CreateCertificateAndLicenseAndSetVerificationMethodInputCreateCertificateandlicenseofflineverificationmethod =
  {
    certificateFile: Scalars["ID"]["input"];
  };

export type CreateCertificateAndLicenseAndSetVerificationMethodInputCreateCertificateandlicenseonlineverificationmethod =
  {
    certificateLink: Scalars["String"]["input"];
  };

export type CreateEducationAndSetVerificationMethodInput = {
  allowSelfVerification?: InputMaybe<Scalars["Boolean"]["input"]>;
  city: Scalars["ID"]["input"];
  communicationmethod?: InputMaybe<CreateEducationAndSetVerificationMethodInputCreateCommunicationmethod>;
  degree: AuthAccountEducationDegreeChoices;
  end?: InputMaybe<Scalars["Date"]["input"]>;
  field: Scalars["ID"]["input"];
  ieemethod?: InputMaybe<CreateEducationAndSetVerificationMethodInputCreateIeemethod>;
  start: Scalars["Date"]["input"];
  university: Scalars["ID"]["input"];
};

export type CreateEducationAndSetVerificationMethodInputCreateCommunicationmethod = {
  degreeFile: Scalars["ID"]["input"];
  department: Scalars["String"]["input"];
  email: Scalars["String"]["input"];
  person: Scalars["String"]["input"];
  website: Scalars["String"]["input"];
};

export type CreateEducationAndSetVerificationMethodInputCreateIeemethod = {
  educationEvaluationDocument: Scalars["ID"]["input"];
  evaluator?: InputMaybe<IeeMethodEvaluator>;
};

export type CreateLanguageCertificateAndSetVerificationMethodInput = {
  allowSelfVerification?: InputMaybe<Scalars["Boolean"]["input"]>;
  expiredAt?: InputMaybe<Scalars["Date"]["input"]>;
  issuedAt: Scalars["Date"]["input"];
  language: AuthAccountLanguageCertificateLanguageChoices;
  offlinemethod?: InputMaybe<CreateLanguageCertificateAndSetVerificationMethodInputCreateOfflinemethod>;
  onlinemethod?: InputMaybe<CreateLanguageCertificateAndSetVerificationMethodInputCreateOnlinemethod>;
  test: Scalars["ID"]["input"];
  values?: InputMaybe<
    Array<InputMaybe<CreateLanguageCertificateAndSetVerificationMethodInputExactLanguageCertificateValues>>
  >;
};

export type CreateLanguageCertificateAndSetVerificationMethodInputCreateOfflinemethod = {
  certificateFile: Scalars["ID"]["input"];
};

export type CreateLanguageCertificateAndSetVerificationMethodInputCreateOnlinemethod = {
  certificateLink: Scalars["String"]["input"];
};

export type CreateLanguageCertificateAndSetVerificationMethodInputExactLanguageCertificateValues = {
  skill: Scalars["ID"]["input"];
  value: Scalars["String"]["input"];
};

export type CreateOrganizationInvitationInput = {
  email: Scalars["String"]["input"];
  organization: Scalars["ID"]["input"];
  role: Scalars["ID"]["input"];
};

export type CreateOrganizationJobPositionInput = {
  ageRange?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  benefits?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  cities?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  contractType?: InputMaybe<AuthAccountOrganizationJobPositionContractTypeChoices>;
  daysOff?: InputMaybe<Array<InputMaybe<AuthAccountOrganizationJobPositionDaysOffChoices>>>;
  degrees?: InputMaybe<Array<InputMaybe<AuthAccountOrganizationJobPositionDegreesChoices>>>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  employerQuestions?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  fields?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  hiringInCanada?: InputMaybe<Scalars["Boolean"]["input"]>;
  jobRestrictions?: InputMaybe<Scalars["String"]["input"]>;
  languages?: InputMaybe<Array<InputMaybe<AuthAccountOrganizationJobPositionLanguagesChoices>>>;
  locationType?: InputMaybe<AuthAccountOrganizationJobPositionLocationTypeChoices>;
  nativeLanguages?: InputMaybe<Array<InputMaybe<AuthAccountOrganizationJobPositionNativeLanguagesChoices>>>;
  organization: Scalars["ID"]["input"];
  otherBenefits?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  paymentTerm?: InputMaybe<AuthAccountOrganizationJobPositionPaymentTermChoices>;
  performanceExpectation?: InputMaybe<Scalars["String"]["input"]>;
  requiredDocuments?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  salaryRange?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  skills?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  startAt?: InputMaybe<Scalars["Date"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  vaccancy?: InputMaybe<Scalars["Int"]["input"]>;
  validityDays?: InputMaybe<Scalars["Int"]["input"]>;
  workExperienceYearsRange?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  workingEndAt?: InputMaybe<Scalars["Time"]["input"]>;
  workingStartAt?: InputMaybe<Scalars["Time"]["input"]>;
};

export type CreateSupportTicketInput = {
  category: Scalars["ID"]["input"];
  contactMethod: AuthAccountSupportTicketContactMethodChoices;
  contactValue: Scalars["String"]["input"];
  description: Scalars["String"]["input"];
  priority: AuthAccountSupportTicketPriorityChoices;
  title: Scalars["String"]["input"];
};

export type CreateWorkExperienceAndSetVerificationMethodInput = {
  allowSelfVerification?: InputMaybe<Scalars["Boolean"]["input"]>;
  city: Scalars["ID"]["input"];
  employerlettermethod?: InputMaybe<WorkExperienceEmployerLetterMethodInput>;
  end?: InputMaybe<Scalars["Date"]["input"]>;
  grade: AuthAccountWorkExperienceGradeChoices;
  jobTitle: Scalars["String"]["input"];
  organization: Scalars["String"]["input"];
  paystubsmethod?: InputMaybe<CreateWorkExperienceAndSetVerificationMethodInputCreatePaystubsmethod>;
  skills?: InputMaybe<Scalars["String"]["input"]>;
  start: Scalars["Date"]["input"];
};

export type CreateWorkExperienceAndSetVerificationMethodInputCreatePaystubsmethod = {
  paystubs: Scalars["ID"]["input"];
};

export type DnstxtRecordMethodType = {
  __typename?: "DNSTXTRecordMethodType";
  code: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
};

export type DegreeFileType = {
  __typename?: "DegreeFileType";
  file: Scalars["String"]["output"];
};

export type EducationAiType = {
  __typename?: "EducationAIType";
  city?: Maybe<CityNode>;
  degree?: Maybe<AuthAccountEducationDegreeChoices>;
  end?: Maybe<Scalars["Date"]["output"]>;
  field?: Maybe<FieldType>;
  start?: Maybe<Scalars["Date"]["output"]>;
  university?: Maybe<UniversityNode>;
};

export type EducationAnalyseAndExtractDataMutation = {
  __typename?: "EducationAnalyseAndExtractDataMutation";
  data?: Maybe<EducationAiType>;
  isValid?: Maybe<Scalars["Boolean"]["output"]>;
  verificationMethodData?: Maybe<EducationVerificationMethodType>;
};

export type EducationCreateMutation = {
  __typename?: "EducationCreateMutation";
  education?: Maybe<EducationNode>;
};

export type EducationEvaluationDocumentFileType = {
  __typename?: "EducationEvaluationDocumentFileType";
  file: Scalars["String"]["output"];
};

export type EducationMutation = {
  __typename?: "EducationMutation";
  analyseAndExtractData?: Maybe<EducationAnalyseAndExtractDataMutation>;
  create?: Maybe<EducationCreateMutation>;
  update?: Maybe<EducationUpdateMutation>;
};

export type EducationMutationAnalyseAndExtractDataArgs = {
  fileId: Scalars["NotEmptyID"]["input"];
  verificationType: EducationVerificationMethodUploadType;
};

export type EducationMutationCreateArgs = {
  input: CreateEducationAndSetVerificationMethodInput;
};

export type EducationMutationUpdateArgs = {
  id: Scalars["ID"]["input"];
  input: PatchEducationInput;
};

export type EducationNode = {
  __typename?: "EducationNode";
  allowSelfVerification: Scalars["Boolean"]["output"];
  city: CityNode;
  communicationmethod?: Maybe<CommunicationMethodType>;
  createdAt: Scalars["DateTime"]["output"];
  degree: AuthAccountEducationDegreeChoices;
  end?: Maybe<Scalars["Date"]["output"]>;
  field: FieldType;
  id: Scalars["ID"]["output"];
  ieemethod?: Maybe<IeeMethodType>;
  start: Scalars["Date"]["output"];
  status: AuthAccountEducationStatusChoices;
  university: UniversityNode;
  updatedAt: Scalars["DateTime"]["output"];
};

export type EducationQuery = {
  __typename?: "EducationQuery";
  get?: Maybe<EducationNode>;
};

export type EducationQueryGetArgs = {
  id: Scalars["NotEmptyID"]["input"];
};

export type EducationUpdateMutation = {
  __typename?: "EducationUpdateMutation";
  education?: Maybe<EducationNode>;
};

export type EducationVerificationMethodType = CommunicationMethodAiType | IeeMethodAiType;

/** An enumeration. */
export enum EducationVerificationMethodUploadType {
  /** Degree File */
  DEGREE = "DEGREE",
  /** Education Evaluation Document File */
  EDUCATION_EVALUATION = "EDUCATION_EVALUATION",
}

export type EmployeeType = {
  __typename?: "EmployeeType";
  assessments?: Maybe<Array<Maybe<OrganizationAssessmentType>>>;
  certificateandlicenses?: Maybe<Array<JobSeekerCertificateAndLicenseType>>;
  courses?: Maybe<CourseNodeConnection>;
  cv?: Maybe<JobSeekerGeneratedCvType>;
  educations?: Maybe<Array<JobSeekerEducationType>>;
  email: Scalars["String"]["output"];
  firstName: Scalars["String"]["output"];
  languagecertificates?: Maybe<Array<JobSeekerLanguageCertificateType>>;
  lastName: Scalars["String"]["output"];
  profile?: Maybe<JobSeekerProfileType>;
  resume?: Maybe<ResumeType>;
  workexperiences?: Maybe<Array<JobSeekerWorkExperienceType>>;
};

export type EmployeeTypeCoursesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  results_Status?: InputMaybe<AcademyCourseResultStatusChoices>;
};

export type EmployerLetterFileType = {
  __typename?: "EmployerLetterFileType";
  file: Scalars["String"]["output"];
};

export type EmployerLetterMethodType = {
  __typename?: "EmployerLetterMethodType";
  employerLetter: EmployerLetterFileType;
  employers?: Maybe<Array<Maybe<ReferenceCheckEmployerType>>>;
  id: Scalars["ID"]["output"];
};

export type EmploymentMutation = {
  __typename?: "EmploymentMutation";
  selectInterviewSlot?: Maybe<SelectInterviewSlotMutation>;
  updateJobPositionAssignmentStatus?: Maybe<JobSeekerJobPositionAssignmentStatusUpdateMutation>;
};

export type EmploymentMutationSelectInterviewSlotArgs = {
  jobPositionAssignmentId: Scalars["ID"]["input"];
  slotId: Scalars["ID"]["input"];
};

export type EmploymentMutationUpdateJobPositionAssignmentStatusArgs = {
  id: Scalars["ID"]["input"];
  input: JobSeekerJobPositionAssignmentStatusUpdateInput;
};

export type FieldNode = {
  __typename?: "FieldNode";
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
};

export type FieldNodeConnection = {
  __typename?: "FieldNodeConnection";
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<FieldNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `FieldNode` and its cursor. */
export type FieldNodeEdge = {
  __typename?: "FieldNodeEdge";
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  node?: Maybe<FieldNode>;
};

export type FieldType = {
  __typename?: "FieldType";
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
};

/** An enumeration. */
export enum FlexCalendarCalendarEventStatusChoices {
  /** Canceled */
  CANCELED = "CANCELED",
  /** Completed */
  COMPLETED = "COMPLETED",
  /** Scheduled */
  SCHEDULED = "SCHEDULED",
  /** Started */
  STARTED = "STARTED",
}

export type FullBodyImageFileType = {
  __typename?: "FullBodyImageFileType";
  file: Scalars["String"]["output"];
};

export type GenerateAssessmentTokenMutation = {
  __typename?: "GenerateAssessmentTokenMutation";
  token?: Maybe<Scalars["String"]["output"]>;
};

export type GenerateResumeMutation = {
  __typename?: "GenerateResumeMutation";
  success?: Maybe<Scalars["Boolean"]["output"]>;
};

export type GeneratedCvNode = {
  __typename?: "GeneratedCVNode";
  file: Scalars["String"]["output"];
  modified: Scalars["DateTime"]["output"];
};

export type GoogleAuth = {
  __typename?: "GoogleAuth";
  payload?: Maybe<Scalars["GenericScalar"]["output"]>;
  refreshExpiresIn?: Maybe<Scalars["Int"]["output"]>;
  refreshToken?: Maybe<Scalars["String"]["output"]>;
  token?: Maybe<Scalars["String"]["output"]>;
};

export type HijackUserMutation = {
  __typename?: "HijackUserMutation";
  payload?: Maybe<Scalars["GenericScalar"]["output"]>;
  refreshExpiresIn?: Maybe<Scalars["Int"]["output"]>;
  refreshToken?: Maybe<Scalars["String"]["output"]>;
  token?: Maybe<Scalars["String"]["output"]>;
  user?: Maybe<UserNode>;
};

export type IeeMethodAiType = {
  __typename?: "IEEMethodAIType";
  evaluator?: Maybe<IeeMethodEvaluator>;
};

/** An enumeration. */
export enum IeeMethodEvaluator {
  /** Comparative Education Service */
  CES = "CES",
  /** International Credential Assessment Service of Canada */
  ICAS = "ICAS",
  /** International Qualifications Assessment Service */
  IQAS = "IQAS",
  /** Other */
  OTHER = "OTHER",
  /** World Education Services */
  WES = "WES",
}

export type IeeMethodType = {
  __typename?: "IEEMethodType";
  educationEvaluationDocument: EducationEvaluationDocumentFileType;
  id: Scalars["ID"]["output"];
};

export type InAppNotificationMutation = {
  __typename?: "InAppNotificationMutation";
  updateReadAt?: Maybe<InAppNotificationReadAtUpdateMutation>;
};

export type InAppNotificationMutationUpdateReadAtArgs = {
  input: Array<InputMaybe<InAppNotificationReadAtUpdateInput>>;
};

export type InAppNotificationNode = {
  __typename?: "InAppNotificationNode";
  action?: Maybe<NotificationActionType>;
  body: Scalars["String"]["output"];
  created: Scalars["DateTime"]["output"];
  id: Scalars["ID"]["output"];
  modified: Scalars["DateTime"]["output"];
  readAt?: Maybe<Scalars["DateTime"]["output"]>;
  title: Scalars["String"]["output"];
};

export type InAppNotificationReadAtUpdateInput = {
  id?: InputMaybe<Scalars["ID"]["input"]>;
};

export type InAppNotificationReadAtUpdateMutation = {
  __typename?: "InAppNotificationReadAtUpdateMutation";
  inAppNotifications?: Maybe<Array<Maybe<InAppNotificationNode>>>;
};

export type IndustryNode = {
  __typename?: "IndustryNode";
  id: Scalars["ID"]["output"];
  title: Scalars["String"]["output"];
};

export type IndustryNodeConnection = {
  __typename?: "IndustryNodeConnection";
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<IndustryNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `IndustryNode` and its cursor. */
export type IndustryNodeEdge = {
  __typename?: "IndustryNodeEdge";
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  node?: Maybe<IndustryNode>;
};

export type JobBenefitNode = {
  __typename?: "JobBenefitNode";
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
};

export type JobBenefitNodeConnection = {
  __typename?: "JobBenefitNodeConnection";
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<JobBenefitNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `JobBenefitNode` and its cursor. */
export type JobBenefitNodeEdge = {
  __typename?: "JobBenefitNodeEdge";
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  node?: Maybe<JobBenefitNode>;
};

export type JobBenefitType = {
  __typename?: "JobBenefitType";
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
};

export type JobNode = {
  __typename?: "JobNode";
  id: Scalars["ID"]["output"];
  industries: IndustryNodeConnection;
  requireAppearanceData: Scalars["Boolean"]["output"];
  title: Scalars["String"]["output"];
};

export type JobNodeIndustriesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<CommonIndustryOrderByChoices>;
  title_Icontains?: InputMaybe<Scalars["String"]["input"]>;
};

export type JobNodeConnection = {
  __typename?: "JobNodeConnection";
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<JobNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `JobNode` and its cursor. */
export type JobNodeEdge = {
  __typename?: "JobNodeEdge";
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  node?: Maybe<JobNode>;
};

export type JobPositionAssignmentNode = {
  __typename?: "JobPositionAssignmentNode";
  createdAt: Scalars["DateTime"]["output"];
  hasActiveCooperationInOtherOrganizations?: Maybe<Scalars["Boolean"]["output"]>;
  id: Scalars["ID"]["output"];
  interviews?: Maybe<Array<Maybe<JobPositionInterviewType>>>;
  jobPosition?: Maybe<OrganizationJobPositionNode>;
  jobSeeker?: Maybe<JobSeekerUnionType>;
  jobSuggestionItem?: Maybe<JobSuggestionResultItemNode>;
  overQualificationReasons?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  status: AuthAccountJobPositionAssignmentStatusChoices;
  statusHistories?: Maybe<Array<Maybe<JobPositionAssignmentStatusHistoryType>>>;
};

export type JobPositionAssignmentNodeConnection = {
  __typename?: "JobPositionAssignmentNodeConnection";
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<JobPositionAssignmentNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** A Relay edge containing a `JobPositionAssignmentNode` and its cursor. */
export type JobPositionAssignmentNodeEdge = {
  __typename?: "JobPositionAssignmentNodeEdge";
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  node?: Maybe<JobPositionAssignmentNode>;
};

export type JobPositionAssignmentStatisticsType = {
  __typename?: "JobPositionAssignmentStatisticsType";
  acceptedCount?: Maybe<Scalars["Int"]["output"]>;
  awaitingInterviewDateCount?: Maybe<Scalars["Int"]["output"]>;
  awaitingJobseekerApprovalCount?: Maybe<Scalars["Int"]["output"]>;
  interviewCanceledCount?: Maybe<Scalars["Int"]["output"]>;
  interviewDoneCount?: Maybe<Scalars["Int"]["output"]>;
  interviewScheduledCount?: Maybe<Scalars["Int"]["output"]>;
  notReviewedCount?: Maybe<Scalars["Int"]["output"]>;
  rejectedByJobseekerCount?: Maybe<Scalars["Int"]["output"]>;
  rejectedCount?: Maybe<Scalars["Int"]["output"]>;
};

export type JobPositionAssignmentStatusCountType = {
  __typename?: "JobPositionAssignmentStatusCountType";
  count?: Maybe<Scalars["Int"]["output"]>;
  status?: Maybe<Scalars["String"]["output"]>;
};

export type JobPositionAssignmentStatusCountsType = {
  __typename?: "JobPositionAssignmentStatusCountsType";
  accepted?: Maybe<Scalars["Int"]["output"]>;
  awaitingInterviewDate?: Maybe<Scalars["Int"]["output"]>;
  awaitingJobseekerApproval?: Maybe<Scalars["Int"]["output"]>;
  interviewCanceled?: Maybe<Scalars["Int"]["output"]>;
  interviewDone?: Maybe<Scalars["Int"]["output"]>;
  interviewScheduled?: Maybe<Scalars["Int"]["output"]>;
  notReviewed?: Maybe<Scalars["Int"]["output"]>;
  rejected?: Maybe<Scalars["Int"]["output"]>;
  rejectedByJobseeker?: Maybe<Scalars["Int"]["output"]>;
};

export type JobPositionAssignmentStatusHistoryType = {
  __typename?: "JobPositionAssignmentStatusHistoryType";
  createdAt: Scalars["DateTime"]["output"];
  interview?: Maybe<JobPositionInterviewDetailType>;
  status: AuthAccountJobPositionAssignmentStatusHistoryStatusChoices;
};

export type JobPositionAssignmentStatusUpdateInput = {
  startAt?: InputMaybe<Scalars["Date"]["input"]>;
  status: AuthAccountJobPositionAssignmentStatusChoices;
};

export type JobPositionAssignmentStatusUpdateMutation = {
  __typename?: "JobPositionAssignmentStatusUpdateMutation";
  jobPositionAssignment?: Maybe<JobPositionAssignmentNode>;
};

export type JobPositionInterviewDetailType = {
  __typename?: "JobPositionInterviewDetailType";
  event: CalendarEventType;
  id: Scalars["ID"]["output"];
  jobPosition?: Maybe<OrganizationJobPositionNode>;
  jobPositionAssignment?: Maybe<JobPositionAssignmentNode>;
  slot?: Maybe<JobPositionInterviewSlotType>;
};

export type JobPositionInterviewSlotType = {
  __typename?: "JobPositionInterviewSlotType";
  datetime?: Maybe<Scalars["DateTimeRangeScalar"]["output"]>;
  id: Scalars["ID"]["output"];
  isAvailable?: Maybe<Scalars["Boolean"]["output"]>;
};

export type JobPositionInterviewType = {
  __typename?: "JobPositionInterviewType";
  event: CalendarEventType;
  id: Scalars["ID"]["output"];
  slot?: Maybe<JobPositionInterviewSlotType>;
};

export type JobPositionLocationTypeCountsType = {
  __typename?: "JobPositionLocationTypeCountsType";
  globalCount?: Maybe<Scalars["Int"]["output"]>;
  hybridCount?: Maybe<Scalars["Int"]["output"]>;
  limitedAreaCount?: Maybe<Scalars["Int"]["output"]>;
  onTheRoadCount?: Maybe<Scalars["Int"]["output"]>;
  preciseLocationCount?: Maybe<Scalars["Int"]["output"]>;
  remoteCount?: Maybe<Scalars["Int"]["output"]>;
};

export type JobPositionStatusCountsType = {
  __typename?: "JobPositionStatusCountsType";
  capacityFilled?: Maybe<Scalars["Int"]["output"]>;
  drafted?: Maybe<Scalars["Int"]["output"]>;
  expired?: Maybe<Scalars["Int"]["output"]>;
  published?: Maybe<Scalars["Int"]["output"]>;
  rejected?: Maybe<Scalars["Int"]["output"]>;
  submitted?: Maybe<Scalars["Int"]["output"]>;
  suspended?: Maybe<Scalars["Int"]["output"]>;
};

export type JobSeekerAssessmentResultType = {
  __typename?: "JobSeekerAssessmentResultType";
  evaluation?: Maybe<JobSeekerEvaluationType>;
  question: AssessmentResultQuestionType;
};

export type JobSeekerCertificateAndLicenseType = {
  __typename?: "JobSeekerCertificateAndLicenseType";
  certificateandlicenseofflineverificationmethod?: Maybe<CertificateAndLicenseOfflineVerificationMethodType>;
  certificateandlicenseonlineverificationmethod?: Maybe<CertificateAndLicenseOnlineVerificationMethodType>;
  certifier: Scalars["String"]["output"];
  expiredAt?: Maybe<Scalars["Date"]["output"]>;
  id: Scalars["ID"]["output"];
  issuedAt: Scalars["Date"]["output"];
  status: AuthAccountCertificateAndLicenseStatusChoices;
  title: Scalars["String"]["output"];
};

export type JobSeekerCooperationType = {
  __typename?: "JobSeekerCooperationType";
  createdAt: Scalars["DateTime"]["output"];
  employerSatisfactionRate?: Maybe<Scalars["Float"]["output"]>;
  endAt?: Maybe<Scalars["DateTime"]["output"]>;
  id: Scalars["ID"]["output"];
  jobPosition?: Maybe<JobSeekerJobPositionType>;
  performanceReport?: Maybe<OrganizationEmployeePerformanceReportNodeConnection>;
  platformMessages?: Maybe<OrganizationPlatformMessageNodeConnection>;
  startAt?: Maybe<Scalars["DateTime"]["output"]>;
  status: AuthAccountOrganizationEmployeeCooperationStatusChoices;
};

export type JobSeekerCooperationTypePerformanceReportArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  date_Gte?: InputMaybe<Scalars["Date"]["input"]>;
  date_Lte?: InputMaybe<Scalars["Date"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type JobSeekerCooperationTypePlatformMessagesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type JobSeekerEducationType = {
  __typename?: "JobSeekerEducationType";
  city: CityNode;
  communicationmethod?: Maybe<CommunicationMethodType>;
  degree: AuthAccountEducationDegreeChoices;
  end?: Maybe<Scalars["Date"]["output"]>;
  field: FieldType;
  id: Scalars["ID"]["output"];
  ieemethod?: Maybe<IeeMethodType>;
  start: Scalars["Date"]["output"];
  status: AuthAccountEducationStatusChoices;
  university: UniversityNode;
};

export type JobSeekerEmployeeType = {
  __typename?: "JobSeekerEmployeeType";
  cooperations?: Maybe<JobSeekerCooperationType>;
  id: Scalars["ID"]["output"];
  organization?: Maybe<JobSeekerOrganizationType>;
};

export type JobSeekerEvaluationType = {
  __typename?: "JobSeekerEvaluationType";
  score: Score;
  userFeedback: Scalars["String"]["output"];
};

export type JobSeekerGeneratedCvType = {
  __typename?: "JobSeekerGeneratedCVType";
  aboutMe?: Maybe<Scalars["String"]["output"]>;
  file: Scalars["String"]["output"];
  modified: Scalars["DateTime"]["output"];
};

export type JobSeekerJobPositionAssignmentNode = {
  __typename?: "JobSeekerJobPositionAssignmentNode";
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["ID"]["output"];
  interviews?: Maybe<Array<Maybe<JobPositionInterviewType>>>;
  jobPosition?: Maybe<JobSeekerJobPositionType>;
  status: AuthAccountJobPositionAssignmentStatusChoices;
  statusHistories?: Maybe<Array<Maybe<JobPositionAssignmentStatusHistoryType>>>;
};

export type JobSeekerJobPositionAssignmentNodeConnection = {
  __typename?: "JobSeekerJobPositionAssignmentNodeConnection";
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<JobSeekerJobPositionAssignmentNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** A Relay edge containing a `JobSeekerJobPositionAssignmentNode` and its cursor. */
export type JobSeekerJobPositionAssignmentNodeEdge = {
  __typename?: "JobSeekerJobPositionAssignmentNodeEdge";
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  node?: Maybe<JobSeekerJobPositionAssignmentNode>;
};

export type JobSeekerJobPositionAssignmentStatusUpdateInput = {
  status: AuthAccountJobPositionAssignmentStatusChoices;
};

export type JobSeekerJobPositionAssignmentStatusUpdateMutation = {
  __typename?: "JobSeekerJobPositionAssignmentStatusUpdateMutation";
  jobPositionAssignment?: Maybe<JobSeekerJobPositionAssignmentNode>;
};

export type JobSeekerJobPositionType = {
  __typename?: "JobSeekerJobPositionType";
  ageRange?: Maybe<Array<Scalars["Int"]["output"]>>;
  benefits?: Maybe<Array<JobBenefitType>>;
  cities: CityNodeConnection;
  contractType?: Maybe<AuthAccountOrganizationJobPositionContractTypeChoices>;
  daysOff?: Maybe<Array<Maybe<AuthAccountOrganizationJobPositionDaysOffChoices>>>;
  degrees?: Maybe<Array<Maybe<AuthAccountOrganizationJobPositionDegreesChoices>>>;
  description?: Maybe<Scalars["String"]["output"]>;
  employerQuestions?: Maybe<Array<Scalars["String"]["output"]>>;
  fields?: Maybe<Array<FieldType>>;
  hiringInCanada?: Maybe<Scalars["Boolean"]["output"]>;
  id: Scalars["ID"]["output"];
  interviewSlots: Array<JobPositionInterviewSlotType>;
  jobRestrictions?: Maybe<Scalars["String"]["output"]>;
  languages?: Maybe<Array<Maybe<AuthAccountOrganizationJobPositionLanguagesChoices>>>;
  locationType?: Maybe<AuthAccountOrganizationJobPositionLocationTypeChoices>;
  nativeLanguages?: Maybe<Array<Maybe<AuthAccountOrganizationJobPositionNativeLanguagesChoices>>>;
  organization?: Maybe<OrganizationType>;
  otherBenefits?: Maybe<Array<Scalars["String"]["output"]>>;
  paymentTerm?: Maybe<AuthAccountOrganizationJobPositionPaymentTermChoices>;
  performanceExpectation?: Maybe<Scalars["String"]["output"]>;
  report?: Maybe<OrganizationJobPositionReportType>;
  requiredDocuments?: Maybe<Array<Scalars["String"]["output"]>>;
  salaryRange?: Maybe<Array<Scalars["Int"]["output"]>>;
  skills?: Maybe<Array<SkillType>>;
  startAt?: Maybe<Scalars["Date"]["output"]>;
  status: AuthAccountOrganizationJobPositionStatusChoices;
  title?: Maybe<Scalars["String"]["output"]>;
  vaccancy?: Maybe<Scalars["Int"]["output"]>;
  validityDate?: Maybe<Scalars["Date"]["output"]>;
  validityDays?: Maybe<Scalars["Int"]["output"]>;
  workExperienceYearsRange?: Maybe<Array<Scalars["Int"]["output"]>>;
  workingEndAt?: Maybe<Scalars["Time"]["output"]>;
  workingStartAt?: Maybe<Scalars["Time"]["output"]>;
};

export type JobSeekerJobPositionTypeCitiesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  country_Code2?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  name_Icontains?: InputMaybe<Scalars["String"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  region?: InputMaybe<Scalars["ID"]["input"]>;
};

export type JobSeekerLanguageCertificateType = {
  __typename?: "JobSeekerLanguageCertificateType";
  allowSelfVerification: Scalars["Boolean"]["output"];
  expiredAt?: Maybe<Scalars["Date"]["output"]>;
  id: Scalars["ID"]["output"];
  issuedAt: Scalars["Date"]["output"];
  language: AuthAccountLanguageCertificateLanguageChoices;
  offlinemethod?: Maybe<LanguageCertificateOfflineVerificationMethodType>;
  onlinemethod?: Maybe<LanguageCertificateOnlineVerificationMethodType>;
  status: AuthAccountLanguageCertificateStatusChoices;
  test?: Maybe<LanguageProficiencyTestNode>;
  values?: Maybe<Array<LanguageCertificateValueNode>>;
};

export type JobSeekerOrganizationType = {
  __typename?: "JobSeekerOrganizationType";
  about?: Maybe<Scalars["String"]["output"]>;
  businessType?: Maybe<AuthAccountOrganizationBusinessTypeChoices>;
  city?: Maybe<CityNode>;
  contacts?: Maybe<Array<Maybe<ContactType>>>;
  establishedAt?: Maybe<Scalars["Date"]["output"]>;
  id: Scalars["ID"]["output"];
  industry?: Maybe<IndustryNode>;
  logo?: Maybe<OrganizationLogoFileType>;
  name: Scalars["String"]["output"];
  shortName?: Maybe<Scalars["String"]["output"]>;
  size?: Maybe<AuthAccountOrganizationSizeChoices>;
};

export type JobSeekerPrimitiveType = {
  __typename?: "JobSeekerPrimitiveType";
  firstName: Scalars["String"]["output"];
  lastName: Scalars["String"]["output"];
  profile?: Maybe<JobSeekerProfilePrimitiveType>;
  workexperiences?: Maybe<Array<Maybe<JobSeekerWorkExperienceType>>>;
};

export type JobSeekerProfilePrimitiveType = {
  __typename?: "JobSeekerProfilePrimitiveType";
  avatar?: Maybe<AvatarFileType>;
  score: Scalars["Int"]["output"];
};

export type JobSeekerProfileType = {
  __typename?: "JobSeekerProfileType";
  avatar?: Maybe<AvatarFileType>;
  /** Must be at least 18 years ago and at most 65 years ago */
  birthDate?: Maybe<Scalars["Date"]["output"]>;
  city?: Maybe<CityNode>;
  contacts?: Maybe<Array<Maybe<ContactType>>>;
  fullBodyImage?: Maybe<FullBodyImageFileType>;
  gender?: Maybe<AuthAccountProfileGenderChoices>;
  score: Scalars["Int"]["output"];
};

export type JobSeekerType = {
  __typename?: "JobSeekerType";
  assessments?: Maybe<Array<Maybe<OrganizationAssessmentType>>>;
  certificateandlicenses?: Maybe<Array<JobSeekerCertificateAndLicenseType>>;
  cv?: Maybe<JobSeekerGeneratedCvType>;
  educations?: Maybe<Array<JobSeekerEducationType>>;
  email: Scalars["String"]["output"];
  firstName: Scalars["String"]["output"];
  languagecertificates?: Maybe<Array<JobSeekerLanguageCertificateType>>;
  lastName: Scalars["String"]["output"];
  profile?: Maybe<JobSeekerProfileType>;
  resume?: Maybe<ResumeType>;
  workexperiences?: Maybe<Array<JobSeekerWorkExperienceType>>;
};

export type JobSeekerUnionType = JobSeekerPrimitiveType | JobSeekerType;

export type JobSeekerWorkExperienceType = {
  __typename?: "JobSeekerWorkExperienceType";
  city: CityNode;
  employerlettermethod?: Maybe<EmployerLetterMethodType>;
  end?: Maybe<Scalars["Date"]["output"]>;
  grade: AuthAccountWorkExperienceGradeChoices;
  id: Scalars["ID"]["output"];
  jobTitle: Scalars["String"]["output"];
  organization: Scalars["String"]["output"];
  paystubsmethod?: Maybe<PaystubsMethodType>;
  start: Scalars["Date"]["output"];
  status: AuthAccountWorkExperienceStatusChoices;
};

export type JobSuggestionResultItemNode = {
  __typename?: "JobSuggestionResultItemNode";
  confidenceLevel: Scalars["Int"]["output"];
  considerations?: Maybe<Array<Scalars["String"]["output"]>>;
  experienceMatch: Scalars["Int"]["output"];
  id: Scalars["ID"]["output"];
  isAssigned?: Maybe<Scalars["Boolean"]["output"]>;
  jobPositionAssignment?: Maybe<JobPositionAssignmentNode>;
  matchExplanation?: Maybe<Scalars["String"]["output"]>;
  matchScore?: Maybe<Scalars["Int"]["output"]>;
  overQualificationReasons: Array<Scalars["String"]["output"]>;
  recommendation: Scalars["Int"]["output"];
  seniorityMatch: Scalars["Int"]["output"];
  skillMatch: Scalars["Int"]["output"];
  strengths?: Maybe<Array<Scalars["String"]["output"]>>;
  user?: Maybe<UserNode>;
};

export type JobSuggestionResultItemNodeConnection = {
  __typename?: "JobSuggestionResultItemNodeConnection";
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<JobSuggestionResultItemNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `JobSuggestionResultItemNode` and its cursor. */
export type JobSuggestionResultItemNodeEdge = {
  __typename?: "JobSuggestionResultItemNodeEdge";
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  node?: Maybe<JobSuggestionResultItemNode>;
};

export type JobSuggestionResultNode = {
  __typename?: "JobSuggestionResultNode";
  id: Scalars["ID"]["output"];
  items?: Maybe<JobSuggestionResultItemNodeConnection>;
  jobPosition?: Maybe<OrganizationJobPositionNode>;
};

export type JobSuggestionResultNodeItemsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type JobSuggestionResultNodeConnection = {
  __typename?: "JobSuggestionResultNodeConnection";
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<JobSuggestionResultNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** A Relay edge containing a `JobSuggestionResultNode` and its cursor. */
export type JobSuggestionResultNodeEdge = {
  __typename?: "JobSuggestionResultNodeEdge";
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  node?: Maybe<JobSuggestionResultNode>;
};

export type LanguageCertificateAiType = {
  __typename?: "LanguageCertificateAIType";
  expiredAt?: Maybe<Scalars["Date"]["output"]>;
  issuedAt?: Maybe<Scalars["Date"]["output"]>;
  language?: Maybe<AuthAccountLanguageCertificateLanguageChoices>;
  test?: Maybe<LanguageCertificateTestAiType>;
  values?: Maybe<Array<Maybe<LanguageCertificateValueAiType>>>;
};

export type LanguageCertificateAnalyseAndExtractDataMutation = {
  __typename?: "LanguageCertificateAnalyseAndExtractDataMutation";
  data?: Maybe<LanguageCertificateAiType>;
  isValid?: Maybe<Scalars["Boolean"]["output"]>;
  verificationMethodData?: Maybe<Scalars["String"]["output"]>;
};

export type LanguageCertificateCreateMutation = {
  __typename?: "LanguageCertificateCreateMutation";
  languageCertificate?: Maybe<LanguageCertificateNode>;
};

export type LanguageCertificateFileType = {
  __typename?: "LanguageCertificateFileType";
  file: Scalars["String"]["output"];
};

export type LanguageCertificateMutation = {
  __typename?: "LanguageCertificateMutation";
  analyseAndExtractData?: Maybe<LanguageCertificateAnalyseAndExtractDataMutation>;
  create?: Maybe<LanguageCertificateCreateMutation>;
  update?: Maybe<LanguageCertificateUpdateMutation>;
};

export type LanguageCertificateMutationAnalyseAndExtractDataArgs = {
  fileId: Scalars["NotEmptyID"]["input"];
};

export type LanguageCertificateMutationCreateArgs = {
  input: CreateLanguageCertificateAndSetVerificationMethodInput;
};

export type LanguageCertificateMutationUpdateArgs = {
  id: Scalars["ID"]["input"];
  input: PatchLanguageCertificateInput;
};

export type LanguageCertificateNode = {
  __typename?: "LanguageCertificateNode";
  allowSelfVerification: Scalars["Boolean"]["output"];
  expiredAt?: Maybe<Scalars["Date"]["output"]>;
  id: Scalars["ID"]["output"];
  issuedAt: Scalars["Date"]["output"];
  language: AuthAccountLanguageCertificateLanguageChoices;
  offlinemethod?: Maybe<LanguageCertificateOfflineVerificationMethodType>;
  onlinemethod?: Maybe<LanguageCertificateOnlineVerificationMethodType>;
  status: AuthAccountLanguageCertificateStatusChoices;
  test?: Maybe<LanguageProficiencyTestNode>;
  values?: Maybe<Array<Maybe<LanguageCertificateValueNode>>>;
};

export type LanguageCertificateOfflineVerificationMethodType = {
  __typename?: "LanguageCertificateOfflineVerificationMethodType";
  certificateFile: LanguageCertificateFileType;
  id: Scalars["ID"]["output"];
};

export type LanguageCertificateOnlineVerificationMethodType = {
  __typename?: "LanguageCertificateOnlineVerificationMethodType";
  certificateLink: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
};

export type LanguageCertificateQuery = {
  __typename?: "LanguageCertificateQuery";
  get?: Maybe<LanguageCertificateNode>;
};

export type LanguageCertificateQueryGetArgs = {
  id: Scalars["NotEmptyID"]["input"];
};

export type LanguageCertificateTestAiType = {
  __typename?: "LanguageCertificateTestAIType";
  id?: Maybe<Scalars["ID"]["output"]>;
  title?: Maybe<Scalars["String"]["output"]>;
};

export type LanguageCertificateUpdateMutation = {
  __typename?: "LanguageCertificateUpdateMutation";
  languageCertificate?: Maybe<LanguageCertificateNode>;
};

export type LanguageCertificateValueAiType = {
  __typename?: "LanguageCertificateValueAIType";
  skill?: Maybe<LanguageCertificateValueSkillAiType>;
  value?: Maybe<Scalars["String"]["output"]>;
};

export type LanguageCertificateValueNode = {
  __typename?: "LanguageCertificateValueNode";
  id: Scalars["ID"]["output"];
  skill?: Maybe<LanguageProficiencySkillNode>;
  value: Scalars["String"]["output"];
};

export type LanguageCertificateValueSkillAiType = {
  __typename?: "LanguageCertificateValueSkillAIType";
  id?: Maybe<Scalars["ID"]["output"]>;
  skillName?: Maybe<Scalars["String"]["output"]>;
  slug?: Maybe<Scalars["String"]["output"]>;
};

export type LanguageProficiencySkillNode = {
  __typename?: "LanguageProficiencySkillNode";
  id: Scalars["ID"]["output"];
  skillName: Scalars["String"]["output"];
  slug: Scalars["String"]["output"];
  /** A list of kwargs dictionaries */
  validatorKwargs: Scalars["JSONString"]["output"];
};

export type LanguageProficiencySkillNodeConnection = {
  __typename?: "LanguageProficiencySkillNodeConnection";
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<LanguageProficiencySkillNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `LanguageProficiencySkillNode` and its cursor. */
export type LanguageProficiencySkillNodeEdge = {
  __typename?: "LanguageProficiencySkillNodeEdge";
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  node?: Maybe<LanguageProficiencySkillNode>;
};

export type LanguageProficiencyTestNode = {
  __typename?: "LanguageProficiencyTestNode";
  id: Scalars["ID"]["output"];
  languages?: Maybe<Array<Maybe<CommonLanguageProficiencyTestLanguagesChoices>>>;
  skills?: Maybe<LanguageProficiencySkillNodeConnection>;
  title: Scalars["String"]["output"];
};

export type LanguageProficiencyTestNodeSkillsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type LanguageProficiencyTestNodeConnection = {
  __typename?: "LanguageProficiencyTestNodeConnection";
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<LanguageProficiencyTestNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `LanguageProficiencyTestNode` and its cursor. */
export type LanguageProficiencyTestNodeEdge = {
  __typename?: "LanguageProficiencyTestNodeEdge";
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  node?: Maybe<LanguageProficiencyTestNode>;
};

export type LinkedInAuth = {
  __typename?: "LinkedInAuth";
  payload?: Maybe<Scalars["GenericScalar"]["output"]>;
  refreshExpiresIn?: Maybe<Scalars["Int"]["output"]>;
  refreshToken?: Maybe<Scalars["String"]["output"]>;
  token?: Maybe<Scalars["String"]["output"]>;
};

export type Mutation = {
  __typename?: "Mutation";
  academy: AcademyMutation;
  account: AccountMutation;
  assessment: AssessmentMutation;
  common: CommonMutation;
  cv: CvMutation;
  notification: NotificationMutation;
};

export type NotificationActionDetailType = NotificationRelatedObjectType | NotificationSimpleLinkType;

export type NotificationActionType = {
  __typename?: "NotificationActionType";
  detail?: Maybe<NotificationActionDetailType>;
  text: Scalars["String"]["output"];
};

export type NotificationMutation = {
  __typename?: "NotificationMutation";
  inAppNotification?: Maybe<InAppNotificationMutation>;
  pushNotification?: Maybe<PushNotificationMutation>;
};

/** An enumeration. */
export enum NotificationRelatedObjectSlugEnum {
  JOB_POSITION = "JOB_POSITION",
  JOB_POSITION_ASSIGNMENT = "JOB_POSITION_ASSIGNMENT",
  ORGANIZATION_EMPLOYEE_COOPERATION = "ORGANIZATION_EMPLOYEE_COOPERATION",
}

export type NotificationRelatedObjectType = {
  __typename?: "NotificationRelatedObjectType";
  relatedObjectId: Scalars["Int"]["output"];
  relatedObjectSlug?: Maybe<NotificationRelatedObjectSlugEnum>;
};

export type NotificationSimpleLinkType = {
  __typename?: "NotificationSimpleLinkType";
  id: Scalars["ID"]["output"];
  link: Scalars["String"]["output"];
};

export type ObtainJsonWebToken = {
  __typename?: "ObtainJSONWebToken";
  payload?: Maybe<Scalars["GenericScalar"]["output"]>;
  refreshExpiresIn?: Maybe<Scalars["Int"]["output"]>;
  refreshToken?: Maybe<Scalars["String"]["output"]>;
  success?: Maybe<Scalars["Boolean"]["output"]>;
  token?: Maybe<Scalars["String"]["output"]>;
  unarchiving?: Maybe<Scalars["Boolean"]["output"]>;
  user?: Maybe<UserNode>;
};

export type OnboardingJobSuggestionOutputType = {
  __typename?: "OnboardingJobSuggestionOutputType";
  jobSuggestions?: Maybe<Array<Maybe<OnboardingJobSuggestionType>>>;
  text?: Maybe<Scalars["String"]["output"]>;
};

export type OnboardingJobSuggestionType = {
  __typename?: "OnboardingJobSuggestionType";
  companyName?: Maybe<Scalars["String"]["output"]>;
  country?: Maybe<Scalars["String"]["output"]>;
  salaryRange?: Maybe<Array<Maybe<Scalars["Int"]["output"]>>>;
  shortDescription?: Maybe<Scalars["String"]["output"]>;
  title?: Maybe<Scalars["String"]["output"]>;
};

export type OrganizationAssessmentResultType = {
  __typename?: "OrganizationAssessmentResultType";
  evaluation?: Maybe<OrganizationEvaluationType>;
  question: AssessmentResultQuestionType;
};

export type OrganizationAssessmentType = {
  __typename?: "OrganizationAssessmentType";
  description: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  remainingQuestions: Scalars["Int"]["output"];
  results?: Maybe<Array<Maybe<OrganizationAssessmentResultType>>>;
  skill?: Maybe<AssessmentSkillType>;
  status: Status;
  title: Scalars["String"]["output"];
  totalEstimatedTime: Scalars["Int"]["output"];
  totalQuestions: Scalars["Int"]["output"];
};

export type OrganizationCertificateFileType = {
  __typename?: "OrganizationCertificateFileType";
  file: Scalars["String"]["output"];
};

export type OrganizationEmployeeCooperationStatusCountsType = {
  __typename?: "OrganizationEmployeeCooperationStatusCountsType";
  active?: Maybe<Scalars["Int"]["output"]>;
  awaiting?: Maybe<Scalars["Int"]["output"]>;
  finished?: Maybe<Scalars["Int"]["output"]>;
  fired?: Maybe<Scalars["Int"]["output"]>;
  resigned?: Maybe<Scalars["Int"]["output"]>;
  suspended?: Maybe<Scalars["Int"]["output"]>;
};

export type OrganizationEmployeeCooperationStatusUpdateInput = {
  status: AuthAccountOrganizationEmployeeCooperationStatusChoices;
};

export type OrganizationEmployeeCooperationStatusUpdateMutation = {
  __typename?: "OrganizationEmployeeCooperationStatusUpdateMutation";
  organizationEmployeeCooperation?: Maybe<OrganizationEmployeeCooperationType>;
};

export type OrganizationEmployeeCooperationType = {
  __typename?: "OrganizationEmployeeCooperationType";
  createdAt: Scalars["DateTime"]["output"];
  employerSatisfactionRate?: Maybe<Scalars["Float"]["output"]>;
  endAt?: Maybe<Scalars["DateTime"]["output"]>;
  id: Scalars["ID"]["output"];
  jobPosition?: Maybe<OrganizationJobPositionNode>;
  performanceReport?: Maybe<OrganizationEmployeePerformanceReportNodeConnection>;
  platformMessages?: Maybe<OrganizationPlatformMessageNodeConnection>;
  startAt?: Maybe<Scalars["DateTime"]["output"]>;
  status: AuthAccountOrganizationEmployeeCooperationStatusChoices;
};

export type OrganizationEmployeeCooperationTypePerformanceReportArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  date_Gte?: InputMaybe<Scalars["Date"]["input"]>;
  date_Lte?: InputMaybe<Scalars["Date"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type OrganizationEmployeeCooperationTypePlatformMessagesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type OrganizationEmployeeNode = {
  __typename?: "OrganizationEmployeeNode";
  cooperations?: Maybe<Array<Maybe<OrganizationEmployeeCooperationType>>>;
  employee?: Maybe<EmployeeType>;
  id: Scalars["ID"]["output"];
};

export type OrganizationEmployeeNodeConnection = {
  __typename?: "OrganizationEmployeeNodeConnection";
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<OrganizationEmployeeNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** A Relay edge containing a `OrganizationEmployeeNode` and its cursor. */
export type OrganizationEmployeeNodeEdge = {
  __typename?: "OrganizationEmployeeNodeEdge";
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  node?: Maybe<OrganizationEmployeeNode>;
};

export type OrganizationEmployeePerformanceReportNode = {
  __typename?: "OrganizationEmployeePerformanceReportNode";
  date?: Maybe<Scalars["Date"]["output"]>;
  id: Scalars["ID"]["output"];
  reportSummary?: Maybe<Scalars["String"]["output"]>;
  reportText: Scalars["String"]["output"];
  status: AuthAccountOrganizationEmployeePerformanceReportStatusChoices;
  statusHistories: Array<OrganizationEmployeePerformanceReportStatusHistoryType>;
  title?: Maybe<Scalars["String"]["output"]>;
};

export type OrganizationEmployeePerformanceReportNodeConnection = {
  __typename?: "OrganizationEmployeePerformanceReportNodeConnection";
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<OrganizationEmployeePerformanceReportNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** A Relay edge containing a `OrganizationEmployeePerformanceReportNode` and its cursor. */
export type OrganizationEmployeePerformanceReportNodeEdge = {
  __typename?: "OrganizationEmployeePerformanceReportNodeEdge";
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  node?: Maybe<OrganizationEmployeePerformanceReportNode>;
};

export type OrganizationEmployeePerformanceReportStatusHistoryType = {
  __typename?: "OrganizationEmployeePerformanceReportStatusHistoryType";
  createdAt: Scalars["DateTime"]["output"];
  status: AuthAccountOrganizationEmployeePerformanceReportStatusHistoryStatusChoices;
};

export type OrganizationEmployeeQuery = {
  __typename?: "OrganizationEmployeeQuery";
  get?: Maybe<OrganizationEmployeeNode>;
  list?: Maybe<OrganizationEmployeeNodeConnection>;
};

export type OrganizationEmployeeQueryGetArgs = {
  id: Scalars["NotEmptyID"]["input"];
};

export type OrganizationEmployeeQueryListArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  cooperationStartAt?: InputMaybe<Scalars["Date"]["input"]>;
  cooperationStartAtGte?: InputMaybe<Scalars["Date"]["input"]>;
  cooperationStartAtLte?: InputMaybe<Scalars["Date"]["input"]>;
  cooperations_Status?: InputMaybe<AuthAccountOrganizationEmployeeCooperationStatusChoices>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  fullName?: InputMaybe<Scalars["String"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  organization?: InputMaybe<Scalars["ID"]["input"]>;
  user_JobPositionAssignments_JobPosition?: InputMaybe<Scalars["ID"]["input"]>;
};

export type OrganizationEvaluationType = {
  __typename?: "OrganizationEvaluationType";
  negativePoints: Array<Maybe<Scalars["String"]["output"]>>;
  positivePoints: Array<Maybe<Scalars["String"]["output"]>>;
  score: Score;
  scoreReasoning: Scalars["String"]["output"];
  scoreValue?: Maybe<Scalars["Decimal"]["output"]>;
  userFeedback: Scalars["String"]["output"];
};

export type OrganizationExtractJobPosition = {
  __typename?: "OrganizationExtractJobPosition";
  jobPosition?: Maybe<OrganizationJobPositionNode>;
  taskScheduled?: Maybe<Scalars["Boolean"]["output"]>;
};

export type OrganizationInvitationType = {
  __typename?: "OrganizationInvitationType";
  createdAt: Scalars["DateTime"]["output"];
  createdBy: UserNode;
  email: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  organization?: Maybe<OrganizationType>;
  role: RoleType;
};

export type OrganizationInviteMutation = {
  __typename?: "OrganizationInviteMutation";
  organizationInvitation?: Maybe<OrganizationInvitationType>;
};

export type OrganizationJobPositionCreateMutation = {
  __typename?: "OrganizationJobPositionCreateMutation";
  organizationJobPosition?: Maybe<OrganizationJobPositionNode>;
};

export type OrganizationJobPositionInterviewSlotSetMutation = {
  __typename?: "OrganizationJobPositionInterviewSlotSetMutation";
  overlappingInterviews?: Maybe<Array<Maybe<JobPositionInterviewType>>>;
};

export type OrganizationJobPositionNode = {
  __typename?: "OrganizationJobPositionNode";
  ageRange?: Maybe<Array<Scalars["Int"]["output"]>>;
  assignments?: Maybe<JobPositionAssignmentNodeConnection>;
  benefits?: Maybe<Array<JobBenefitType>>;
  cities: CityNodeConnection;
  contractType?: Maybe<AuthAccountOrganizationJobPositionContractTypeChoices>;
  daysOff?: Maybe<Array<Maybe<AuthAccountOrganizationJobPositionDaysOffChoices>>>;
  degrees?: Maybe<Array<Maybe<AuthAccountOrganizationJobPositionDegreesChoices>>>;
  description?: Maybe<Scalars["String"]["output"]>;
  employerQuestions?: Maybe<Array<Scalars["String"]["output"]>>;
  fields?: Maybe<Array<FieldType>>;
  hiringInCanada?: Maybe<Scalars["Boolean"]["output"]>;
  id: Scalars["ID"]["output"];
  interviewSlots: Array<JobPositionInterviewSlotType>;
  isEditable?: Maybe<Scalars["Boolean"]["output"]>;
  jobRestrictions?: Maybe<Scalars["String"]["output"]>;
  languages?: Maybe<Array<Maybe<AuthAccountOrganizationJobPositionLanguagesChoices>>>;
  locationType?: Maybe<AuthAccountOrganizationJobPositionLocationTypeChoices>;
  nativeLanguages?: Maybe<Array<Maybe<AuthAccountOrganizationJobPositionNativeLanguagesChoices>>>;
  organization?: Maybe<OrganizationType>;
  otherBenefits?: Maybe<Array<Scalars["String"]["output"]>>;
  paymentTerm?: Maybe<AuthAccountOrganizationJobPositionPaymentTermChoices>;
  performanceExpectation?: Maybe<Scalars["String"]["output"]>;
  report?: Maybe<OrganizationJobPositionReportType>;
  requiredDocuments?: Maybe<Array<Scalars["String"]["output"]>>;
  salaryRange?: Maybe<Array<Scalars["Int"]["output"]>>;
  skills?: Maybe<Array<SkillType>>;
  startAt?: Maybe<Scalars["Date"]["output"]>;
  status: AuthAccountOrganizationJobPositionStatusChoices;
  title?: Maybe<Scalars["String"]["output"]>;
  vaccancy?: Maybe<Scalars["Int"]["output"]>;
  validityDate?: Maybe<Scalars["Date"]["output"]>;
  validityDays?: Maybe<Scalars["Int"]["output"]>;
  workExperienceYearsRange?: Maybe<Array<Scalars["Int"]["output"]>>;
  workingEndAt?: Maybe<Scalars["Time"]["output"]>;
  workingStartAt?: Maybe<Scalars["Time"]["output"]>;
};

export type OrganizationJobPositionNodeAssignmentsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  createdAt_Gte?: InputMaybe<Scalars["DateTime"]["input"]>;
  createdAt_Lte?: InputMaybe<Scalars["DateTime"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  jobPosition_Status_In?: InputMaybe<Array<InputMaybe<AuthAccountOrganizationJobPositionStatusChoices>>>;
  jobSeekerFullName?: InputMaybe<Scalars["String"]["input"]>;
  jobSeeker_Profile_Score_Gte?: InputMaybe<Scalars["Int"]["input"]>;
  jobSeeker_Profile_Score_Lte?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<AuthAccountJobPositionAssignmentOrderByChoices>;
  status_In?: InputMaybe<Array<InputMaybe<AuthAccountJobPositionAssignmentStatusChoices>>>;
};

export type OrganizationJobPositionNodeCitiesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  country_Code2?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  name_Icontains?: InputMaybe<Scalars["String"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  region?: InputMaybe<Scalars["ID"]["input"]>;
};

export type OrganizationJobPositionNodeConnection = {
  __typename?: "OrganizationJobPositionNodeConnection";
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<OrganizationJobPositionNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** A Relay edge containing a `OrganizationJobPositionNode` and its cursor. */
export type OrganizationJobPositionNodeEdge = {
  __typename?: "OrganizationJobPositionNodeEdge";
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  node?: Maybe<OrganizationJobPositionNode>;
};

export type OrganizationJobPositionQuery = {
  __typename?: "OrganizationJobPositionQuery";
  get?: Maybe<OrganizationJobPositionNode>;
  list?: Maybe<OrganizationJobPositionNodeConnection>;
};

export type OrganizationJobPositionQueryGetArgs = {
  id: Scalars["NotEmptyID"]["input"];
};

export type OrganizationJobPositionQueryListArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  assignments_Status?: InputMaybe<AuthAccountJobPositionAssignmentStatusChoices>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  cities_DisplayName?: InputMaybe<Scalars["String"]["input"]>;
  cities_DisplayName_Icontains?: InputMaybe<Scalars["String"]["input"]>;
  cities_Id?: InputMaybe<Scalars["ID"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  organization?: InputMaybe<Scalars["ID"]["input"]>;
  startAt_Gte?: InputMaybe<Scalars["Date"]["input"]>;
  startAt_Lte?: InputMaybe<Scalars["Date"]["input"]>;
  status?: InputMaybe<AuthAccountOrganizationJobPositionStatusChoices>;
  title_Icontains?: InputMaybe<Scalars["String"]["input"]>;
};

export type OrganizationJobPositionReportType = {
  __typename?: "OrganizationJobPositionReportType";
  assignmentStatusCounts?: Maybe<Array<Maybe<JobPositionAssignmentStatusCountType>>>;
};

export type OrganizationJobPositionStatusUpdateInput = {
  status: AuthAccountOrganizationJobPositionStatusChoices;
};

export type OrganizationJobPositionStatusUpdateMutation = {
  __typename?: "OrganizationJobPositionStatusUpdateMutation";
  organizationJobPosition?: Maybe<OrganizationJobPositionNode>;
};

export type OrganizationJobPositionUpdateMutation = {
  __typename?: "OrganizationJobPositionUpdateMutation";
  organizationJobPosition?: Maybe<OrganizationJobPositionNode>;
};

export type OrganizationLogoFileType = {
  __typename?: "OrganizationLogoFileType";
  file: Scalars["String"]["output"];
};

export type OrganizationMembershipType = {
  __typename?: "OrganizationMembershipType";
  accessedRoles?: Maybe<Array<Maybe<RoleType>>>;
  organization?: Maybe<OrganizationType>;
  role: RoleType;
  user?: Maybe<OrganizationMembershipUserType>;
};

export type OrganizationMembershipUserType = {
  __typename?: "OrganizationMembershipUserType";
  email: Scalars["String"]["output"];
  firstName: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  lastName: Scalars["String"]["output"];
};

export type OrganizationMutation = {
  __typename?: "OrganizationMutation";
  createJobPosition?: Maybe<OrganizationJobPositionCreateMutation>;
  createJobPositionFromFile?: Maybe<OrganizationExtractJobPosition>;
  invite?: Maybe<OrganizationInviteMutation>;
  register?: Maybe<RegisterOrganization>;
  setContacts?: Maybe<SetOrganizationContactsMutation>;
  setJobPositionInterviewSlot?: Maybe<OrganizationJobPositionInterviewSlotSetMutation>;
  setVerificationMethod?: Maybe<OrganizationSetVerificationMethodMutation>;
  update?: Maybe<OrganizationUpdateMutation>;
  updateCalendarEventStatus?: Maybe<CalendarEventStatusUpdateMutation>;
  updateEmployeeCooperationStatus?: Maybe<OrganizationEmployeeCooperationStatusUpdateMutation>;
  updateJobPosition?: Maybe<OrganizationJobPositionUpdateMutation>;
  updateJobPositionAssignmentStatus?: Maybe<JobPositionAssignmentStatusUpdateMutation>;
  updateJobPositionStatus?: Maybe<OrganizationJobPositionStatusUpdateMutation>;
  updatePlatformMessageReadAt?: Maybe<OrganizationPlatformMessageReadAtUpdateMutation>;
  verify?: Maybe<OrganizationVerify>;
};

export type OrganizationMutationCreateJobPositionArgs = {
  input: CreateOrganizationJobPositionInput;
};

export type OrganizationMutationCreateJobPositionFromFileArgs = {
  file: Scalars["Upload"]["input"];
  organizationId: Scalars["ID"]["input"];
};

export type OrganizationMutationInviteArgs = {
  input: CreateOrganizationInvitationInput;
};

export type OrganizationMutationRegisterArgs = {
  email: Scalars["String"]["input"];
  emailCallbackUrl: Scalars["String"]["input"];
  gRecaptchaToken: Scalars["String"]["input"];
  name: Scalars["String"]["input"];
  website: Scalars["String"]["input"];
};

export type OrganizationMutationSetContactsArgs = {
  input: Array<InputMaybe<SetOrganizationContactableInput>>;
};

export type OrganizationMutationSetJobPositionInterviewSlotArgs = {
  jobPositionId: Scalars["ID"]["input"];
  slots: Array<InputMaybe<Scalars["DateTimeRangeScalar"]["input"]>>;
};

export type OrganizationMutationSetVerificationMethodArgs = {
  id: Scalars["NotEmptyID"]["input"];
  input: OrganizationVerificationMethodInput;
};

export type OrganizationMutationUpdateArgs = {
  id: Scalars["ID"]["input"];
  input: PatchOrganizationInput;
};

export type OrganizationMutationUpdateCalendarEventStatusArgs = {
  id: Scalars["ID"]["input"];
  status?: InputMaybe<FlexCalendarCalendarEventStatusChoices>;
};

export type OrganizationMutationUpdateEmployeeCooperationStatusArgs = {
  id: Scalars["ID"]["input"];
  input: OrganizationEmployeeCooperationStatusUpdateInput;
};

export type OrganizationMutationUpdateJobPositionArgs = {
  id: Scalars["ID"]["input"];
  input: PatchOrganizationJobPositionInput;
};

export type OrganizationMutationUpdateJobPositionAssignmentStatusArgs = {
  id: Scalars["ID"]["input"];
  input: JobPositionAssignmentStatusUpdateInput;
};

export type OrganizationMutationUpdateJobPositionStatusArgs = {
  id: Scalars["ID"]["input"];
  input: OrganizationJobPositionStatusUpdateInput;
};

export type OrganizationMutationUpdatePlatformMessageReadAtArgs = {
  id: Scalars["ID"]["input"];
  input: OrganizationPlatformMessageReadAtUpdateInput;
};

export type OrganizationMutationVerifyArgs = {
  organization: Scalars["NotEmptyID"]["input"];
  otp?: InputMaybe<Scalars["String"]["input"]>;
};

export type OrganizationPlatformMessageAttachmentType = {
  __typename?: "OrganizationPlatformMessageAttachmentType";
  attachmentType?: Maybe<AttachmentType>;
  course?: Maybe<CourseNode>;
  courseResult?: Maybe<CourseResultType>;
  file?: Maybe<BaseFileModelType>;
  id: Scalars["ID"]["output"];
  text: Scalars["String"]["output"];
};

export type OrganizationPlatformMessageNode = {
  __typename?: "OrganizationPlatformMessageNode";
  assigneeType: AuthAccountOrganizationPlatformMessageAssigneeTypeChoices;
  attachments: Array<OrganizationPlatformMessageAttachmentType>;
  created: Scalars["DateTime"]["output"];
  id: Scalars["ID"]["output"];
  readAt?: Maybe<Scalars["DateTime"]["output"]>;
  source: AuthAccountOrganizationPlatformMessageSourceChoices;
  text: Scalars["String"]["output"];
  title: Scalars["String"]["output"];
};

export type OrganizationPlatformMessageNodeConnection = {
  __typename?: "OrganizationPlatformMessageNodeConnection";
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<OrganizationPlatformMessageNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `OrganizationPlatformMessageNode` and its cursor. */
export type OrganizationPlatformMessageNodeEdge = {
  __typename?: "OrganizationPlatformMessageNodeEdge";
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  node?: Maybe<OrganizationPlatformMessageNode>;
};

export type OrganizationPlatformMessageReadAtUpdateInput = {
  readAt?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type OrganizationPlatformMessageReadAtUpdateMutation = {
  __typename?: "OrganizationPlatformMessageReadAtUpdateMutation";
  organizationPlatformMessage?: Maybe<OrganizationPlatformMessageNode>;
};

export type OrganizationQuery = {
  __typename?: "OrganizationQuery";
  employee?: Maybe<OrganizationEmployeeQuery>;
  invitation?: Maybe<OrganizationInvitationType>;
  jobPosition?: Maybe<OrganizationJobPositionQuery>;
  jobPositionAssignment?: Maybe<JobPositionAssignmentNode>;
  jobPositionAssignmentStatistics?: Maybe<JobPositionAssignmentStatisticsType>;
  jobPositionInterview?: Maybe<JobPositionInterviewDetailType>;
};

export type OrganizationQueryInvitationArgs = {
  token: Scalars["NotEmptyID"]["input"];
};

export type OrganizationQueryJobPositionAssignmentArgs = {
  id: Scalars["NotEmptyID"]["input"];
};

export type OrganizationQueryJobPositionAssignmentStatisticsArgs = {
  organizationId: Scalars["NotEmptyID"]["input"];
};

export type OrganizationQueryJobPositionInterviewArgs = {
  id: Scalars["NotEmptyID"]["input"];
};

export type OrganizationSetVerificationMethodMutation = {
  __typename?: "OrganizationSetVerificationMethodMutation";
  output?: Maybe<Scalars["GenericScalar"]["output"]>;
  success?: Maybe<Scalars["Boolean"]["output"]>;
};

export type OrganizationType = {
  __typename?: "OrganizationType";
  about?: Maybe<Scalars["String"]["output"]>;
  businessType?: Maybe<AuthAccountOrganizationBusinessTypeChoices>;
  city?: Maybe<CityNode>;
  contacts?: Maybe<Array<Maybe<ContactType>>>;
  email?: Maybe<Scalars["String"]["output"]>;
  establishedAt?: Maybe<Scalars["Date"]["output"]>;
  hasFinancialData?: Maybe<Scalars["Boolean"]["output"]>;
  id: Scalars["ID"]["output"];
  industry?: Maybe<IndustryNode>;
  invitations: Array<OrganizationInvitationType>;
  logo?: Maybe<OrganizationLogoFileType>;
  memberships: Array<OrganizationMembershipType>;
  name: Scalars["String"]["output"];
  nationalNumber?: Maybe<Scalars["String"]["output"]>;
  shortName?: Maybe<Scalars["String"]["output"]>;
  size?: Maybe<AuthAccountOrganizationSizeChoices>;
  status: AuthAccountOrganizationStatusChoices;
  type?: Maybe<AuthAccountOrganizationTypeChoices>;
};

export type OrganizationUpdateMutation = {
  __typename?: "OrganizationUpdateMutation";
  organization?: Maybe<OrganizationType>;
};

export type OrganizationVerificationMethodInput = {
  communicateorganizationmethod?: InputMaybe<CommunicateOrganizationMethodInput>;
  dnstxtrecordmethod?: InputMaybe<Scalars["String"]["input"]>;
  uploadcompanycertificatemethod?: InputMaybe<UploadCompanyCertificateMethodInput>;
  uploadfiletowebsitemethod?: InputMaybe<Scalars["String"]["input"]>;
};

export type OrganizationVerify = {
  __typename?: "OrganizationVerify";
  success?: Maybe<Scalars["Boolean"]["output"]>;
};

/** The Relay compliant `PageInfo` type, containing data necessary to paginate this connection. */
export type PageInfo = {
  __typename?: "PageInfo";
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars["String"]["output"]>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars["Boolean"]["output"];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars["Boolean"]["output"];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars["String"]["output"]>;
};

export type PasswordReset = {
  __typename?: "PasswordReset";
  success?: Maybe<Scalars["Boolean"]["output"]>;
};

export type PatchCertificateAndLicenseInput = {
  allowSelfVerification?: InputMaybe<Scalars["Boolean"]["input"]>;
  certifier?: InputMaybe<Scalars["String"]["input"]>;
  expiredAt?: InputMaybe<Scalars["Date"]["input"]>;
  issuedAt?: InputMaybe<Scalars["Date"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type PatchEducationInput = {
  allowSelfVerification?: InputMaybe<Scalars["Boolean"]["input"]>;
  city?: InputMaybe<Scalars["ID"]["input"]>;
  degree?: InputMaybe<AuthAccountEducationDegreeChoices>;
  end?: InputMaybe<Scalars["Date"]["input"]>;
  field?: InputMaybe<Scalars["ID"]["input"]>;
  start?: InputMaybe<Scalars["Date"]["input"]>;
  university?: InputMaybe<Scalars["ID"]["input"]>;
};

export type PatchLanguageCertificateInput = {
  allowSelfVerification?: InputMaybe<Scalars["Boolean"]["input"]>;
  expiredAt?: InputMaybe<Scalars["Date"]["input"]>;
  issuedAt?: InputMaybe<Scalars["Date"]["input"]>;
  language?: InputMaybe<AuthAccountLanguageCertificateLanguageChoices>;
  test?: InputMaybe<Scalars["ID"]["input"]>;
  values?: InputMaybe<Array<InputMaybe<PatchLanguageCertificateInputExactLanguageCertificateValues>>>;
};

export type PatchLanguageCertificateInputExactLanguageCertificateValues = {
  skill: Scalars["ID"]["input"];
  value: Scalars["String"]["input"];
};

export type PatchOrganizationInput = {
  about?: InputMaybe<Scalars["String"]["input"]>;
  businessType?: InputMaybe<AuthAccountOrganizationBusinessTypeChoices>;
  city?: InputMaybe<Scalars["ID"]["input"]>;
  establishedAt?: InputMaybe<Scalars["Date"]["input"]>;
  industry?: InputMaybe<Scalars["ID"]["input"]>;
  logo?: InputMaybe<Scalars["ID"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  nationalNumber?: InputMaybe<Scalars["String"]["input"]>;
  shortName?: InputMaybe<Scalars["String"]["input"]>;
  size?: InputMaybe<AuthAccountOrganizationSizeChoices>;
  type?: InputMaybe<AuthAccountOrganizationTypeChoices>;
};

export type PatchOrganizationJobPositionInput = {
  ageRange?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  benefits?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  cities?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  contractType?: InputMaybe<AuthAccountOrganizationJobPositionContractTypeChoices>;
  daysOff?: InputMaybe<Array<InputMaybe<AuthAccountOrganizationJobPositionDaysOffChoices>>>;
  degrees?: InputMaybe<Array<InputMaybe<AuthAccountOrganizationJobPositionDegreesChoices>>>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  employerQuestions?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  fields?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  hiringInCanada?: InputMaybe<Scalars["Boolean"]["input"]>;
  jobRestrictions?: InputMaybe<Scalars["String"]["input"]>;
  languages?: InputMaybe<Array<InputMaybe<AuthAccountOrganizationJobPositionLanguagesChoices>>>;
  locationType?: InputMaybe<AuthAccountOrganizationJobPositionLocationTypeChoices>;
  nativeLanguages?: InputMaybe<Array<InputMaybe<AuthAccountOrganizationJobPositionNativeLanguagesChoices>>>;
  otherBenefits?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  paymentTerm?: InputMaybe<AuthAccountOrganizationJobPositionPaymentTermChoices>;
  performanceExpectation?: InputMaybe<Scalars["String"]["input"]>;
  requiredDocuments?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  salaryRange?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  skills?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  startAt?: InputMaybe<Scalars["Date"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  vaccancy?: InputMaybe<Scalars["Int"]["input"]>;
  validityDays?: InputMaybe<Scalars["Int"]["input"]>;
  workExperienceYearsRange?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  workingEndAt?: InputMaybe<Scalars["Time"]["input"]>;
  workingStartAt?: InputMaybe<Scalars["Time"]["input"]>;
};

export type PatchWorkExperienceInput = {
  allowSelfVerification?: InputMaybe<Scalars["Boolean"]["input"]>;
  city?: InputMaybe<Scalars["ID"]["input"]>;
  end?: InputMaybe<Scalars["Date"]["input"]>;
  grade?: InputMaybe<AuthAccountWorkExperienceGradeChoices>;
  jobTitle?: InputMaybe<Scalars["String"]["input"]>;
  organization?: InputMaybe<Scalars["String"]["input"]>;
  skills?: InputMaybe<Scalars["String"]["input"]>;
  start?: InputMaybe<Scalars["Date"]["input"]>;
};

export type PaystubsFileType = {
  __typename?: "PaystubsFileType";
  file: Scalars["String"]["output"];
};

export type PaystubsMethodAiType = {
  __typename?: "PaystubsMethodAIType";
  id?: Maybe<Scalars["ID"]["output"]>;
};

export type PaystubsMethodType = {
  __typename?: "PaystubsMethodType";
  id: Scalars["ID"]["output"];
  paystubs: PaystubsFileType;
};

export type PerformOnboardingInput = {
  country: Scalars["ID"]["input"];
  industry: Scalars["ID"]["input"];
  interestedJobs: Array<InputMaybe<Scalars["ID"]["input"]>>;
};

export type PerformOnboardingJobSuggestionMutation = {
  __typename?: "PerformOnboardingJobSuggestionMutation";
  output?: Maybe<OnboardingJobSuggestionOutputType>;
};

export type PerformOnboardingMutation = {
  __typename?: "PerformOnboardingMutation";
  success?: Maybe<Scalars["Boolean"]["output"]>;
};

export type ProfileMutation = {
  __typename?: "ProfileMutation";
  performOnboarding?: Maybe<PerformOnboardingMutation>;
  setContacts?: Maybe<SetUserContactsMutation>;
  setSkills?: Maybe<UserSetSkillsMutation>;
  update?: Maybe<UserUpdateMutation>;
  uploadResume?: Maybe<ResumeCreateMutation>;
};

export type ProfileMutationPerformOnboardingArgs = {
  input: PerformOnboardingInput;
};

export type ProfileMutationSetContactsArgs = {
  input: Array<InputMaybe<BatchCreateContactInput>>;
};

export type ProfileMutationSetSkillsArgs = {
  input: UserSkillInput;
  shouldAnalyze?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ProfileMutationUpdateArgs = {
  input: UpdateProfileInput;
};

export type ProfileMutationUploadResumeArgs = {
  input: UpdateResumeInput;
};

export type ProfileType = {
  __typename?: "ProfileType";
  acceptTermsAndConditions: Scalars["Boolean"]["output"];
  allowNotifications: Scalars["Boolean"]["output"];
  avatar?: Maybe<AvatarFileType>;
  /** Must be at least 18 years ago and at most 65 years ago */
  birthDate?: Maybe<Scalars["Date"]["output"]>;
  city?: Maybe<CityNode>;
  completionPercentage?: Maybe<Scalars["Float"]["output"]>;
  contacts?: Maybe<Array<Maybe<ContactType>>>;
  country?: Maybe<CountryNode>;
  credits: Scalars["Int"]["output"];
  employmentStatus?: Maybe<AuthAccountProfileEmploymentStatusChoices>;
  eyeColor?: Maybe<AuthAccountProfileEyeColorChoices>;
  fluentLanguages?: Maybe<Array<Maybe<AuthAccountProfileFluentLanguagesChoices>>>;
  fullBodyImage?: Maybe<FullBodyImageFileType>;
  gender?: Maybe<AuthAccountProfileGenderChoices>;
  hairColor?: Maybe<Scalars["String"]["output"]>;
  height?: Maybe<Scalars["Int"]["output"]>;
  industry?: Maybe<IndustryNode>;
  interestedJobs: JobNodeConnection;
  isOnboardingCompleted?: Maybe<Scalars["Boolean"]["output"]>;
  jobCities: CityNodeConnection;
  jobLocationType?: Maybe<Array<Maybe<AuthAccountProfileJobLocationTypeExcludeChoices>>>;
  jobType?: Maybe<Array<Maybe<AuthAccountProfileJobTypeExcludeChoices>>>;
  nativeLanguage?: Maybe<AuthAccountProfileNativeLanguageChoices>;
  rawSkills?: Maybe<Array<Scalars["String"]["output"]>>;
  score: Scalars["Int"]["output"];
  scores: Scalars["JSONString"]["output"];
  skills: Array<SkillType>;
  skinColor?: Maybe<AuthAccountProfileSkinColorChoices>;
  weight?: Maybe<Scalars["Int"]["output"]>;
};

export type ProfileTypeInterestedJobsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  title_Icontains?: InputMaybe<Scalars["String"]["input"]>;
};

export type ProfileTypeJobCitiesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  country_Code2?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  name_Icontains?: InputMaybe<Scalars["String"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  region?: InputMaybe<Scalars["ID"]["input"]>;
};

export type PushNotificationMutation = {
  __typename?: "PushNotificationMutation";
  registerToken?: Maybe<RegisterPushNotificationTokenMutation>;
};

export type PushNotificationMutationRegisterTokenArgs = {
  token: Scalars["String"]["input"];
};

export type Query = {
  __typename?: "Query";
  academy?: Maybe<AcademyQuery>;
  admin?: Maybe<AdminQuery>;
  calendar?: Maybe<CalendarQuery>;
  certificateAndLicense?: Maybe<CertificateAndLicenseQuery>;
  common?: Maybe<CommonQuery>;
  cv?: Maybe<CvQuery>;
  education?: Maybe<EducationQuery>;
  languageCertificate?: Maybe<LanguageCertificateQuery>;
  me?: Maybe<UserNode>;
  organization?: Maybe<OrganizationQuery>;
  supportTicketCategory?: Maybe<SupportTicketCategoryNodeConnection>;
  workExperience?: Maybe<WorkExperienceQuery>;
};

export type QuerySupportTicketCategoryArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  types_Contains?: InputMaybe<Array<InputMaybe<AuthAccountSupportTicketCategoryTypesChoices>>>;
};

/** An enumeration. */
export enum QuestionStatus {
  ANSWERED = "ANSWERED",
  NOT_STARTED = "NOT_STARTED",
  SEEN = "SEEN",
  SKIP = "SKIP",
  TIMEOUT = "TIMEOUT",
}

export type ReferenceCheckEmployerAiType = {
  __typename?: "ReferenceCheckEmployerAIType";
  email?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  phoneNumber?: Maybe<Scalars["String"]["output"]>;
  position?: Maybe<Scalars["String"]["output"]>;
};

export type ReferenceCheckEmployerType = {
  __typename?: "ReferenceCheckEmployerType";
  email: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  phoneNumber: Scalars["String"]["output"];
  position: Scalars["String"]["output"];
};

export type ReferralType = {
  __typename?: "ReferralType";
  code: Scalars["String"]["output"];
};

export type RefreshToken = {
  __typename?: "RefreshToken";
  payload?: Maybe<Scalars["GenericScalar"]["output"]>;
  success?: Maybe<Scalars["Boolean"]["output"]>;
  token?: Maybe<Scalars["String"]["output"]>;
};

export type RegionNode = {
  __typename?: "RegionNode";
  alternateNames?: Maybe<Scalars["String"]["output"]>;
  country: CountryNode;
  displayName: Scalars["String"]["output"];
  geonameCode?: Maybe<Scalars["String"]["output"]>;
  geonameId?: Maybe<Scalars["Int"]["output"]>;
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  nameAscii: Scalars["String"]["output"];
  slug: Scalars["String"]["output"];
};

export type RegionNodeConnection = {
  __typename?: "RegionNodeConnection";
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<RegionNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `RegionNode` and its cursor. */
export type RegionNodeEdge = {
  __typename?: "RegionNodeEdge";
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  node?: Maybe<RegionNode>;
};

export type RegisterOrganization = {
  __typename?: "RegisterOrganization";
  success?: Maybe<Scalars["Boolean"]["output"]>;
};

export type RegisterPushNotificationTokenMutation = {
  __typename?: "RegisterPushNotificationTokenMutation";
  success?: Maybe<Scalars["Boolean"]["output"]>;
};

export type ResendActivationEmail = {
  __typename?: "ResendActivationEmail";
  success?: Maybe<Scalars["Boolean"]["output"]>;
};

export enum ResumeAssessmentsReadyEnum {
  ASSESSMENTS_IN_PROGRESS = "ASSESSMENTS_IN_PROGRESS",
  ASSESSMENTS_READY = "ASSESSMENTS_READY",
  NO_RESUME = "NO_RESUME",
}

export type ResumeCreateMutation = {
  __typename?: "ResumeCreateMutation";
  resume?: Maybe<ResumeType>;
};

export type ResumeFileType = {
  __typename?: "ResumeFileType";
  file: Scalars["String"]["output"];
};

export type ResumeType = {
  __typename?: "ResumeType";
  file: ResumeFileType;
};

export type RevokeTokenMutation = {
  __typename?: "RevokeTokenMutation";
  revoked?: Maybe<Scalars["Int"]["output"]>;
  success?: Maybe<Scalars["Boolean"]["output"]>;
};

export type RoleType = {
  __typename?: "RoleType";
  accesses: Array<AccessType>;
  description?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  title?: Maybe<Scalars["String"]["output"]>;
};

/** An enumeration. */
export enum Score {
  AVERAGE = "AVERAGE",
  EXCEPTIONAL = "EXCEPTIONAL",
  GOOD = "GOOD",
  GREAT = "GREAT",
  ZERO = "ZERO",
}

export type SelectInterviewSlotMutation = {
  __typename?: "SelectInterviewSlotMutation";
  jobPositionAssignment?: Maybe<JobSeekerJobPositionAssignmentNode>;
};

export type SendPasswordResetEmail = {
  __typename?: "SendPasswordResetEmail";
  success?: Maybe<Scalars["Boolean"]["output"]>;
};

export type SetOrganizationContactableInput = {
  organizationId: Scalars["NotEmptyID"]["input"];
  type?: InputMaybe<AuthAccountContactTypeChoices>;
  value: Scalars["String"]["input"];
};

export type SetOrganizationContactsMutation = {
  __typename?: "SetOrganizationContactsMutation";
  contacts?: Maybe<Array<Maybe<ContactType>>>;
};

export type SetUserContactsMutation = {
  __typename?: "SetUserContactsMutation";
  contacts?: Maybe<Array<Maybe<ContactType>>>;
};

export type SkillNode = {
  __typename?: "SkillNode";
  id: Scalars["ID"]["output"];
  title: Scalars["String"]["output"];
};

export type SkillNodeConnection = {
  __typename?: "SkillNodeConnection";
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SkillNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `SkillNode` and its cursor. */
export type SkillNodeEdge = {
  __typename?: "SkillNodeEdge";
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  node?: Maybe<SkillNode>;
};

export type SkillType = {
  __typename?: "SkillType";
  id: Scalars["ID"]["output"];
  title: Scalars["String"]["output"];
};

/** An enumeration. */
export enum Status {
  COMPLETED = "COMPLETED",
  EVALUATED = "EVALUATED",
  EXPIRED = "EXPIRED",
  GENERATING = "GENERATING",
  IN_PROGRESS = "IN_PROGRESS",
  NOT_READY = "NOT_READY",
  NOT_STARTED = "NOT_STARTED",
}

export type SubRegionNode = {
  __typename?: "SubRegionNode";
  alternateNames?: Maybe<Scalars["String"]["output"]>;
  country: CountryNode;
  displayName: Scalars["String"]["output"];
  geonameCode?: Maybe<Scalars["String"]["output"]>;
  geonameId?: Maybe<Scalars["Int"]["output"]>;
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  nameAscii: Scalars["String"]["output"];
  region?: Maybe<RegionNode>;
  slug: Scalars["String"]["output"];
};

export type SupportTicketCategoryNode = {
  __typename?: "SupportTicketCategoryNode";
  id: Scalars["ID"]["output"];
  title: Scalars["String"]["output"];
  types?: Maybe<Array<Maybe<AuthAccountSupportTicketCategoryTypesChoices>>>;
};

export type SupportTicketCategoryNodeConnection = {
  __typename?: "SupportTicketCategoryNodeConnection";
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SupportTicketCategoryNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `SupportTicketCategoryNode` and its cursor. */
export type SupportTicketCategoryNodeEdge = {
  __typename?: "SupportTicketCategoryNodeEdge";
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  node?: Maybe<SupportTicketCategoryNode>;
};

export type SupportTicketCreateMutation = {
  __typename?: "SupportTicketCreateMutation";
  supportTicket?: Maybe<SupportTicketType>;
};

export type SupportTicketMutation = {
  __typename?: "SupportTicketMutation";
  create?: Maybe<SupportTicketCreateMutation>;
};

export type SupportTicketMutationCreateArgs = {
  input: CreateSupportTicketInput;
};

export type SupportTicketType = {
  __typename?: "SupportTicketType";
  category: SupportTicketCategoryNode;
  contactMethod: AuthAccountSupportTicketContactMethodChoices;
  contactValue: Scalars["String"]["output"];
  created: Scalars["DateTime"]["output"];
  description: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  modified: Scalars["DateTime"]["output"];
  priority: AuthAccountSupportTicketPriorityChoices;
  status: AuthAccountSupportTicketStatusChoices;
  ticketId: Scalars["String"]["output"];
  title: Scalars["String"]["output"];
};

export type TriggerJobSuggestionMutation = {
  __typename?: "TriggerJobSuggestionMutation";
  success?: Maybe<Scalars["Boolean"]["output"]>;
};

export type UnassignJobMutation = {
  __typename?: "UnassignJobMutation";
  deletedId?: Maybe<Scalars["ID"]["output"]>;
  deletedInputId?: Maybe<Scalars["ID"]["output"]>;
  deletedRawId?: Maybe<Scalars["ID"]["output"]>;
  found?: Maybe<Scalars["Boolean"]["output"]>;
};

export type UniversityNode = {
  __typename?: "UniversityNode";
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  websites?: Maybe<Array<Scalars["String"]["output"]>>;
};

export type UniversityNodeConnection = {
  __typename?: "UniversityNodeConnection";
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<UniversityNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `UniversityNode` and its cursor. */
export type UniversityNodeEdge = {
  __typename?: "UniversityNodeEdge";
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  node?: Maybe<UniversityNode>;
};

export type UpdateCanadaVisaInput = {
  citizenshipDocument?: InputMaybe<Scalars["ID"]["input"]>;
  nationality?: InputMaybe<Scalars["ID"]["input"]>;
  status: AuthAccountCanadaVisaStatusChoices;
};

export type UpdateCourseResultInput = {
  course: Scalars["ID"]["input"];
};

export type UpdateProfileInput = {
  acceptTermsAndConditions?: InputMaybe<Scalars["Boolean"]["input"]>;
  allowNotifications?: InputMaybe<Scalars["Boolean"]["input"]>;
  avatar?: InputMaybe<Scalars["ID"]["input"]>;
  /** Must be at least 18 years ago and at most 65 years ago */
  birthDate?: InputMaybe<Scalars["Date"]["input"]>;
  city?: InputMaybe<Scalars["ID"]["input"]>;
  employmentStatus?: InputMaybe<AuthAccountProfileEmploymentStatusChoices>;
  eyeColor?: InputMaybe<AuthAccountProfileEyeColorChoices>;
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  fluentLanguages?: InputMaybe<Array<InputMaybe<AuthAccountProfileFluentLanguagesChoices>>>;
  fullBodyImage?: InputMaybe<Scalars["ID"]["input"]>;
  gender?: InputMaybe<AuthAccountProfileGenderChoices>;
  hairColor?: InputMaybe<Scalars["String"]["input"]>;
  height?: InputMaybe<Scalars["Int"]["input"]>;
  industry?: InputMaybe<Scalars["ID"]["input"]>;
  interestedJobs?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  jobCities?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  jobLocationType?: InputMaybe<Array<InputMaybe<AuthAccountProfileJobLocationTypeExcludeChoices>>>;
  jobType?: InputMaybe<Array<InputMaybe<AuthAccountProfileJobTypeExcludeChoices>>>;
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  nativeLanguage?: InputMaybe<AuthAccountProfileNativeLanguageChoices>;
  skills?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  skinColor?: InputMaybe<AuthAccountProfileSkinColorChoices>;
  weight?: InputMaybe<Scalars["Int"]["input"]>;
};

export type UpdateResumeInput = {
  file: Scalars["ID"]["input"];
};

export type UploadCompanyCertificateMethodInput = {
  organizationCertificateFileId: Scalars["NotEmptyID"]["input"];
};

export type UploadCompanyCertificateMethodType = {
  __typename?: "UploadCompanyCertificateMethodType";
  id: Scalars["ID"]["output"];
  organizationCertificateFile: OrganizationCertificateFileType;
};

export type UploadFileMutation = {
  __typename?: "UploadFileMutation";
  pk?: Maybe<Scalars["Int"]["output"]>;
};

export type UploadFileToWebsiteMethodType = {
  __typename?: "UploadFileToWebsiteMethodType";
  fileName: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
};

/** An enumeration. */
export enum UploadType {
  /** Avatar Image */
  AVATAR = "AVATAR",
  /** Certificate File */
  CERTIFICATE = "CERTIFICATE",
  /** Citizenship Document File */
  CITIZENSHIP_DOCUMENT = "CITIZENSHIP_DOCUMENT",
  /** Degree File */
  DEGREE = "DEGREE",
  /** Education Evaluation Document File */
  EDUCATION_EVALUATION = "EDUCATION_EVALUATION",
  /** Employer Letter File */
  EMPLOYER_LETTER = "EMPLOYER_LETTER",
  /** Full Body Image */
  FULL_BODY_IMAGE = "FULL_BODY_IMAGE",
  /** Language Certificate File */
  LANGUAGE_CERTIFICATE = "LANGUAGE_CERTIFICATE",
  /** Organization Certificate File */
  ORGANIZATION_CERTIFICATE = "ORGANIZATION_CERTIFICATE",
  /** Organization Logo File */
  ORGANIZATION_LOGO = "ORGANIZATION_LOGO",
  /** Paystubs File */
  PAYSTUBS = "PAYSTUBS",
  /** Resume File */
  RESUME = "RESUME",
}

export type UserNode = {
  __typename?: "UserNode";
  archived?: Maybe<Scalars["Boolean"]["output"]>;
  assessments?: Maybe<Array<Maybe<AssessmentType>>>;
  calendar?: Maybe<CalendarType>;
  canadaVisa?: Maybe<CanadaVisaNode>;
  certificateandlicenses?: Maybe<Array<CertificateAndLicenseNode>>;
  currentEmployement?: Maybe<JobSeekerEmployeeType>;
  cv?: Maybe<GeneratedCvNode>;
  educations?: Maybe<Array<EducationNode>>;
  email: Scalars["String"]["output"];
  firstName: Scalars["String"]["output"];
  hasResume?: Maybe<Scalars["Boolean"]["output"]>;
  jobPositionAssignments?: Maybe<JobSeekerJobPositionAssignmentNodeConnection>;
  languagecertificates?: Maybe<Array<LanguageCertificateNode>>;
  lastName: Scalars["String"]["output"];
  notifications?: Maybe<Array<Maybe<InAppNotificationNode>>>;
  organizationMemberships: Array<OrganizationMembershipType>;
  pk?: Maybe<Scalars["Int"]["output"]>;
  profile?: Maybe<ProfileType>;
  referral?: Maybe<ReferralType>;
  relatedCalendarEvents?: Maybe<Array<Maybe<CalendarEventType>>>;
  resume?: Maybe<ResumeType>;
  resumeAssessmentsReady?: Maybe<ResumeAssessmentsReadyEnum>;
  secondaryEmail?: Maybe<Scalars["String"]["output"]>;
  supportTickets?: Maybe<Array<SupportTicketType>>;
  tasks: Array<UserTaskType>;
  verified?: Maybe<Scalars["Boolean"]["output"]>;
  workexperiences?: Maybe<Array<WorkExperienceNode>>;
};

export type UserNodeJobPositionAssignmentsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  createdAt_Gte?: InputMaybe<Scalars["DateTime"]["input"]>;
  createdAt_Lte?: InputMaybe<Scalars["DateTime"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  jobPosition_Status_In?: InputMaybe<Array<InputMaybe<AuthAccountOrganizationJobPositionStatusChoices>>>;
  jobSeekerFullName?: InputMaybe<Scalars["String"]["input"]>;
  jobSeeker_Profile_Score_Gte?: InputMaybe<Scalars["Int"]["input"]>;
  jobSeeker_Profile_Score_Lte?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<AuthAccountJobPositionAssignmentOrderByChoices>;
  status_In?: InputMaybe<Array<InputMaybe<AuthAccountJobPositionAssignmentStatusChoices>>>;
};

export type UserRegister = {
  __typename?: "UserRegister";
  success?: Maybe<Scalars["Boolean"]["output"]>;
};

export type UserSetSkillsMutation = {
  __typename?: "UserSetSkillsMutation";
  user?: Maybe<UserNode>;
};

export type UserSkillInput = {
  skills: Array<InputMaybe<Scalars["String"]["input"]>>;
};

export type UserTaskType = {
  __typename?: "UserTaskType";
  status?: Maybe<AuthAccountUserTaskStatusChoices>;
  taskName: AuthAccountUserTaskTaskNameChoices;
};

export type UserUpdateMutation = {
  __typename?: "UserUpdateMutation";
  profile?: Maybe<ProfileType>;
};

export type VerifyAccount = {
  __typename?: "VerifyAccount";
  success?: Maybe<Scalars["Boolean"]["output"]>;
  /** The token required to set password after registration with password_reset */
  token?: Maybe<Scalars["String"]["output"]>;
};

export type WorkExperienceAiType = {
  __typename?: "WorkExperienceAIType";
  city?: Maybe<CityNode>;
  end?: Maybe<Scalars["Date"]["output"]>;
  grade?: Maybe<AuthAccountWorkExperienceGradeChoices>;
  industry?: Maybe<IndustryNode>;
  jobTitle?: Maybe<Scalars["String"]["output"]>;
  organization?: Maybe<Scalars["String"]["output"]>;
  skills?: Maybe<Scalars["String"]["output"]>;
  start?: Maybe<Scalars["Date"]["output"]>;
};

export type WorkExperienceAnalyseAndExtractDataMutation = {
  __typename?: "WorkExperienceAnalyseAndExtractDataMutation";
  data?: Maybe<WorkExperienceAiType>;
  isValid?: Maybe<Scalars["Boolean"]["output"]>;
  verificationMethodData?: Maybe<WorkExperienceVerificationMethodType>;
};

export type WorkExperienceCreateMutation = {
  __typename?: "WorkExperienceCreateMutation";
  workExperience?: Maybe<WorkExperienceNode>;
};

export type WorkExperienceEmployerLetterMethodInput = {
  employerLetter: Scalars["ID"]["input"];
  employers?: InputMaybe<Array<InputMaybe<WorkExperienceEmployerLetterMethodInputExactEmployerLetterMethodEmployers>>>;
};

export type WorkExperienceEmployerLetterMethodInputExactEmployerLetterMethodEmployers = {
  email: Scalars["String"]["input"];
  name: Scalars["String"]["input"];
  phoneNumber: Scalars["String"]["input"];
  position: Scalars["String"]["input"];
};

export type WorkExperienceMutation = {
  __typename?: "WorkExperienceMutation";
  analyseAndExtractData?: Maybe<WorkExperienceAnalyseAndExtractDataMutation>;
  create?: Maybe<WorkExperienceCreateMutation>;
  update?: Maybe<WorkExperienceUpdateMutation>;
};

export type WorkExperienceMutationAnalyseAndExtractDataArgs = {
  fileId: Scalars["NotEmptyID"]["input"];
  verificationType: WorkExperienceVerificationMethodUploadType;
};

export type WorkExperienceMutationCreateArgs = {
  input: CreateWorkExperienceAndSetVerificationMethodInput;
};

export type WorkExperienceMutationUpdateArgs = {
  id: Scalars["ID"]["input"];
  input: PatchWorkExperienceInput;
};

export type WorkExperienceNode = {
  __typename?: "WorkExperienceNode";
  allowSelfVerification: Scalars["Boolean"]["output"];
  city: CityNode;
  createdAt: Scalars["DateTime"]["output"];
  employerlettermethod?: Maybe<EmployerLetterMethodType>;
  end?: Maybe<Scalars["Date"]["output"]>;
  grade: AuthAccountWorkExperienceGradeChoices;
  id: Scalars["ID"]["output"];
  jobTitle: Scalars["String"]["output"];
  organization: Scalars["String"]["output"];
  paystubsmethod?: Maybe<PaystubsMethodType>;
  skills?: Maybe<Scalars["String"]["output"]>;
  start: Scalars["Date"]["output"];
  status: AuthAccountWorkExperienceStatusChoices;
  updatedAt: Scalars["DateTime"]["output"];
};

export type WorkExperienceQuery = {
  __typename?: "WorkExperienceQuery";
  get?: Maybe<WorkExperienceNode>;
};

export type WorkExperienceQueryGetArgs = {
  id: Scalars["NotEmptyID"]["input"];
};

export type WorkExperienceUpdateMutation = {
  __typename?: "WorkExperienceUpdateMutation";
  workExperience?: Maybe<WorkExperienceNode>;
};

export type WorkExperienceVerificationMethodType = PaystubsMethodAiType | ReferenceCheckEmployerAiType;

/** An enumeration. */
export enum WorkExperienceVerificationMethodUploadType {
  /** Employer Letter File */
  EMPLOYER_LETTER = "EMPLOYER_LETTER",
  /** Paystubs File */
  PAYSTUBS = "PAYSTUBS",
}

export type StartCourseMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type StartCourseMutation = {
  __typename?: "Mutation";
  academy: {
    __typename?: "AcademyMutation";
    startCourse?: { __typename?: "CourseResultCreateMutation"; startUrl: string } | null;
  };
};

export type ScheduleInterviewTimeMutationVariables = Exact<{
  jobPositionAssignmentId: Scalars["ID"]["input"];
  slotId: Scalars["ID"]["input"];
}>;

export type ScheduleInterviewTimeMutation = {
  __typename?: "Mutation";
  account: {
    __typename?: "AccountMutation";
    employment?: {
      __typename?: "EmploymentMutation";
      selectInterviewSlot?: {
        __typename?: "SelectInterviewSlotMutation";
        jobPositionAssignment?: {
          __typename?: "JobSeekerJobPositionAssignmentNode";
          status: AuthAccountJobPositionAssignmentStatusChoices;
          interviews?: Array<{
            __typename?: "JobPositionInterviewType";
            id: string;
            event: {
              __typename?: "CalendarEventType";
              datetime?: any | null;
              meetUrl?: string | null;
              status: FlexCalendarCalendarEventStatusChoices;
              attendees?: Array<{
                __typename?: "CalendarEventAttendeeType";
                firstName?: string | null;
                id: string;
                lastName?: string | null;
              } | null> | null;
            };
            slot?: {
              __typename?: "JobPositionInterviewSlotType";
              datetime?: any | null;
              id: string;
              isAvailable?: boolean | null;
            } | null;
          } | null> | null;
        } | null;
      } | null;
    } | null;
  };
};

export type GetPerformOnboardingJobSuggestionMutationVariables = Exact<{
  industry: Scalars["ID"]["input"];
  interestedJobs: Array<InputMaybe<Scalars["ID"]["input"]>> | InputMaybe<Scalars["ID"]["input"]>;
}>;

export type GetPerformOnboardingJobSuggestionMutation = {
  __typename?: "Mutation";
  account: {
    __typename?: "AccountMutation";
    performOnboardingJobSuggestion?: {
      __typename?: "PerformOnboardingJobSuggestionMutation";
      output?: {
        __typename?: "OnboardingJobSuggestionOutputType";
        text?: string | null;
        jobSuggestions?: Array<{
          __typename?: "OnboardingJobSuggestionType";
          companyName?: string | null;
          country?: string | null;
          salaryRange?: Array<number | null> | null;
          shortDescription?: string | null;
          title?: string | null;
        } | null> | null;
      } | null;
    } | null;
  };
};

export type AccountGoogleAuthMutationVariables = Exact<{
  accessToken?: InputMaybe<Scalars["String"]["input"]>;
  referralCode?: InputMaybe<Scalars["String"]["input"]>;
  jobReferralCode?: InputMaybe<Scalars["String"]["input"]>;
  deviceId?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type AccountGoogleAuthMutation = {
  __typename?: "Mutation";
  account: {
    __typename?: "AccountMutation";
    googleAuth?: {
      __typename?: "GoogleAuth";
      refreshExpiresIn?: number | null;
      token?: string | null;
      payload?: any | null;
      refreshToken?: string | null;
    } | null;
  };
};

export type AccountLinkedinAuthMutationVariables = Exact<{
  code?: InputMaybe<Scalars["String"]["input"]>;
  redirectUri?: InputMaybe<Scalars["String"]["input"]>;
  referralCode?: InputMaybe<Scalars["String"]["input"]>;
  jobReferralCode?: InputMaybe<Scalars["String"]["input"]>;
  deviceId?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type AccountLinkedinAuthMutation = {
  __typename?: "Mutation";
  account: {
    __typename?: "AccountMutation";
    linkedinAuth?: {
      __typename?: "LinkedInAuth";
      refreshExpiresIn?: number | null;
      token?: string | null;
      payload?: any | null;
      refreshToken?: string | null;
    } | null;
  };
};

export type UpdateJobPositionAssignmentStatusMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
  status: AuthAccountJobPositionAssignmentStatusChoices;
}>;

export type UpdateJobPositionAssignmentStatusMutation = {
  __typename?: "Mutation";
  account: {
    __typename?: "AccountMutation";
    employment?: {
      __typename?: "EmploymentMutation";
      updateJobPositionAssignmentStatus?: {
        __typename?: "JobSeekerJobPositionAssignmentStatusUpdateMutation";
        jobPositionAssignment?: { __typename?: "JobSeekerJobPositionAssignmentNode"; id: string } | null;
      } | null;
    } | null;
  };
};

export type AccountPasswordResetMutationVariables = Exact<{
  newPassword1: Scalars["String"]["input"];
  newPassword2: Scalars["String"]["input"];
  token: Scalars["String"]["input"];
  gRecaptchaToken: Scalars["String"]["input"];
}>;

export type AccountPasswordResetMutation = {
  __typename?: "Mutation";
  account: {
    __typename?: "AccountMutation";
    passwordReset?: { __typename?: "PasswordReset"; success?: boolean | null } | null;
  };
};

export type UpdateAvatarMutationVariables = Exact<{
  avatar?: InputMaybe<Scalars["ID"]["input"]>;
}>;

export type UpdateAvatarMutation = {
  __typename?: "Mutation";
  account: {
    __typename?: "AccountMutation";
    profile?: {
      __typename?: "ProfileMutation";
      update?: {
        __typename?: "UserUpdateMutation";
        profile?: {
          __typename?: "ProfileType";
          avatar?: { __typename?: "AvatarFileType"; file: string } | null;
        } | null;
      } | null;
    } | null;
  };
};

export type UpdateInterestedJobsMutationVariables = Exact<{
  employmentStatus?: InputMaybe<AuthAccountProfileEmploymentStatusChoices>;
  interestedJobs?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>> | InputMaybe<Scalars["ID"]["input"]>>;
  height?: InputMaybe<Scalars["Int"]["input"]>;
  weight?: InputMaybe<Scalars["Int"]["input"]>;
  skinColor?: InputMaybe<AuthAccountProfileSkinColorChoices>;
  hairColor?: InputMaybe<Scalars["String"]["input"]>;
  eyeColor?: InputMaybe<AuthAccountProfileEyeColorChoices>;
  fullBodyImage?: InputMaybe<Scalars["ID"]["input"]>;
  jobCities?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>> | InputMaybe<Scalars["ID"]["input"]>>;
  jobLocationType?: InputMaybe<
    | Array<InputMaybe<AuthAccountProfileJobLocationTypeExcludeChoices>>
    | InputMaybe<AuthAccountProfileJobLocationTypeExcludeChoices>
  >;
  jobType?: InputMaybe<
    Array<InputMaybe<AuthAccountProfileJobTypeExcludeChoices>> | InputMaybe<AuthAccountProfileJobTypeExcludeChoices>
  >;
}>;

export type UpdateInterestedJobsMutation = {
  __typename?: "Mutation";
  account: {
    __typename?: "AccountMutation";
    profile?: {
      __typename?: "ProfileMutation";
      update?: {
        __typename?: "UserUpdateMutation";
        profile?: {
          __typename?: "ProfileType";
          weight?: number | null;
          skinColor?: AuthAccountProfileSkinColorChoices | null;
          height?: number | null;
          hairColor?: string | null;
          eyeColor?: AuthAccountProfileEyeColorChoices | null;
          jobLocationType?: Array<AuthAccountProfileJobLocationTypeExcludeChoices | null> | null;
          jobType?: Array<AuthAccountProfileJobTypeExcludeChoices | null> | null;
          employmentStatus?: AuthAccountProfileEmploymentStatusChoices | null;
          interestedJobs: {
            __typename?: "JobNodeConnection";
            edges: Array<{
              __typename?: "JobNodeEdge";
              node?: { __typename?: "JobNode"; title: string; id: string } | null;
            } | null>;
          };
          fullBodyImage?: { __typename?: "FullBodyImageFileType"; file: string } | null;
          jobCities: {
            __typename?: "CityNodeConnection";
            edges: Array<{
              __typename?: "CityNodeEdge";
              node?: { __typename?: "CityNode"; id: string; name: string } | null;
            } | null>;
          };
        } | null;
      } | null;
    } | null;
  };
};

export type UpdateOnboardingValuesMutationVariables = Exact<{
  country: Scalars["ID"]["input"];
  industry: Scalars["ID"]["input"];
  interestedJobs: Array<InputMaybe<Scalars["ID"]["input"]>> | InputMaybe<Scalars["ID"]["input"]>;
}>;

export type UpdateOnboardingValuesMutation = {
  __typename?: "Mutation";
  account: {
    __typename?: "AccountMutation";
    profile?: {
      __typename?: "ProfileMutation";
      performOnboarding?: { __typename?: "PerformOnboardingMutation"; success?: boolean | null } | null;
    } | null;
  };
};

export type UpdateProfileMutationVariables = Exact<{
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  gender?: InputMaybe<AuthAccountProfileGenderChoices>;
  birthDate?: InputMaybe<Scalars["Date"]["input"]>;
  city?: InputMaybe<Scalars["ID"]["input"]>;
  contacts: Array<InputMaybe<BatchCreateContactInput>> | InputMaybe<BatchCreateContactInput>;
  allowNotifications?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type UpdateProfileMutation = {
  __typename?: "Mutation";
  account: {
    __typename?: "AccountMutation";
    profile?: {
      __typename?: "ProfileMutation";
      setContacts?: {
        __typename?: "SetUserContactsMutation";
        contacts?: Array<{
          __typename?: "ContactType";
          id: string;
          type: AuthAccountContactTypeChoices;
          value: string;
        } | null> | null;
      } | null;
      update?: {
        __typename?: "UserUpdateMutation";
        profile?: {
          __typename?: "ProfileType";
          city?: {
            __typename?: "CityNode";
            id: string;
            name: string;
            country: { __typename?: "CountryNode"; id: string; name: string };
            region?: { __typename?: "RegionNode"; name: string; id: string } | null;
          } | null;
        } | null;
      } | null;
    } | null;
  };
};

export type UpdateProfileTermsStatusMutationVariables = Exact<{
  acceptTermsAndConditions: Scalars["Boolean"]["input"];
}>;

export type UpdateProfileTermsStatusMutation = {
  __typename?: "Mutation";
  account: {
    __typename?: "AccountMutation";
    profile?: {
      __typename?: "ProfileMutation";
      update?: {
        __typename?: "UserUpdateMutation";
        profile?: { __typename?: "ProfileType"; acceptTermsAndConditions: boolean } | null;
      } | null;
    } | null;
  };
};

export type ProfileCompletionMutationVariables = Exact<{
  firstName: Scalars["String"]["input"];
  lastName: Scalars["String"]["input"];
  gender: AuthAccountProfileGenderChoices;
  phone: Scalars["String"]["input"];
  visaStatus: AuthAccountCanadaVisaStatusChoices;
}>;

export type ProfileCompletionMutation = {
  __typename?: "Mutation";
  account: {
    __typename?: "AccountMutation";
    profile?: {
      __typename?: "ProfileMutation";
      setContacts?: {
        __typename?: "SetUserContactsMutation";
        contacts?: Array<{
          __typename?: "ContactType";
          id: string;
          type: AuthAccountContactTypeChoices;
          value: string;
        } | null> | null;
      } | null;
      update?: {
        __typename?: "UserUpdateMutation";
        profile?: { __typename?: "ProfileType"; height?: number | null } | null;
      } | null;
    } | null;
    canadaVisa?: {
      __typename?: "CanadaVisaMutation";
      createOrUpdate?: {
        __typename?: "CanadaVisaCreateOrUpdateMutation";
        canadaVisa?: { __typename?: "CanadaVisaNode"; id: string } | null;
      } | null;
    } | null;
  };
};

export type UploadResumeFileMutationVariables = Exact<{
  file: Scalars["ID"]["input"];
}>;

export type UploadResumeFileMutation = {
  __typename?: "Mutation";
  account: {
    __typename?: "AccountMutation";
    profile?: {
      __typename?: "ProfileMutation";
      uploadResume?: {
        __typename?: "ResumeCreateMutation";
        resume?: { __typename?: "ResumeType"; file: { __typename?: "ResumeFileType"; file: string } } | null;
      } | null;
    } | null;
  };
};

export type AccountRefreshTokenMutationVariables = Exact<{
  refreshToken: Scalars["String"]["input"];
}>;

export type AccountRefreshTokenMutation = {
  __typename?: "Mutation";
  account: {
    __typename?: "AccountMutation";
    refreshToken?: {
      __typename?: "RefreshToken";
      token?: string | null;
      success?: boolean | null;
      payload?: any | null;
    } | null;
  };
};

export type AccountRegisterMutationVariables = Exact<{
  email: Scalars["String"]["input"];
  lastName: Scalars["String"]["input"];
  firstName: Scalars["String"]["input"];
  referralCode?: InputMaybe<Scalars["String"]["input"]>;
  jobReferralCode?: InputMaybe<Scalars["String"]["input"]>;
  emailCallbackUrl: Scalars["String"]["input"];
  gRecaptchaToken: Scalars["String"]["input"];
}>;

export type AccountRegisterMutation = {
  __typename?: "Mutation";
  account: {
    __typename?: "AccountMutation";
    register?: { __typename?: "UserRegister"; success?: boolean | null } | null;
  };
};

export type AccountResendActivationEmailMutationVariables = Exact<{
  email: Scalars["String"]["input"];
  emailCallbackUrl: Scalars["String"]["input"];
  gRecaptchaToken: Scalars["String"]["input"];
}>;

export type AccountResendActivationEmailMutation = {
  __typename?: "Mutation";
  account: {
    __typename?: "AccountMutation";
    resendActivationEmail?: { __typename?: "ResendActivationEmail"; success?: boolean | null } | null;
  };
};

export type AccountRevokeTokenMutationVariables = Exact<{
  refreshToken: Scalars["String"]["input"];
}>;

export type AccountRevokeTokenMutation = {
  __typename?: "Mutation";
  account: {
    __typename?: "AccountMutation";
    revokeToken?: { __typename?: "RevokeTokenMutation"; success?: boolean | null } | null;
  };
};

export type AccountSendPasswordResetEmailMutationVariables = Exact<{
  email: Scalars["String"]["input"];
  emailCallbackUrl: Scalars["String"]["input"];
  gRecaptchaToken: Scalars["String"]["input"];
}>;

export type AccountSendPasswordResetEmailMutation = {
  __typename?: "Mutation";
  account: {
    __typename?: "AccountMutation";
    sendPasswordResetEmail?: { __typename?: "SendPasswordResetEmail"; success?: boolean | null } | null;
  };
};

export type CreateSupportTicketMutationVariables = Exact<{
  category: Scalars["ID"]["input"];
  contactMethod: AuthAccountSupportTicketContactMethodChoices;
  contactValue: Scalars["String"]["input"];
  description: Scalars["String"]["input"];
  priority: AuthAccountSupportTicketPriorityChoices;
  title: Scalars["String"]["input"];
}>;

export type CreateSupportTicketMutation = {
  __typename?: "Mutation";
  account: {
    __typename?: "AccountMutation";
    supportTicket?: {
      __typename?: "SupportTicketMutation";
      create?: {
        __typename?: "SupportTicketCreateMutation";
        supportTicket?: { __typename?: "SupportTicketType"; id: string; ticketId: string } | null;
      } | null;
    } | null;
  };
};

export type AccountTokenAuthMutationVariables = Exact<{
  email: Scalars["String"]["input"];
  password: Scalars["String"]["input"];
  deviceId: Scalars["String"]["input"];
  gRecaptchaToken: Scalars["String"]["input"];
}>;

export type AccountTokenAuthMutation = {
  __typename?: "Mutation";
  account: {
    __typename?: "AccountMutation";
    tokenAuth?: {
      __typename?: "ObtainJSONWebToken";
      token?: string | null;
      success?: boolean | null;
      refreshExpiresIn?: number | null;
      payload?: any | null;
      refreshToken?: string | null;
    } | null;
  };
};

export type AccountVerifyMutationVariables = Exact<{
  token: Scalars["String"]["input"];
}>;

export type AccountVerifyMutation = {
  __typename?: "Mutation";
  account: {
    __typename?: "AccountMutation";
    verify?: { __typename?: "VerifyAccount"; success?: boolean | null; token?: string | null } | null;
  };
};

export type GenerateAndGetAssessmentTokenMutationVariables = Exact<{
  assessmentId: Scalars["String"]["input"];
}>;

export type GenerateAndGetAssessmentTokenMutation = {
  __typename?: "Mutation";
  assessment: {
    __typename?: "AssessmentMutation";
    generateAssessmentToken?: { __typename?: "GenerateAssessmentTokenMutation"; token?: string | null } | null;
  };
};

export type CommonUploadFileMutationVariables = Exact<{
  file: Scalars["Upload"]["input"];
  type: UploadType;
}>;

export type CommonUploadFileMutation = {
  __typename?: "Mutation";
  common: {
    __typename?: "CommonMutation";
    uploadFile?: { __typename?: "UploadFileMutation"; pk?: number | null } | null;
  };
};

export type CvGenerateResumeMutationVariables = Exact<{ [key: string]: never }>;

export type CvGenerateResumeMutation = {
  __typename?: "Mutation";
  cv: {
    __typename?: "CVMutation";
    generateResume?: { __typename?: "GenerateResumeMutation"; success?: boolean | null } | null;
  };
};

export type GetCitiesQueryVariables = Exact<{
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  region?: InputMaybe<Scalars["ID"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  country?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetCitiesQuery = {
  __typename?: "Query";
  common?: {
    __typename?: "CommonQuery";
    cities?: {
      __typename?: "CityNodeConnection";
      edges: Array<{
        __typename?: "CityNodeEdge";
        node?: { __typename?: "CityNode"; id: string; name: string } | null;
      } | null>;
      pageInfo: {
        __typename?: "PageInfo";
        endCursor?: string | null;
        hasNextPage: boolean;
        hasPreviousPage: boolean;
        startCursor?: string | null;
      };
    } | null;
  } | null;
};

export type GetCountriesQueryVariables = Exact<{
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
}>;

export type GetCountriesQuery = {
  __typename?: "Query";
  common?: {
    __typename?: "CommonQuery";
    countries?: {
      __typename?: "CountryNodeConnection";
      pageInfo: {
        __typename?: "PageInfo";
        endCursor?: string | null;
        hasNextPage: boolean;
        hasPreviousPage: boolean;
        startCursor?: string | null;
      };
      edges: Array<{
        __typename?: "CountryNodeEdge";
        node?: { __typename?: "CountryNode"; name: string; id: string; code2?: string | null } | null;
      } | null>;
    } | null;
  } | null;
};

export type GetFieldsQueryVariables = Exact<{
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
}>;

export type GetFieldsQuery = {
  __typename?: "Query";
  common?: {
    __typename?: "CommonQuery";
    fields?: {
      __typename?: "FieldNodeConnection";
      edges: Array<{
        __typename?: "FieldNodeEdge";
        node?: { __typename?: "FieldNode"; id: string; name: string } | null;
      } | null>;
      pageInfo: {
        __typename?: "PageInfo";
        endCursor?: string | null;
        hasNextPage: boolean;
        hasPreviousPage: boolean;
        startCursor?: string | null;
      };
    } | null;
  } | null;
};

export type GetIndustriesQueryVariables = Exact<{
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetIndustriesQuery = {
  __typename?: "Query";
  common?: {
    __typename?: "CommonQuery";
    industries?: {
      __typename?: "IndustryNodeConnection";
      edges: Array<{
        __typename?: "IndustryNodeEdge";
        node?: { __typename?: "IndustryNode"; id: string; title: string } | null;
      } | null>;
      pageInfo: {
        __typename?: "PageInfo";
        endCursor?: string | null;
        hasNextPage: boolean;
        hasPreviousPage: boolean;
        startCursor?: string | null;
      };
    } | null;
  } | null;
};

export type GetJobsQueryVariables = Exact<{
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  title_Icontains?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetJobsQuery = {
  __typename?: "Query";
  common?: {
    __typename?: "CommonQuery";
    jobs?: {
      __typename?: "JobNodeConnection";
      pageInfo: {
        __typename?: "PageInfo";
        endCursor?: string | null;
        hasNextPage: boolean;
        hasPreviousPage: boolean;
        startCursor?: string | null;
      };
      edges: Array<{
        __typename?: "JobNodeEdge";
        node?: { __typename?: "JobNode"; id: string; title: string } | null;
      } | null>;
    } | null;
  } | null;
};

export type GetLanguagesProficiencyTestsQueryVariables = Exact<{
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  languages_Contains?: InputMaybe<
    | Array<InputMaybe<CommonLanguageProficiencyTestLanguagesChoices>>
    | InputMaybe<CommonLanguageProficiencyTestLanguagesChoices>
  >;
}>;

export type GetLanguagesProficiencyTestsQuery = {
  __typename?: "Query";
  common?: {
    __typename?: "CommonQuery";
    languagesProficiencyTests?: {
      __typename?: "LanguageProficiencyTestNodeConnection";
      edges: Array<{
        __typename?: "LanguageProficiencyTestNodeEdge";
        node?: {
          __typename?: "LanguageProficiencyTestNode";
          id: string;
          title: string;
          skills?: {
            __typename?: "LanguageProficiencySkillNodeConnection";
            edges: Array<{
              __typename?: "LanguageProficiencySkillNodeEdge";
              node?: {
                __typename?: "LanguageProficiencySkillNode";
                skillName: string;
                id: string;
                slug: string;
              } | null;
            } | null>;
          } | null;
        } | null;
      } | null>;
      pageInfo: {
        __typename?: "PageInfo";
        endCursor?: string | null;
        hasNextPage: boolean;
        hasPreviousPage: boolean;
        startCursor?: string | null;
      };
    } | null;
  } | null;
};

export type GetRegionsQueryVariables = Exact<{
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  country?: InputMaybe<Scalars["ID"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
}>;

export type GetRegionsQuery = {
  __typename?: "Query";
  common?: {
    __typename?: "CommonQuery";
    regions?: {
      __typename?: "RegionNodeConnection";
      edges: Array<{
        __typename?: "RegionNodeEdge";
        node?: { __typename?: "RegionNode"; id: string; name: string } | null;
      } | null>;
      pageInfo: {
        __typename?: "PageInfo";
        endCursor?: string | null;
        hasNextPage: boolean;
        hasPreviousPage: boolean;
        startCursor?: string | null;
      };
    } | null;
  } | null;
};

export type GetUniversitiesQueryVariables = Exact<{
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
}>;

export type GetUniversitiesQuery = {
  __typename?: "Query";
  common?: {
    __typename?: "CommonQuery";
    universities?: {
      __typename?: "UniversityNodeConnection";
      edges: Array<{
        __typename?: "UniversityNodeEdge";
        node?: { __typename?: "UniversityNode"; id: string; name: string } | null;
      } | null>;
      pageInfo: {
        __typename?: "PageInfo";
        endCursor?: string | null;
        hasNextPage: boolean;
        hasPreviousPage: boolean;
        startCursor?: string | null;
      };
    } | null;
  } | null;
};

export type GetAiAssessmentsQueryVariables = Exact<{ [key: string]: never }>;

export type GetAiAssessmentsQuery = {
  __typename?: "Query";
  me?: {
    __typename?: "UserNode";
    assessments?: Array<{
      __typename?: "AssessmentType";
      title: string;
      status: Status;
      description: string;
      id: string;
      remainingQuestions: number;
      totalEstimatedTime: number;
      totalQuestions: number;
      skill?: { __typename?: "AssessmentSkillType"; description: string; title: string } | null;
      results?: Array<{
        __typename?: "JobSeekerAssessmentResultType";
        evaluation?: { __typename?: "JobSeekerEvaluationType"; score: Score; userFeedback: string } | null;
        question: { __typename?: "AssessmentResultQuestionType"; text: string; status: QuestionStatus };
      } | null> | null;
    } | null> | null;
  } | null;
};

export type GetCanadaVisaQueryVariables = Exact<{ [key: string]: never }>;

export type GetCanadaVisaQuery = {
  __typename?: "Query";
  me?: {
    __typename?: "UserNode";
    canadaVisa?: {
      __typename?: "CanadaVisaNode";
      id: string;
      status: AuthAccountCanadaVisaStatusChoices;
      citizenshipDocument?: { __typename?: "CitizenshipDocumentFileType"; file: string } | null;
      nationality?: { __typename?: "CountryNode"; name: string; id: string } | null;
    } | null;
  } | null;
};

export type GetCertificateAndLicensesQueryVariables = Exact<{ [key: string]: never }>;

export type GetCertificateAndLicensesQuery = {
  __typename?: "Query";
  me?: {
    __typename?: "UserNode";
    certificateandlicenses?: Array<{
      __typename?: "CertificateAndLicenseNode";
      id: string;
      expiredAt?: any | null;
      certifier: string;
      issuedAt: any;
      title: string;
      status: AuthAccountCertificateAndLicenseStatusChoices;
    }> | null;
  } | null;
};

export type GetEmployementPlatformMessagesQueryVariables = Exact<{ [key: string]: never }>;

export type GetEmployementPlatformMessagesQuery = {
  __typename?: "Query";
  me?: {
    __typename?: "UserNode";
    currentEmployement?: {
      __typename?: "JobSeekerEmployeeType";
      cooperations?: {
        __typename?: "JobSeekerCooperationType";
        platformMessages?: {
          __typename?: "OrganizationPlatformMessageNodeConnection";
          edges: Array<{
            __typename?: "OrganizationPlatformMessageNodeEdge";
            node?: {
              __typename?: "OrganizationPlatformMessageNode";
              id: string;
              text: string;
              title: string;
              source: AuthAccountOrganizationPlatformMessageSourceChoices;
              readAt?: any | null;
              created: any;
            } | null;
          } | null>;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type GetCoursesQueryVariables = Exact<{
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type GetCoursesQuery = {
  __typename?: "Query";
  academy?: {
    __typename?: "AcademyQuery";
    courses?: {
      __typename?: "CourseNodeConnection";
      edges: Array<{
        __typename?: "CourseNodeEdge";
        node?: {
          __typename?: "CourseNode";
          description: string;
          externalId: string;
          id: string;
          logo?: string | null;
          name: string;
          isGeneral?: boolean | null;
          results: {
            __typename?: "CourseResultTypeConnection";
            edges: Array<{
              __typename?: "CourseResultTypeEdge";
              node?: { __typename?: "CourseResultType"; status: AcademyCourseResultStatusChoices } | null;
            } | null>;
          };
          industries: {
            __typename?: "IndustryNodeConnection";
            edges: Array<{
              __typename?: "IndustryNodeEdge";
              node?: { __typename?: "IndustryNode"; id: string; title: string } | null;
            } | null>;
          };
        } | null;
      } | null>;
    } | null;
  } | null;
};

export type GetEmployementOverviewQueryVariables = Exact<{ [key: string]: never }>;

export type GetEmployementOverviewQuery = {
  __typename?: "Query";
  me?: {
    __typename?: "UserNode";
    currentEmployement?: {
      __typename?: "JobSeekerEmployeeType";
      cooperations?: {
        __typename?: "JobSeekerCooperationType";
        status: AuthAccountOrganizationEmployeeCooperationStatusChoices;
        employerSatisfactionRate?: number | null;
        endAt?: any | null;
        startAt?: any | null;
        createdAt: any;
        jobPosition?: {
          __typename?: "JobSeekerJobPositionType";
          title?: string | null;
          contractType?: AuthAccountOrganizationJobPositionContractTypeChoices | null;
          workExperienceYearsRange?: Array<number> | null;
        } | null;
      } | null;
      organization?: {
        __typename?: "JobSeekerOrganizationType";
        name: string;
        size?: AuthAccountOrganizationSizeChoices | null;
        establishedAt?: any | null;
        logo?: { __typename?: "OrganizationLogoFileType"; file: string } | null;
        city?: { __typename?: "CityNode"; name: string; country: { __typename?: "CountryNode"; name: string } } | null;
        industry?: { __typename?: "IndustryNode"; title: string } | null;
        contacts?: Array<{
          __typename?: "ContactType";
          type: AuthAccountContactTypeChoices;
          value: string;
        } | null> | null;
      } | null;
    } | null;
  } | null;
  academy?: {
    __typename?: "AcademyQuery";
    courses?: { __typename?: "CourseNodeConnection"; totalCount?: number | null } | null;
  } | null;
};

export type GetEducationsQueryVariables = Exact<{ [key: string]: never }>;

export type GetEducationsQuery = {
  __typename?: "Query";
  me?: {
    __typename?: "UserNode";
    educations?: Array<{
      __typename?: "EducationNode";
      id: string;
      degree: AuthAccountEducationDegreeChoices;
      start: any;
      end?: any | null;
      status: AuthAccountEducationStatusChoices;
      field: { __typename?: "FieldType"; name: string };
      university: { __typename?: "UniversityNode"; name: string };
      city: {
        __typename?: "CityNode";
        name: string;
        region?: {
          __typename?: "RegionNode";
          name: string;
          country: { __typename?: "CountryNode"; name: string };
        } | null;
      };
    }> | null;
  } | null;
};

export type GetInterestedJobsQueryVariables = Exact<{ [key: string]: never }>;

export type GetInterestedJobsQuery = {
  __typename?: "Query";
  me?: {
    __typename?: "UserNode";
    profile?: {
      __typename?: "ProfileType";
      employmentStatus?: AuthAccountProfileEmploymentStatusChoices | null;
      eyeColor?: AuthAccountProfileEyeColorChoices | null;
      hairColor?: string | null;
      height?: number | null;
      skinColor?: AuthAccountProfileSkinColorChoices | null;
      weight?: number | null;
      jobLocationType?: Array<AuthAccountProfileJobLocationTypeExcludeChoices | null> | null;
      jobType?: Array<AuthAccountProfileJobTypeExcludeChoices | null> | null;
      interestedJobs: {
        __typename?: "JobNodeConnection";
        edges: Array<{
          __typename?: "JobNodeEdge";
          node?: { __typename?: "JobNode"; title: string; id: string; requireAppearanceData: boolean } | null;
        } | null>;
      };
      fullBodyImage?: { __typename?: "FullBodyImageFileType"; file: string } | null;
      jobCities: {
        __typename?: "CityNodeConnection";
        edges: Array<{
          __typename?: "CityNodeEdge";
          node?: { __typename?: "CityNode"; id: string; name: string } | null;
        } | null>;
      };
    } | null;
  } | null;
};

export type GetJobPositionAssignmentsQueryVariables = Exact<{
  jobPositionStatus?: InputMaybe<
    | Array<InputMaybe<AuthAccountOrganizationJobPositionStatusChoices>>
    | InputMaybe<AuthAccountOrganizationJobPositionStatusChoices>
  >;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  jobSeekerStatus?: InputMaybe<
    | Array<InputMaybe<AuthAccountJobPositionAssignmentStatusChoices>>
    | InputMaybe<AuthAccountJobPositionAssignmentStatusChoices>
  >;
}>;

export type GetJobPositionAssignmentsQuery = {
  __typename?: "Query";
  me?: {
    __typename?: "UserNode";
    jobPositionAssignments?: {
      __typename?: "JobSeekerJobPositionAssignmentNodeConnection";
      edges: Array<{
        __typename?: "JobSeekerJobPositionAssignmentNodeEdge";
        node?: {
          __typename?: "JobSeekerJobPositionAssignmentNode";
          id: string;
          status: AuthAccountJobPositionAssignmentStatusChoices;
          createdAt: any;
          statusHistories?: Array<{
            __typename?: "JobPositionAssignmentStatusHistoryType";
            createdAt: any;
            status: AuthAccountJobPositionAssignmentStatusHistoryStatusChoices;
            interview?: {
              __typename?: "JobPositionInterviewDetailType";
              id: string;
              event: {
                __typename?: "CalendarEventType";
                datetime?: any | null;
                meetUrl?: string | null;
                status: FlexCalendarCalendarEventStatusChoices;
                attendees?: Array<{
                  __typename?: "CalendarEventAttendeeType";
                  firstName?: string | null;
                  id: string;
                  lastName?: string | null;
                } | null> | null;
              };
              slot?: {
                __typename?: "JobPositionInterviewSlotType";
                datetime?: any | null;
                id: string;
                isAvailable?: boolean | null;
              } | null;
            } | null;
          } | null> | null;
          jobPosition?: {
            __typename?: "JobSeekerJobPositionType";
            contractType?: AuthAccountOrganizationJobPositionContractTypeChoices | null;
            description?: string | null;
            locationType?: AuthAccountOrganizationJobPositionLocationTypeChoices | null;
            salaryRange?: Array<number> | null;
            requiredDocuments?: Array<string> | null;
            otherBenefits?: Array<string> | null;
            ageRange?: Array<number> | null;
            daysOff?: Array<AuthAccountOrganizationJobPositionDaysOffChoices | null> | null;
            degrees?: Array<AuthAccountOrganizationJobPositionDegreesChoices | null> | null;
            id: string;
            jobRestrictions?: string | null;
            languages?: Array<AuthAccountOrganizationJobPositionLanguagesChoices | null> | null;
            nativeLanguages?: Array<AuthAccountOrganizationJobPositionNativeLanguagesChoices | null> | null;
            paymentTerm?: AuthAccountOrganizationJobPositionPaymentTermChoices | null;
            performanceExpectation?: string | null;
            status: AuthAccountOrganizationJobPositionStatusChoices;
            startAt?: any | null;
            title?: string | null;
            vaccancy?: number | null;
            validityDate?: any | null;
            workExperienceYearsRange?: Array<number> | null;
            workingEndAt?: any | null;
            workingStartAt?: any | null;
            cities: {
              __typename?: "CityNodeConnection";
              edges: Array<{
                __typename?: "CityNodeEdge";
                node?: {
                  __typename?: "CityNode";
                  name: string;
                  displayName: string;
                  country: { __typename?: "CountryNode"; name: string };
                } | null;
              } | null>;
            };
            organization?: {
              __typename?: "OrganizationType";
              name: string;
              shortName?: string | null;
              establishedAt?: any | null;
              size?: AuthAccountOrganizationSizeChoices | null;
              id: string;
              about?: string | null;
              businessType?: AuthAccountOrganizationBusinessTypeChoices | null;
              logo?: { __typename?: "OrganizationLogoFileType"; file: string } | null;
              city?: {
                __typename?: "CityNode";
                name: string;
                displayName: string;
                country: { __typename?: "CountryNode"; name: string };
              } | null;
              contacts?: Array<{
                __typename?: "ContactType";
                id: string;
                type: AuthAccountContactTypeChoices;
                value: string;
              } | null> | null;
            } | null;
            benefits?: Array<{ __typename?: "JobBenefitType"; id: string; name: string }> | null;
            fields?: Array<{ __typename?: "FieldType"; id: string; name: string }> | null;
            skills?: Array<{ __typename?: "SkillType"; id: string; title: string }> | null;
            interviewSlots: Array<{
              __typename?: "JobPositionInterviewSlotType";
              datetime?: any | null;
              id: string;
              isAvailable?: boolean | null;
            }>;
          } | null;
          interviews?: Array<{
            __typename?: "JobPositionInterviewType";
            id: string;
            event: {
              __typename?: "CalendarEventType";
              datetime?: any | null;
              meetUrl?: string | null;
              status: FlexCalendarCalendarEventStatusChoices;
              attendees?: Array<{
                __typename?: "CalendarEventAttendeeType";
                firstName?: string | null;
                id: string;
                lastName?: string | null;
              } | null> | null;
            };
            slot?: {
              __typename?: "JobPositionInterviewSlotType";
              datetime?: any | null;
              id: string;
              isAvailable?: boolean | null;
            } | null;
          } | null> | null;
        } | null;
      } | null>;
    } | null;
  } | null;
};

export type GetLanguagesCertificatesQueryVariables = Exact<{ [key: string]: never }>;

export type GetLanguagesCertificatesQuery = {
  __typename?: "Query";
  me?: {
    __typename?: "UserNode";
    languagecertificates?: Array<{
      __typename?: "LanguageCertificateNode";
      allowSelfVerification: boolean;
      expiredAt?: any | null;
      id: string;
      issuedAt: any;
      language: AuthAccountLanguageCertificateLanguageChoices;
      status: AuthAccountLanguageCertificateStatusChoices;
      test?: { __typename?: "LanguageProficiencyTestNode"; title: string; id: string } | null;
      values?: Array<{
        __typename?: "LanguageCertificateValueNode";
        id: string;
        value: string;
        skill?: { __typename?: "LanguageProficiencySkillNode"; id: string; skillName: string; slug: string } | null;
      } | null> | null;
    }> | null;
  } | null;
};

export type GetNativeLanguagesQueryVariables = Exact<{ [key: string]: never }>;

export type GetNativeLanguagesQuery = {
  __typename?: "Query";
  me?: {
    __typename?: "UserNode";
    profile?: {
      __typename?: "ProfileType";
      nativeLanguage?: AuthAccountProfileNativeLanguageChoices | null;
      fluentLanguages?: Array<AuthAccountProfileFluentLanguagesChoices | null> | null;
    } | null;
  } | null;
};

export type GetProfileQueryVariables = Exact<{ [key: string]: never }>;

export type GetProfileQuery = {
  __typename?: "Query";
  me?: {
    __typename?: "UserNode";
    email: string;
    firstName: string;
    lastName: string;
    hasResume?: boolean | null;
    resumeAssessmentsReady?: ResumeAssessmentsReadyEnum | null;
    resume?: { __typename?: "ResumeType"; file: { __typename?: "ResumeFileType"; file: string } } | null;
    cv?: { __typename?: "GeneratedCVNode"; file: string } | null;
    referral?: { __typename?: "ReferralType"; code: string } | null;
    profile?: {
      __typename?: "ProfileType";
      birthDate?: any | null;
      gender?: AuthAccountProfileGenderChoices | null;
      credits: number;
      score: number;
      scores: any;
      allowNotifications: boolean;
      acceptTermsAndConditions: boolean;
      completionPercentage?: number | null;
      isOnboardingCompleted?: boolean | null;
      avatar?: { __typename?: "AvatarFileType"; file: string } | null;
      city?: {
        __typename?: "CityNode";
        id: string;
        name: string;
        country: { __typename?: "CountryNode"; id: string; name: string };
        region?: { __typename?: "RegionNode"; name: string; id: string } | null;
      } | null;
      contacts?: Array<{
        __typename?: "ContactType";
        value: string;
        type: AuthAccountContactTypeChoices;
        id: string;
      } | null> | null;
      industry?: { __typename?: "IndustryNode"; id: string } | null;
      interestedJobs: {
        __typename?: "JobNodeConnection";
        edges: Array<{ __typename?: "JobNodeEdge"; node?: { __typename?: "JobNode"; id: string } | null } | null>;
      };
      country?: { __typename?: "CountryNode"; id: string } | null;
    } | null;
    workexperiences?: Array<{ __typename?: "WorkExperienceNode"; jobTitle: string }> | null;
    jobPositionAssignments?: {
      __typename?: "JobSeekerJobPositionAssignmentNodeConnection";
      totalCount?: number | null;
    } | null;
  } | null;
};

export type GetProfileCompletionDataQueryVariables = Exact<{ [key: string]: never }>;

export type GetProfileCompletionDataQuery = {
  __typename?: "Query";
  me?: {
    __typename?: "UserNode";
    firstName: string;
    lastName: string;
    email: string;
    profile?: {
      __typename?: "ProfileType";
      gender?: AuthAccountProfileGenderChoices | null;
      industry?: { __typename?: "IndustryNode"; id: string; title: string } | null;
      contacts?: Array<{
        __typename?: "ContactType";
        id: string;
        type: AuthAccountContactTypeChoices;
        value: string;
      } | null> | null;
      interestedJobs: {
        __typename?: "JobNodeConnection";
        edges: Array<{
          __typename?: "JobNodeEdge";
          node?: { __typename?: "JobNode"; title: string; id: string } | null;
        } | null>;
      };
      country?: { __typename?: "CountryNode"; code2?: string | null; name: string; id: string } | null;
    } | null;
    canadaVisa?: {
      __typename?: "CanadaVisaNode";
      id: string;
      status: AuthAccountCanadaVisaStatusChoices;
      nationality?: { __typename?: "CountryNode"; id: string; name: string; code2?: string | null } | null;
    } | null;
  } | null;
};

export type GetUserSkillsQueryVariables = Exact<{ [key: string]: never }>;

export type GetUserSkillsQuery = {
  __typename?: "Query";
  me?: {
    __typename?: "UserNode";
    profile?: {
      __typename?: "ProfileType";
      rawSkills?: Array<string> | null;
      skills: Array<{ __typename?: "SkillType"; id: string; title: string }>;
    } | null;
  } | null;
};

export type GetSupportTicketsQueryVariables = Exact<{ [key: string]: never }>;

export type GetSupportTicketsQuery = {
  __typename?: "Query";
  me?: {
    __typename?: "UserNode";
    supportTickets?: Array<{
      __typename?: "SupportTicketType";
      contactMethod: AuthAccountSupportTicketContactMethodChoices;
      contactValue: string;
      created: any;
      description: string;
      id: string;
      priority: AuthAccountSupportTicketPriorityChoices;
      status: AuthAccountSupportTicketStatusChoices;
      ticketId: string;
      title: string;
      modified: any;
      category: { __typename?: "SupportTicketCategoryNode"; id: string; title: string };
    }> | null;
  } | null;
};

export type GetSupportTicketCategoryQueryVariables = Exact<{
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  types_Contains?: InputMaybe<
    | Array<InputMaybe<AuthAccountSupportTicketCategoryTypesChoices>>
    | InputMaybe<AuthAccountSupportTicketCategoryTypesChoices>
  >;
}>;

export type GetSupportTicketCategoryQuery = {
  __typename?: "Query";
  supportTicketCategory?: {
    __typename?: "SupportTicketCategoryNodeConnection";
    edges: Array<{
      __typename?: "SupportTicketCategoryNodeEdge";
      node?: { __typename?: "SupportTicketCategoryNode"; id: string; title: string } | null;
    } | null>;
    pageInfo: {
      __typename?: "PageInfo";
      endCursor?: string | null;
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      startCursor?: string | null;
    };
  } | null;
};

export const StartCourseDocument = gql`
  mutation StartCourse($id: ID!) {
    academy {
      startCourse(input: { course: $id }) {
        startUrl
      }
    }
  }
`;
export type StartCourseMutationFn = Apollo.MutationFunction<StartCourseMutation, StartCourseMutationVariables>;

/**
 * __useStartCourseMutation__
 *
 * To run a mutation, you first call `useStartCourseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartCourseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startCourseMutation, { data, loading, error }] = useStartCourseMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStartCourseMutation(
  baseOptions?: Apollo.MutationHookOptions<StartCourseMutation, StartCourseMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<StartCourseMutation, StartCourseMutationVariables>(StartCourseDocument, options);
}
export type StartCourseMutationHookResult = ReturnType<typeof useStartCourseMutation>;
export type StartCourseMutationResult = Apollo.MutationResult<StartCourseMutation>;
export type StartCourseMutationOptions = Apollo.BaseMutationOptions<StartCourseMutation, StartCourseMutationVariables>;
export const ScheduleInterviewTimeDocument = gql`
  mutation scheduleInterviewTime($jobPositionAssignmentId: ID!, $slotId: ID!) {
    account {
      employment {
        selectInterviewSlot(jobPositionAssignmentId: $jobPositionAssignmentId, slotId: $slotId) {
          jobPositionAssignment {
            interviews {
              event {
                attendees {
                  firstName
                  id
                  lastName
                }
                datetime
                meetUrl
                status
              }
              id
              slot {
                datetime
                id
                isAvailable
              }
            }
            status
          }
        }
      }
    }
  }
`;
export type ScheduleInterviewTimeMutationFn = Apollo.MutationFunction<
  ScheduleInterviewTimeMutation,
  ScheduleInterviewTimeMutationVariables
>;

/**
 * __useScheduleInterviewTimeMutation__
 *
 * To run a mutation, you first call `useScheduleInterviewTimeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useScheduleInterviewTimeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [scheduleInterviewTimeMutation, { data, loading, error }] = useScheduleInterviewTimeMutation({
 *   variables: {
 *      jobPositionAssignmentId: // value for 'jobPositionAssignmentId'
 *      slotId: // value for 'slotId'
 *   },
 * });
 */
export function useScheduleInterviewTimeMutation(
  baseOptions?: Apollo.MutationHookOptions<ScheduleInterviewTimeMutation, ScheduleInterviewTimeMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ScheduleInterviewTimeMutation, ScheduleInterviewTimeMutationVariables>(
    ScheduleInterviewTimeDocument,
    options,
  );
}
export type ScheduleInterviewTimeMutationHookResult = ReturnType<typeof useScheduleInterviewTimeMutation>;
export type ScheduleInterviewTimeMutationResult = Apollo.MutationResult<ScheduleInterviewTimeMutation>;
export type ScheduleInterviewTimeMutationOptions = Apollo.BaseMutationOptions<
  ScheduleInterviewTimeMutation,
  ScheduleInterviewTimeMutationVariables
>;
export const GetPerformOnboardingJobSuggestionDocument = gql`
  mutation GetPerformOnboardingJobSuggestion($industry: ID!, $interestedJobs: [ID]!) {
    account {
      performOnboardingJobSuggestion(industry: $industry, interestedJobs: $interestedJobs) {
        output {
          jobSuggestions {
            companyName
            country
            salaryRange
            shortDescription
            title
          }
          text
        }
      }
    }
  }
`;
export type GetPerformOnboardingJobSuggestionMutationFn = Apollo.MutationFunction<
  GetPerformOnboardingJobSuggestionMutation,
  GetPerformOnboardingJobSuggestionMutationVariables
>;

/**
 * __useGetPerformOnboardingJobSuggestionMutation__
 *
 * To run a mutation, you first call `useGetPerformOnboardingJobSuggestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetPerformOnboardingJobSuggestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getPerformOnboardingJobSuggestionMutation, { data, loading, error }] = useGetPerformOnboardingJobSuggestionMutation({
 *   variables: {
 *      industry: // value for 'industry'
 *      interestedJobs: // value for 'interestedJobs'
 *   },
 * });
 */
export function useGetPerformOnboardingJobSuggestionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GetPerformOnboardingJobSuggestionMutation,
    GetPerformOnboardingJobSuggestionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    GetPerformOnboardingJobSuggestionMutation,
    GetPerformOnboardingJobSuggestionMutationVariables
  >(GetPerformOnboardingJobSuggestionDocument, options);
}
export type GetPerformOnboardingJobSuggestionMutationHookResult = ReturnType<
  typeof useGetPerformOnboardingJobSuggestionMutation
>;
export type GetPerformOnboardingJobSuggestionMutationResult =
  Apollo.MutationResult<GetPerformOnboardingJobSuggestionMutation>;
export type GetPerformOnboardingJobSuggestionMutationOptions = Apollo.BaseMutationOptions<
  GetPerformOnboardingJobSuggestionMutation,
  GetPerformOnboardingJobSuggestionMutationVariables
>;
export const AccountGoogleAuthDocument = gql`
  mutation AccountGoogleAuth(
    $accessToken: String = ""
    $referralCode: String = ""
    $jobReferralCode: String = ""
    $deviceId: String = ""
  ) {
    account {
      googleAuth(
        accessToken: $accessToken
        referralCode: $referralCode
        jobReferralCode: $jobReferralCode
        deviceId: $deviceId
      ) {
        refreshExpiresIn
        token
        payload
        refreshToken
      }
    }
  }
`;
export type AccountGoogleAuthMutationFn = Apollo.MutationFunction<
  AccountGoogleAuthMutation,
  AccountGoogleAuthMutationVariables
>;

/**
 * __useAccountGoogleAuthMutation__
 *
 * To run a mutation, you first call `useAccountGoogleAuthMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountGoogleAuthMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountGoogleAuthMutation, { data, loading, error }] = useAccountGoogleAuthMutation({
 *   variables: {
 *      accessToken: // value for 'accessToken'
 *      referralCode: // value for 'referralCode'
 *      jobReferralCode: // value for 'jobReferralCode'
 *      deviceId: // value for 'deviceId'
 *   },
 * });
 */
export function useAccountGoogleAuthMutation(
  baseOptions?: Apollo.MutationHookOptions<AccountGoogleAuthMutation, AccountGoogleAuthMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AccountGoogleAuthMutation, AccountGoogleAuthMutationVariables>(
    AccountGoogleAuthDocument,
    options,
  );
}
export type AccountGoogleAuthMutationHookResult = ReturnType<typeof useAccountGoogleAuthMutation>;
export type AccountGoogleAuthMutationResult = Apollo.MutationResult<AccountGoogleAuthMutation>;
export type AccountGoogleAuthMutationOptions = Apollo.BaseMutationOptions<
  AccountGoogleAuthMutation,
  AccountGoogleAuthMutationVariables
>;
export const AccountLinkedinAuthDocument = gql`
  mutation AccountLinkedinAuth(
    $code: String = ""
    $redirectUri: String = ""
    $referralCode: String = ""
    $jobReferralCode: String = ""
    $deviceId: String = ""
  ) {
    account {
      linkedinAuth(
        code: $code
        redirectUri: $redirectUri
        referralCode: $referralCode
        jobReferralCode: $jobReferralCode
        deviceId: $deviceId
      ) {
        refreshExpiresIn
        token
        payload
        refreshToken
      }
    }
  }
`;
export type AccountLinkedinAuthMutationFn = Apollo.MutationFunction<
  AccountLinkedinAuthMutation,
  AccountLinkedinAuthMutationVariables
>;

/**
 * __useAccountLinkedinAuthMutation__
 *
 * To run a mutation, you first call `useAccountLinkedinAuthMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountLinkedinAuthMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountLinkedinAuthMutation, { data, loading, error }] = useAccountLinkedinAuthMutation({
 *   variables: {
 *      code: // value for 'code'
 *      redirectUri: // value for 'redirectUri'
 *      referralCode: // value for 'referralCode'
 *      jobReferralCode: // value for 'jobReferralCode'
 *      deviceId: // value for 'deviceId'
 *   },
 * });
 */
export function useAccountLinkedinAuthMutation(
  baseOptions?: Apollo.MutationHookOptions<AccountLinkedinAuthMutation, AccountLinkedinAuthMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AccountLinkedinAuthMutation, AccountLinkedinAuthMutationVariables>(
    AccountLinkedinAuthDocument,
    options,
  );
}
export type AccountLinkedinAuthMutationHookResult = ReturnType<typeof useAccountLinkedinAuthMutation>;
export type AccountLinkedinAuthMutationResult = Apollo.MutationResult<AccountLinkedinAuthMutation>;
export type AccountLinkedinAuthMutationOptions = Apollo.BaseMutationOptions<
  AccountLinkedinAuthMutation,
  AccountLinkedinAuthMutationVariables
>;
export const UpdateJobPositionAssignmentStatusDocument = gql`
  mutation UpdateJobPositionAssignmentStatus($id: ID!, $status: AuthAccountJobPositionAssignmentStatusChoices!) {
    account {
      employment {
        updateJobPositionAssignmentStatus(id: $id, input: { status: $status }) {
          jobPositionAssignment {
            id
          }
        }
      }
    }
  }
`;
export type UpdateJobPositionAssignmentStatusMutationFn = Apollo.MutationFunction<
  UpdateJobPositionAssignmentStatusMutation,
  UpdateJobPositionAssignmentStatusMutationVariables
>;

/**
 * __useUpdateJobPositionAssignmentStatusMutation__
 *
 * To run a mutation, you first call `useUpdateJobPositionAssignmentStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateJobPositionAssignmentStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateJobPositionAssignmentStatusMutation, { data, loading, error }] = useUpdateJobPositionAssignmentStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateJobPositionAssignmentStatusMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateJobPositionAssignmentStatusMutation,
    UpdateJobPositionAssignmentStatusMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateJobPositionAssignmentStatusMutation,
    UpdateJobPositionAssignmentStatusMutationVariables
  >(UpdateJobPositionAssignmentStatusDocument, options);
}
export type UpdateJobPositionAssignmentStatusMutationHookResult = ReturnType<
  typeof useUpdateJobPositionAssignmentStatusMutation
>;
export type UpdateJobPositionAssignmentStatusMutationResult =
  Apollo.MutationResult<UpdateJobPositionAssignmentStatusMutation>;
export type UpdateJobPositionAssignmentStatusMutationOptions = Apollo.BaseMutationOptions<
  UpdateJobPositionAssignmentStatusMutation,
  UpdateJobPositionAssignmentStatusMutationVariables
>;
export const AccountPasswordResetDocument = gql`
  mutation AccountPasswordReset(
    $newPassword1: String!
    $newPassword2: String!
    $token: String!
    $gRecaptchaToken: String!
  ) {
    account {
      passwordReset(
        newPassword1: $newPassword1
        newPassword2: $newPassword2
        token: $token
        gRecaptchaToken: $gRecaptchaToken
      ) {
        success
      }
    }
  }
`;
export type AccountPasswordResetMutationFn = Apollo.MutationFunction<
  AccountPasswordResetMutation,
  AccountPasswordResetMutationVariables
>;

/**
 * __useAccountPasswordResetMutation__
 *
 * To run a mutation, you first call `useAccountPasswordResetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountPasswordResetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountPasswordResetMutation, { data, loading, error }] = useAccountPasswordResetMutation({
 *   variables: {
 *      newPassword1: // value for 'newPassword1'
 *      newPassword2: // value for 'newPassword2'
 *      token: // value for 'token'
 *      gRecaptchaToken: // value for 'gRecaptchaToken'
 *   },
 * });
 */
export function useAccountPasswordResetMutation(
  baseOptions?: Apollo.MutationHookOptions<AccountPasswordResetMutation, AccountPasswordResetMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AccountPasswordResetMutation, AccountPasswordResetMutationVariables>(
    AccountPasswordResetDocument,
    options,
  );
}
export type AccountPasswordResetMutationHookResult = ReturnType<typeof useAccountPasswordResetMutation>;
export type AccountPasswordResetMutationResult = Apollo.MutationResult<AccountPasswordResetMutation>;
export type AccountPasswordResetMutationOptions = Apollo.BaseMutationOptions<
  AccountPasswordResetMutation,
  AccountPasswordResetMutationVariables
>;
export const UpdateAvatarDocument = gql`
  mutation UpdateAvatar($avatar: ID) {
    account {
      profile {
        update(input: { avatar: $avatar }) {
          profile {
            avatar {
              file
            }
          }
        }
      }
    }
  }
`;
export type UpdateAvatarMutationFn = Apollo.MutationFunction<UpdateAvatarMutation, UpdateAvatarMutationVariables>;

/**
 * __useUpdateAvatarMutation__
 *
 * To run a mutation, you first call `useUpdateAvatarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAvatarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAvatarMutation, { data, loading, error }] = useUpdateAvatarMutation({
 *   variables: {
 *      avatar: // value for 'avatar'
 *   },
 * });
 */
export function useUpdateAvatarMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateAvatarMutation, UpdateAvatarMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateAvatarMutation, UpdateAvatarMutationVariables>(UpdateAvatarDocument, options);
}
export type UpdateAvatarMutationHookResult = ReturnType<typeof useUpdateAvatarMutation>;
export type UpdateAvatarMutationResult = Apollo.MutationResult<UpdateAvatarMutation>;
export type UpdateAvatarMutationOptions = Apollo.BaseMutationOptions<
  UpdateAvatarMutation,
  UpdateAvatarMutationVariables
>;
export const UpdateInterestedJobsDocument = gql`
  mutation UpdateInterestedJobs(
    $employmentStatus: AuthAccountProfileEmploymentStatusChoices
    $interestedJobs: [ID]
    $height: Int
    $weight: Int
    $skinColor: AuthAccountProfileSkinColorChoices
    $hairColor: String
    $eyeColor: AuthAccountProfileEyeColorChoices
    $fullBodyImage: ID
    $jobCities: [ID]
    $jobLocationType: [AuthAccountProfileJobLocationTypeExcludeChoices]
    $jobType: [AuthAccountProfileJobTypeExcludeChoices]
  ) {
    account {
      profile {
        update(
          input: {
            jobCities: $jobCities
            jobLocationType: $jobLocationType
            jobType: $jobType
            employmentStatus: $employmentStatus
            interestedJobs: $interestedJobs
            height: $height
            weight: $weight
            skinColor: $skinColor
            hairColor: $hairColor
            eyeColor: $eyeColor
            fullBodyImage: $fullBodyImage
          }
        ) {
          profile {
            weight
            skinColor
            interestedJobs {
              edges {
                node {
                  title
                  id
                }
              }
            }
            height
            hairColor
            fullBodyImage {
              file
            }
            eyeColor
            jobCities {
              edges {
                node {
                  id
                  name
                }
              }
            }
            jobLocationType
            jobType
            employmentStatus
          }
        }
      }
    }
  }
`;
export type UpdateInterestedJobsMutationFn = Apollo.MutationFunction<
  UpdateInterestedJobsMutation,
  UpdateInterestedJobsMutationVariables
>;

/**
 * __useUpdateInterestedJobsMutation__
 *
 * To run a mutation, you first call `useUpdateInterestedJobsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInterestedJobsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInterestedJobsMutation, { data, loading, error }] = useUpdateInterestedJobsMutation({
 *   variables: {
 *      employmentStatus: // value for 'employmentStatus'
 *      interestedJobs: // value for 'interestedJobs'
 *      height: // value for 'height'
 *      weight: // value for 'weight'
 *      skinColor: // value for 'skinColor'
 *      hairColor: // value for 'hairColor'
 *      eyeColor: // value for 'eyeColor'
 *      fullBodyImage: // value for 'fullBodyImage'
 *      jobCities: // value for 'jobCities'
 *      jobLocationType: // value for 'jobLocationType'
 *      jobType: // value for 'jobType'
 *   },
 * });
 */
export function useUpdateInterestedJobsMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateInterestedJobsMutation, UpdateInterestedJobsMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateInterestedJobsMutation, UpdateInterestedJobsMutationVariables>(
    UpdateInterestedJobsDocument,
    options,
  );
}
export type UpdateInterestedJobsMutationHookResult = ReturnType<typeof useUpdateInterestedJobsMutation>;
export type UpdateInterestedJobsMutationResult = Apollo.MutationResult<UpdateInterestedJobsMutation>;
export type UpdateInterestedJobsMutationOptions = Apollo.BaseMutationOptions<
  UpdateInterestedJobsMutation,
  UpdateInterestedJobsMutationVariables
>;
export const UpdateOnboardingValuesDocument = gql`
  mutation UpdateOnboardingValues($country: ID!, $industry: ID!, $interestedJobs: [ID]!) {
    account {
      profile {
        performOnboarding(input: { country: $country, industry: $industry, interestedJobs: $interestedJobs }) {
          success
        }
      }
    }
  }
`;
export type UpdateOnboardingValuesMutationFn = Apollo.MutationFunction<
  UpdateOnboardingValuesMutation,
  UpdateOnboardingValuesMutationVariables
>;

/**
 * __useUpdateOnboardingValuesMutation__
 *
 * To run a mutation, you first call `useUpdateOnboardingValuesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOnboardingValuesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOnboardingValuesMutation, { data, loading, error }] = useUpdateOnboardingValuesMutation({
 *   variables: {
 *      country: // value for 'country'
 *      industry: // value for 'industry'
 *      interestedJobs: // value for 'interestedJobs'
 *   },
 * });
 */
export function useUpdateOnboardingValuesMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateOnboardingValuesMutation, UpdateOnboardingValuesMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateOnboardingValuesMutation, UpdateOnboardingValuesMutationVariables>(
    UpdateOnboardingValuesDocument,
    options,
  );
}
export type UpdateOnboardingValuesMutationHookResult = ReturnType<typeof useUpdateOnboardingValuesMutation>;
export type UpdateOnboardingValuesMutationResult = Apollo.MutationResult<UpdateOnboardingValuesMutation>;
export type UpdateOnboardingValuesMutationOptions = Apollo.BaseMutationOptions<
  UpdateOnboardingValuesMutation,
  UpdateOnboardingValuesMutationVariables
>;
export const UpdateProfileDocument = gql`
  mutation UpdateProfile(
    $firstName: String
    $lastName: String
    $gender: AuthAccountProfileGenderChoices
    $birthDate: Date
    $city: ID
    $contacts: [BatchCreateContactInput]!
    $allowNotifications: Boolean
  ) {
    account {
      profile {
        setContacts(input: $contacts) {
          contacts {
            id
            type
            value
          }
        }
        update(
          input: {
            firstName: $firstName
            lastName: $lastName
            gender: $gender
            birthDate: $birthDate
            city: $city
            allowNotifications: $allowNotifications
          }
        ) {
          profile {
            city {
              country {
                id
                name
              }
              id
              name
              region {
                name
                id
              }
            }
          }
        }
      }
    }
  }
`;
export type UpdateProfileMutationFn = Apollo.MutationFunction<UpdateProfileMutation, UpdateProfileMutationVariables>;

/**
 * __useUpdateProfileMutation__
 *
 * To run a mutation, you first call `useUpdateProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProfileMutation, { data, loading, error }] = useUpdateProfileMutation({
 *   variables: {
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      gender: // value for 'gender'
 *      birthDate: // value for 'birthDate'
 *      city: // value for 'city'
 *      contacts: // value for 'contacts'
 *      allowNotifications: // value for 'allowNotifications'
 *   },
 * });
 */
export function useUpdateProfileMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateProfileMutation, UpdateProfileMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateProfileMutation, UpdateProfileMutationVariables>(UpdateProfileDocument, options);
}
export type UpdateProfileMutationHookResult = ReturnType<typeof useUpdateProfileMutation>;
export type UpdateProfileMutationResult = Apollo.MutationResult<UpdateProfileMutation>;
export type UpdateProfileMutationOptions = Apollo.BaseMutationOptions<
  UpdateProfileMutation,
  UpdateProfileMutationVariables
>;
export const UpdateProfileTermsStatusDocument = gql`
  mutation UpdateProfileTermsStatus($acceptTermsAndConditions: Boolean!) {
    account {
      profile {
        update(input: { acceptTermsAndConditions: $acceptTermsAndConditions }) {
          profile {
            acceptTermsAndConditions
          }
        }
      }
    }
  }
`;
export type UpdateProfileTermsStatusMutationFn = Apollo.MutationFunction<
  UpdateProfileTermsStatusMutation,
  UpdateProfileTermsStatusMutationVariables
>;

/**
 * __useUpdateProfileTermsStatusMutation__
 *
 * To run a mutation, you first call `useUpdateProfileTermsStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProfileTermsStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProfileTermsStatusMutation, { data, loading, error }] = useUpdateProfileTermsStatusMutation({
 *   variables: {
 *      acceptTermsAndConditions: // value for 'acceptTermsAndConditions'
 *   },
 * });
 */
export function useUpdateProfileTermsStatusMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateProfileTermsStatusMutation, UpdateProfileTermsStatusMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateProfileTermsStatusMutation, UpdateProfileTermsStatusMutationVariables>(
    UpdateProfileTermsStatusDocument,
    options,
  );
}
export type UpdateProfileTermsStatusMutationHookResult = ReturnType<typeof useUpdateProfileTermsStatusMutation>;
export type UpdateProfileTermsStatusMutationResult = Apollo.MutationResult<UpdateProfileTermsStatusMutation>;
export type UpdateProfileTermsStatusMutationOptions = Apollo.BaseMutationOptions<
  UpdateProfileTermsStatusMutation,
  UpdateProfileTermsStatusMutationVariables
>;
export const ProfileCompletionDocument = gql`
  mutation ProfileCompletion(
    $firstName: String!
    $lastName: String!
    $gender: AuthAccountProfileGenderChoices!
    $phone: String!
    $visaStatus: AuthAccountCanadaVisaStatusChoices!
  ) {
    account {
      profile {
        setContacts(input: [{ type: PHONE, value: $phone }]) {
          contacts {
            id
            type
            value
          }
        }
        update(input: { firstName: $firstName, lastName: $lastName, gender: $gender }) {
          profile {
            height
          }
        }
      }
      canadaVisa {
        createOrUpdate(input: { status: $visaStatus }) {
          canadaVisa {
            id
          }
        }
      }
    }
  }
`;
export type ProfileCompletionMutationFn = Apollo.MutationFunction<
  ProfileCompletionMutation,
  ProfileCompletionMutationVariables
>;

/**
 * __useProfileCompletionMutation__
 *
 * To run a mutation, you first call `useProfileCompletionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProfileCompletionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [profileCompletionMutation, { data, loading, error }] = useProfileCompletionMutation({
 *   variables: {
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      gender: // value for 'gender'
 *      phone: // value for 'phone'
 *      visaStatus: // value for 'visaStatus'
 *   },
 * });
 */
export function useProfileCompletionMutation(
  baseOptions?: Apollo.MutationHookOptions<ProfileCompletionMutation, ProfileCompletionMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ProfileCompletionMutation, ProfileCompletionMutationVariables>(
    ProfileCompletionDocument,
    options,
  );
}
export type ProfileCompletionMutationHookResult = ReturnType<typeof useProfileCompletionMutation>;
export type ProfileCompletionMutationResult = Apollo.MutationResult<ProfileCompletionMutation>;
export type ProfileCompletionMutationOptions = Apollo.BaseMutationOptions<
  ProfileCompletionMutation,
  ProfileCompletionMutationVariables
>;
export const UploadResumeFileDocument = gql`
  mutation UploadResumeFile($file: ID!) {
    account {
      profile {
        uploadResume(input: { file: $file }) {
          resume {
            file {
              file
            }
          }
        }
      }
    }
  }
`;
export type UploadResumeFileMutationFn = Apollo.MutationFunction<
  UploadResumeFileMutation,
  UploadResumeFileMutationVariables
>;

/**
 * __useUploadResumeFileMutation__
 *
 * To run a mutation, you first call `useUploadResumeFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadResumeFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadResumeFileMutation, { data, loading, error }] = useUploadResumeFileMutation({
 *   variables: {
 *      file: // value for 'file'
 *   },
 * });
 */
export function useUploadResumeFileMutation(
  baseOptions?: Apollo.MutationHookOptions<UploadResumeFileMutation, UploadResumeFileMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UploadResumeFileMutation, UploadResumeFileMutationVariables>(
    UploadResumeFileDocument,
    options,
  );
}
export type UploadResumeFileMutationHookResult = ReturnType<typeof useUploadResumeFileMutation>;
export type UploadResumeFileMutationResult = Apollo.MutationResult<UploadResumeFileMutation>;
export type UploadResumeFileMutationOptions = Apollo.BaseMutationOptions<
  UploadResumeFileMutation,
  UploadResumeFileMutationVariables
>;
export const AccountRefreshTokenDocument = gql`
  mutation AccountRefreshToken($refreshToken: String!) {
    account {
      refreshToken(refreshToken: $refreshToken) {
        token
        success
        payload
      }
    }
  }
`;
export type AccountRefreshTokenMutationFn = Apollo.MutationFunction<
  AccountRefreshTokenMutation,
  AccountRefreshTokenMutationVariables
>;

/**
 * __useAccountRefreshTokenMutation__
 *
 * To run a mutation, you first call `useAccountRefreshTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountRefreshTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountRefreshTokenMutation, { data, loading, error }] = useAccountRefreshTokenMutation({
 *   variables: {
 *      refreshToken: // value for 'refreshToken'
 *   },
 * });
 */
export function useAccountRefreshTokenMutation(
  baseOptions?: Apollo.MutationHookOptions<AccountRefreshTokenMutation, AccountRefreshTokenMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AccountRefreshTokenMutation, AccountRefreshTokenMutationVariables>(
    AccountRefreshTokenDocument,
    options,
  );
}
export type AccountRefreshTokenMutationHookResult = ReturnType<typeof useAccountRefreshTokenMutation>;
export type AccountRefreshTokenMutationResult = Apollo.MutationResult<AccountRefreshTokenMutation>;
export type AccountRefreshTokenMutationOptions = Apollo.BaseMutationOptions<
  AccountRefreshTokenMutation,
  AccountRefreshTokenMutationVariables
>;
export const AccountRegisterDocument = gql`
  mutation AccountRegister(
    $email: String!
    $lastName: String!
    $firstName: String!
    $referralCode: String
    $jobReferralCode: String
    $emailCallbackUrl: String!
    $gRecaptchaToken: String!
  ) {
    account {
      register(
        email: $email
        lastName: $lastName
        firstName: $firstName
        referralCode: $referralCode
        jobReferralCode: $jobReferralCode
        emailCallbackUrl: $emailCallbackUrl
        gRecaptchaToken: $gRecaptchaToken
      ) {
        success
      }
    }
  }
`;
export type AccountRegisterMutationFn = Apollo.MutationFunction<
  AccountRegisterMutation,
  AccountRegisterMutationVariables
>;

/**
 * __useAccountRegisterMutation__
 *
 * To run a mutation, you first call `useAccountRegisterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountRegisterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountRegisterMutation, { data, loading, error }] = useAccountRegisterMutation({
 *   variables: {
 *      email: // value for 'email'
 *      lastName: // value for 'lastName'
 *      firstName: // value for 'firstName'
 *      referralCode: // value for 'referralCode'
 *      jobReferralCode: // value for 'jobReferralCode'
 *      emailCallbackUrl: // value for 'emailCallbackUrl'
 *      gRecaptchaToken: // value for 'gRecaptchaToken'
 *   },
 * });
 */
export function useAccountRegisterMutation(
  baseOptions?: Apollo.MutationHookOptions<AccountRegisterMutation, AccountRegisterMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AccountRegisterMutation, AccountRegisterMutationVariables>(
    AccountRegisterDocument,
    options,
  );
}
export type AccountRegisterMutationHookResult = ReturnType<typeof useAccountRegisterMutation>;
export type AccountRegisterMutationResult = Apollo.MutationResult<AccountRegisterMutation>;
export type AccountRegisterMutationOptions = Apollo.BaseMutationOptions<
  AccountRegisterMutation,
  AccountRegisterMutationVariables
>;
export const AccountResendActivationEmailDocument = gql`
  mutation AccountResendActivationEmail($email: String!, $emailCallbackUrl: String!, $gRecaptchaToken: String!) {
    account {
      resendActivationEmail(email: $email, emailCallbackUrl: $emailCallbackUrl, gRecaptchaToken: $gRecaptchaToken) {
        success
      }
    }
  }
`;
export type AccountResendActivationEmailMutationFn = Apollo.MutationFunction<
  AccountResendActivationEmailMutation,
  AccountResendActivationEmailMutationVariables
>;

/**
 * __useAccountResendActivationEmailMutation__
 *
 * To run a mutation, you first call `useAccountResendActivationEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountResendActivationEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountResendActivationEmailMutation, { data, loading, error }] = useAccountResendActivationEmailMutation({
 *   variables: {
 *      email: // value for 'email'
 *      emailCallbackUrl: // value for 'emailCallbackUrl'
 *      gRecaptchaToken: // value for 'gRecaptchaToken'
 *   },
 * });
 */
export function useAccountResendActivationEmailMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AccountResendActivationEmailMutation,
    AccountResendActivationEmailMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AccountResendActivationEmailMutation, AccountResendActivationEmailMutationVariables>(
    AccountResendActivationEmailDocument,
    options,
  );
}
export type AccountResendActivationEmailMutationHookResult = ReturnType<typeof useAccountResendActivationEmailMutation>;
export type AccountResendActivationEmailMutationResult = Apollo.MutationResult<AccountResendActivationEmailMutation>;
export type AccountResendActivationEmailMutationOptions = Apollo.BaseMutationOptions<
  AccountResendActivationEmailMutation,
  AccountResendActivationEmailMutationVariables
>;
export const AccountRevokeTokenDocument = gql`
  mutation AccountRevokeToken($refreshToken: String!) {
    account {
      revokeToken(refreshToken: $refreshToken) {
        success
      }
    }
  }
`;
export type AccountRevokeTokenMutationFn = Apollo.MutationFunction<
  AccountRevokeTokenMutation,
  AccountRevokeTokenMutationVariables
>;

/**
 * __useAccountRevokeTokenMutation__
 *
 * To run a mutation, you first call `useAccountRevokeTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountRevokeTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountRevokeTokenMutation, { data, loading, error }] = useAccountRevokeTokenMutation({
 *   variables: {
 *      refreshToken: // value for 'refreshToken'
 *   },
 * });
 */
export function useAccountRevokeTokenMutation(
  baseOptions?: Apollo.MutationHookOptions<AccountRevokeTokenMutation, AccountRevokeTokenMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AccountRevokeTokenMutation, AccountRevokeTokenMutationVariables>(
    AccountRevokeTokenDocument,
    options,
  );
}
export type AccountRevokeTokenMutationHookResult = ReturnType<typeof useAccountRevokeTokenMutation>;
export type AccountRevokeTokenMutationResult = Apollo.MutationResult<AccountRevokeTokenMutation>;
export type AccountRevokeTokenMutationOptions = Apollo.BaseMutationOptions<
  AccountRevokeTokenMutation,
  AccountRevokeTokenMutationVariables
>;
export const AccountSendPasswordResetEmailDocument = gql`
  mutation AccountSendPasswordResetEmail($email: String!, $emailCallbackUrl: String!, $gRecaptchaToken: String!) {
    account {
      sendPasswordResetEmail(email: $email, emailCallbackUrl: $emailCallbackUrl, gRecaptchaToken: $gRecaptchaToken) {
        success
      }
    }
  }
`;
export type AccountSendPasswordResetEmailMutationFn = Apollo.MutationFunction<
  AccountSendPasswordResetEmailMutation,
  AccountSendPasswordResetEmailMutationVariables
>;

/**
 * __useAccountSendPasswordResetEmailMutation__
 *
 * To run a mutation, you first call `useAccountSendPasswordResetEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountSendPasswordResetEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountSendPasswordResetEmailMutation, { data, loading, error }] = useAccountSendPasswordResetEmailMutation({
 *   variables: {
 *      email: // value for 'email'
 *      emailCallbackUrl: // value for 'emailCallbackUrl'
 *      gRecaptchaToken: // value for 'gRecaptchaToken'
 *   },
 * });
 */
export function useAccountSendPasswordResetEmailMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AccountSendPasswordResetEmailMutation,
    AccountSendPasswordResetEmailMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AccountSendPasswordResetEmailMutation, AccountSendPasswordResetEmailMutationVariables>(
    AccountSendPasswordResetEmailDocument,
    options,
  );
}
export type AccountSendPasswordResetEmailMutationHookResult = ReturnType<
  typeof useAccountSendPasswordResetEmailMutation
>;
export type AccountSendPasswordResetEmailMutationResult = Apollo.MutationResult<AccountSendPasswordResetEmailMutation>;
export type AccountSendPasswordResetEmailMutationOptions = Apollo.BaseMutationOptions<
  AccountSendPasswordResetEmailMutation,
  AccountSendPasswordResetEmailMutationVariables
>;
export const CreateSupportTicketDocument = gql`
  mutation CreateSupportTicket(
    $category: ID!
    $contactMethod: AuthAccountSupportTicketContactMethodChoices!
    $contactValue: String!
    $description: String!
    $priority: AuthAccountSupportTicketPriorityChoices!
    $title: String!
  ) {
    account {
      supportTicket {
        create(
          input: {
            title: $title
            description: $description
            priority: $priority
            category: $category
            contactMethod: $contactMethod
            contactValue: $contactValue
          }
        ) {
          supportTicket {
            id
            ticketId
          }
        }
      }
    }
  }
`;
export type CreateSupportTicketMutationFn = Apollo.MutationFunction<
  CreateSupportTicketMutation,
  CreateSupportTicketMutationVariables
>;

/**
 * __useCreateSupportTicketMutation__
 *
 * To run a mutation, you first call `useCreateSupportTicketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSupportTicketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSupportTicketMutation, { data, loading, error }] = useCreateSupportTicketMutation({
 *   variables: {
 *      category: // value for 'category'
 *      contactMethod: // value for 'contactMethod'
 *      contactValue: // value for 'contactValue'
 *      description: // value for 'description'
 *      priority: // value for 'priority'
 *      title: // value for 'title'
 *   },
 * });
 */
export function useCreateSupportTicketMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateSupportTicketMutation, CreateSupportTicketMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateSupportTicketMutation, CreateSupportTicketMutationVariables>(
    CreateSupportTicketDocument,
    options,
  );
}
export type CreateSupportTicketMutationHookResult = ReturnType<typeof useCreateSupportTicketMutation>;
export type CreateSupportTicketMutationResult = Apollo.MutationResult<CreateSupportTicketMutation>;
export type CreateSupportTicketMutationOptions = Apollo.BaseMutationOptions<
  CreateSupportTicketMutation,
  CreateSupportTicketMutationVariables
>;
export const AccountTokenAuthDocument = gql`
  mutation AccountTokenAuth($email: String!, $password: String!, $deviceId: String!, $gRecaptchaToken: String!) {
    account {
      tokenAuth(email: $email, password: $password, deviceId: $deviceId, gRecaptchaToken: $gRecaptchaToken) {
        token
        success
        refreshExpiresIn
        payload
        refreshToken
      }
    }
  }
`;
export type AccountTokenAuthMutationFn = Apollo.MutationFunction<
  AccountTokenAuthMutation,
  AccountTokenAuthMutationVariables
>;

/**
 * __useAccountTokenAuthMutation__
 *
 * To run a mutation, you first call `useAccountTokenAuthMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountTokenAuthMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountTokenAuthMutation, { data, loading, error }] = useAccountTokenAuthMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *      deviceId: // value for 'deviceId'
 *      gRecaptchaToken: // value for 'gRecaptchaToken'
 *   },
 * });
 */
export function useAccountTokenAuthMutation(
  baseOptions?: Apollo.MutationHookOptions<AccountTokenAuthMutation, AccountTokenAuthMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AccountTokenAuthMutation, AccountTokenAuthMutationVariables>(
    AccountTokenAuthDocument,
    options,
  );
}
export type AccountTokenAuthMutationHookResult = ReturnType<typeof useAccountTokenAuthMutation>;
export type AccountTokenAuthMutationResult = Apollo.MutationResult<AccountTokenAuthMutation>;
export type AccountTokenAuthMutationOptions = Apollo.BaseMutationOptions<
  AccountTokenAuthMutation,
  AccountTokenAuthMutationVariables
>;
export const AccountVerifyDocument = gql`
  mutation AccountVerify($token: String!) {
    account {
      verify(token: $token) {
        success
        token
      }
    }
  }
`;
export type AccountVerifyMutationFn = Apollo.MutationFunction<AccountVerifyMutation, AccountVerifyMutationVariables>;

/**
 * __useAccountVerifyMutation__
 *
 * To run a mutation, you first call `useAccountVerifyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountVerifyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountVerifyMutation, { data, loading, error }] = useAccountVerifyMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useAccountVerifyMutation(
  baseOptions?: Apollo.MutationHookOptions<AccountVerifyMutation, AccountVerifyMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AccountVerifyMutation, AccountVerifyMutationVariables>(AccountVerifyDocument, options);
}
export type AccountVerifyMutationHookResult = ReturnType<typeof useAccountVerifyMutation>;
export type AccountVerifyMutationResult = Apollo.MutationResult<AccountVerifyMutation>;
export type AccountVerifyMutationOptions = Apollo.BaseMutationOptions<
  AccountVerifyMutation,
  AccountVerifyMutationVariables
>;
export const GenerateAndGetAssessmentTokenDocument = gql`
  mutation GenerateAndGetAssessmentToken($assessmentId: String!) {
    assessment {
      generateAssessmentToken(assessmentId: $assessmentId) {
        token
      }
    }
  }
`;
export type GenerateAndGetAssessmentTokenMutationFn = Apollo.MutationFunction<
  GenerateAndGetAssessmentTokenMutation,
  GenerateAndGetAssessmentTokenMutationVariables
>;

/**
 * __useGenerateAndGetAssessmentTokenMutation__
 *
 * To run a mutation, you first call `useGenerateAndGetAssessmentTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateAndGetAssessmentTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateAndGetAssessmentTokenMutation, { data, loading, error }] = useGenerateAndGetAssessmentTokenMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useGenerateAndGetAssessmentTokenMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GenerateAndGetAssessmentTokenMutation,
    GenerateAndGetAssessmentTokenMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<GenerateAndGetAssessmentTokenMutation, GenerateAndGetAssessmentTokenMutationVariables>(
    GenerateAndGetAssessmentTokenDocument,
    options,
  );
}
export type GenerateAndGetAssessmentTokenMutationHookResult = ReturnType<
  typeof useGenerateAndGetAssessmentTokenMutation
>;
export type GenerateAndGetAssessmentTokenMutationResult = Apollo.MutationResult<GenerateAndGetAssessmentTokenMutation>;
export type GenerateAndGetAssessmentTokenMutationOptions = Apollo.BaseMutationOptions<
  GenerateAndGetAssessmentTokenMutation,
  GenerateAndGetAssessmentTokenMutationVariables
>;
export const CommonUploadFileDocument = gql`
  mutation CommonUploadFile($file: Upload!, $type: UploadType!) {
    common {
      uploadFile(file: $file, type: $type) {
        pk
      }
    }
  }
`;
export type CommonUploadFileMutationFn = Apollo.MutationFunction<
  CommonUploadFileMutation,
  CommonUploadFileMutationVariables
>;

/**
 * __useCommonUploadFileMutation__
 *
 * To run a mutation, you first call `useCommonUploadFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCommonUploadFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [commonUploadFileMutation, { data, loading, error }] = useCommonUploadFileMutation({
 *   variables: {
 *      file: // value for 'file'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useCommonUploadFileMutation(
  baseOptions?: Apollo.MutationHookOptions<CommonUploadFileMutation, CommonUploadFileMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CommonUploadFileMutation, CommonUploadFileMutationVariables>(
    CommonUploadFileDocument,
    options,
  );
}
export type CommonUploadFileMutationHookResult = ReturnType<typeof useCommonUploadFileMutation>;
export type CommonUploadFileMutationResult = Apollo.MutationResult<CommonUploadFileMutation>;
export type CommonUploadFileMutationOptions = Apollo.BaseMutationOptions<
  CommonUploadFileMutation,
  CommonUploadFileMutationVariables
>;
export const CvGenerateResumeDocument = gql`
  mutation CVGenerateResume {
    cv {
      generateResume {
        success
      }
    }
  }
`;
export type CvGenerateResumeMutationFn = Apollo.MutationFunction<
  CvGenerateResumeMutation,
  CvGenerateResumeMutationVariables
>;

/**
 * __useCvGenerateResumeMutation__
 *
 * To run a mutation, you first call `useCvGenerateResumeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCvGenerateResumeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cvGenerateResumeMutation, { data, loading, error }] = useCvGenerateResumeMutation({
 *   variables: {
 *   },
 * });
 */
export function useCvGenerateResumeMutation(
  baseOptions?: Apollo.MutationHookOptions<CvGenerateResumeMutation, CvGenerateResumeMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CvGenerateResumeMutation, CvGenerateResumeMutationVariables>(
    CvGenerateResumeDocument,
    options,
  );
}
export type CvGenerateResumeMutationHookResult = ReturnType<typeof useCvGenerateResumeMutation>;
export type CvGenerateResumeMutationResult = Apollo.MutationResult<CvGenerateResumeMutation>;
export type CvGenerateResumeMutationOptions = Apollo.BaseMutationOptions<
  CvGenerateResumeMutation,
  CvGenerateResumeMutationVariables
>;
export const GetCitiesDocument = gql`
  query GetCities(
    $first: Int = 10
    $after: String = ""
    $before: String = ""
    $name: String = ""
    $region: ID = ""
    $id: ID
    $country: String = ""
  ) {
    common {
      cities(
        region: $region
        first: $first
        name_Icontains: $name
        after: $after
        before: $before
        id: $id
        country_Code2: $country
      ) {
        edges {
          node {
            id
            name
          }
        }
        pageInfo {
          endCursor
          hasNextPage
          hasPreviousPage
          startCursor
        }
      }
    }
  }
`;

/**
 * __useGetCitiesQuery__
 *
 * To run a query within a React component, call `useGetCitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCitiesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      name: // value for 'name'
 *      region: // value for 'region'
 *      id: // value for 'id'
 *      country: // value for 'country'
 *   },
 * });
 */
export function useGetCitiesQuery(baseOptions?: Apollo.QueryHookOptions<GetCitiesQuery, GetCitiesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCitiesQuery, GetCitiesQueryVariables>(GetCitiesDocument, options);
}
export function useGetCitiesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetCitiesQuery, GetCitiesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCitiesQuery, GetCitiesQueryVariables>(GetCitiesDocument, options);
}
export function useGetCitiesSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCitiesQuery, GetCitiesQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetCitiesQuery, GetCitiesQueryVariables>(GetCitiesDocument, options);
}
export type GetCitiesQueryHookResult = ReturnType<typeof useGetCitiesQuery>;
export type GetCitiesLazyQueryHookResult = ReturnType<typeof useGetCitiesLazyQuery>;
export type GetCitiesSuspenseQueryHookResult = ReturnType<typeof useGetCitiesSuspenseQuery>;
export type GetCitiesQueryResult = Apollo.QueryResult<GetCitiesQuery, GetCitiesQueryVariables>;
export const GetCountriesDocument = gql`
  query GetCountries($first: Int = 10, $after: String = "", $before: String = "", $name: String = "", $id: ID) {
    common {
      countries(first: $first, name_Icontains: $name, after: $after, before: $before, id: $id) {
        pageInfo {
          endCursor
          hasNextPage
          hasPreviousPage
          startCursor
        }
        edges {
          node {
            name
            id
            code2
          }
        }
      }
    }
  }
`;

/**
 * __useGetCountriesQuery__
 *
 * To run a query within a React component, call `useGetCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCountriesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      name: // value for 'name'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCountriesQuery(
  baseOptions?: Apollo.QueryHookOptions<GetCountriesQuery, GetCountriesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCountriesQuery, GetCountriesQueryVariables>(GetCountriesDocument, options);
}
export function useGetCountriesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetCountriesQuery, GetCountriesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCountriesQuery, GetCountriesQueryVariables>(GetCountriesDocument, options);
}
export function useGetCountriesSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCountriesQuery, GetCountriesQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetCountriesQuery, GetCountriesQueryVariables>(GetCountriesDocument, options);
}
export type GetCountriesQueryHookResult = ReturnType<typeof useGetCountriesQuery>;
export type GetCountriesLazyQueryHookResult = ReturnType<typeof useGetCountriesLazyQuery>;
export type GetCountriesSuspenseQueryHookResult = ReturnType<typeof useGetCountriesSuspenseQuery>;
export type GetCountriesQueryResult = Apollo.QueryResult<GetCountriesQuery, GetCountriesQueryVariables>;
export const GetFieldsDocument = gql`
  query GetFields($first: Int = 10, $after: String = "", $before: String = "", $name: String = "", $id: ID) {
    common {
      fields(first: $first, name_Icontains: $name, after: $after, before: $before, id: $id) {
        edges {
          node {
            id
            name
          }
        }
        pageInfo {
          endCursor
          hasNextPage
          hasPreviousPage
          startCursor
        }
      }
    }
  }
`;

/**
 * __useGetFieldsQuery__
 *
 * To run a query within a React component, call `useGetFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFieldsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      name: // value for 'name'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetFieldsQuery(baseOptions?: Apollo.QueryHookOptions<GetFieldsQuery, GetFieldsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetFieldsQuery, GetFieldsQueryVariables>(GetFieldsDocument, options);
}
export function useGetFieldsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetFieldsQuery, GetFieldsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetFieldsQuery, GetFieldsQueryVariables>(GetFieldsDocument, options);
}
export function useGetFieldsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFieldsQuery, GetFieldsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetFieldsQuery, GetFieldsQueryVariables>(GetFieldsDocument, options);
}
export type GetFieldsQueryHookResult = ReturnType<typeof useGetFieldsQuery>;
export type GetFieldsLazyQueryHookResult = ReturnType<typeof useGetFieldsLazyQuery>;
export type GetFieldsSuspenseQueryHookResult = ReturnType<typeof useGetFieldsSuspenseQuery>;
export type GetFieldsQueryResult = Apollo.QueryResult<GetFieldsQuery, GetFieldsQueryVariables>;
export const GetIndustriesDocument = gql`
  query GetIndustries($first: Int = 10, $after: String = "", $before: String = "", $name: String = "") {
    common {
      industries(first: $first, title_Icontains: $name, after: $after, before: $before, orderBy: _ORDER) {
        edges {
          node {
            id
            title
          }
        }
        pageInfo {
          endCursor
          hasNextPage
          hasPreviousPage
          startCursor
        }
      }
    }
  }
`;

/**
 * __useGetIndustriesQuery__
 *
 * To run a query within a React component, call `useGetIndustriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIndustriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIndustriesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetIndustriesQuery(
  baseOptions?: Apollo.QueryHookOptions<GetIndustriesQuery, GetIndustriesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetIndustriesQuery, GetIndustriesQueryVariables>(GetIndustriesDocument, options);
}
export function useGetIndustriesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetIndustriesQuery, GetIndustriesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetIndustriesQuery, GetIndustriesQueryVariables>(GetIndustriesDocument, options);
}
export function useGetIndustriesSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIndustriesQuery, GetIndustriesQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetIndustriesQuery, GetIndustriesQueryVariables>(GetIndustriesDocument, options);
}
export type GetIndustriesQueryHookResult = ReturnType<typeof useGetIndustriesQuery>;
export type GetIndustriesLazyQueryHookResult = ReturnType<typeof useGetIndustriesLazyQuery>;
export type GetIndustriesSuspenseQueryHookResult = ReturnType<typeof useGetIndustriesSuspenseQuery>;
export type GetIndustriesQueryResult = Apollo.QueryResult<GetIndustriesQuery, GetIndustriesQueryVariables>;
export const GetJobsDocument = gql`
  query GetJobs($first: Int, $after: String, $before: String, $id: ID, $title_Icontains: String) {
    common {
      jobs(first: $first, after: $after, before: $before, id: $id, title_Icontains: $title_Icontains) {
        pageInfo {
          endCursor
          hasNextPage
          hasPreviousPage
          startCursor
        }
        edges {
          node {
            id
            title
          }
        }
      }
    }
  }
`;

/**
 * __useGetJobsQuery__
 *
 * To run a query within a React component, call `useGetJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      id: // value for 'id'
 *      title_Icontains: // value for 'title_Icontains'
 *   },
 * });
 */
export function useGetJobsQuery(baseOptions?: Apollo.QueryHookOptions<GetJobsQuery, GetJobsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetJobsQuery, GetJobsQueryVariables>(GetJobsDocument, options);
}
export function useGetJobsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetJobsQuery, GetJobsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetJobsQuery, GetJobsQueryVariables>(GetJobsDocument, options);
}
export function useGetJobsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetJobsQuery, GetJobsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetJobsQuery, GetJobsQueryVariables>(GetJobsDocument, options);
}
export type GetJobsQueryHookResult = ReturnType<typeof useGetJobsQuery>;
export type GetJobsLazyQueryHookResult = ReturnType<typeof useGetJobsLazyQuery>;
export type GetJobsSuspenseQueryHookResult = ReturnType<typeof useGetJobsSuspenseQuery>;
export type GetJobsQueryResult = Apollo.QueryResult<GetJobsQuery, GetJobsQueryVariables>;
export const GetLanguagesProficiencyTestsDocument = gql`
  query GetLanguagesProficiencyTests(
    $first: Int = 10
    $after: String = ""
    $before: String = ""
    $name: String = ""
    $languages_Contains: [CommonLanguageProficiencyTestLanguagesChoices]
  ) {
    common {
      languagesProficiencyTests(
        first: $first
        title_Icontains: $name
        after: $after
        before: $before
        languages_Contains: $languages_Contains
      ) {
        edges {
          node {
            id
            title
            skills {
              edges {
                node {
                  skillName
                  id
                  slug
                }
              }
            }
          }
        }
        pageInfo {
          endCursor
          hasNextPage
          hasPreviousPage
          startCursor
        }
      }
    }
  }
`;

/**
 * __useGetLanguagesProficiencyTestsQuery__
 *
 * To run a query within a React component, call `useGetLanguagesProficiencyTestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLanguagesProficiencyTestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLanguagesProficiencyTestsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      name: // value for 'name'
 *      languages_Contains: // value for 'languages_Contains'
 *   },
 * });
 */
export function useGetLanguagesProficiencyTestsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetLanguagesProficiencyTestsQuery, GetLanguagesProficiencyTestsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetLanguagesProficiencyTestsQuery, GetLanguagesProficiencyTestsQueryVariables>(
    GetLanguagesProficiencyTestsDocument,
    options,
  );
}
export function useGetLanguagesProficiencyTestsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetLanguagesProficiencyTestsQuery,
    GetLanguagesProficiencyTestsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetLanguagesProficiencyTestsQuery, GetLanguagesProficiencyTestsQueryVariables>(
    GetLanguagesProficiencyTestsDocument,
    options,
  );
}
export function useGetLanguagesProficiencyTestsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetLanguagesProficiencyTestsQuery, GetLanguagesProficiencyTestsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetLanguagesProficiencyTestsQuery, GetLanguagesProficiencyTestsQueryVariables>(
    GetLanguagesProficiencyTestsDocument,
    options,
  );
}
export type GetLanguagesProficiencyTestsQueryHookResult = ReturnType<typeof useGetLanguagesProficiencyTestsQuery>;
export type GetLanguagesProficiencyTestsLazyQueryHookResult = ReturnType<
  typeof useGetLanguagesProficiencyTestsLazyQuery
>;
export type GetLanguagesProficiencyTestsSuspenseQueryHookResult = ReturnType<
  typeof useGetLanguagesProficiencyTestsSuspenseQuery
>;
export type GetLanguagesProficiencyTestsQueryResult = Apollo.QueryResult<
  GetLanguagesProficiencyTestsQuery,
  GetLanguagesProficiencyTestsQueryVariables
>;
export const GetRegionsDocument = gql`
  query GetRegions(
    $first: Int = 10
    $after: String = ""
    $before: String = ""
    $name: String = ""
    $country: ID = ""
    $id: ID
  ) {
    common {
      regions(country: $country, first: $first, name_Icontains: $name, after: $after, before: $before, id: $id) {
        edges {
          node {
            id
            name
          }
        }
        pageInfo {
          endCursor
          hasNextPage
          hasPreviousPage
          startCursor
        }
      }
    }
  }
`;

/**
 * __useGetRegionsQuery__
 *
 * To run a query within a React component, call `useGetRegionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegionsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      name: // value for 'name'
 *      country: // value for 'country'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetRegionsQuery(baseOptions?: Apollo.QueryHookOptions<GetRegionsQuery, GetRegionsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetRegionsQuery, GetRegionsQueryVariables>(GetRegionsDocument, options);
}
export function useGetRegionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetRegionsQuery, GetRegionsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetRegionsQuery, GetRegionsQueryVariables>(GetRegionsDocument, options);
}
export function useGetRegionsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRegionsQuery, GetRegionsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetRegionsQuery, GetRegionsQueryVariables>(GetRegionsDocument, options);
}
export type GetRegionsQueryHookResult = ReturnType<typeof useGetRegionsQuery>;
export type GetRegionsLazyQueryHookResult = ReturnType<typeof useGetRegionsLazyQuery>;
export type GetRegionsSuspenseQueryHookResult = ReturnType<typeof useGetRegionsSuspenseQuery>;
export type GetRegionsQueryResult = Apollo.QueryResult<GetRegionsQuery, GetRegionsQueryVariables>;
export const GetUniversitiesDocument = gql`
  query GetUniversities($first: Int = 10, $after: String = "", $before: String = "", $name: String = "", $id: ID) {
    common {
      universities(first: $first, name_Icontains: $name, after: $after, before: $before, id: $id) {
        edges {
          node {
            id
            name
          }
        }
        pageInfo {
          endCursor
          hasNextPage
          hasPreviousPage
          startCursor
        }
      }
    }
  }
`;

/**
 * __useGetUniversitiesQuery__
 *
 * To run a query within a React component, call `useGetUniversitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUniversitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUniversitiesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      name: // value for 'name'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUniversitiesQuery(
  baseOptions?: Apollo.QueryHookOptions<GetUniversitiesQuery, GetUniversitiesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetUniversitiesQuery, GetUniversitiesQueryVariables>(GetUniversitiesDocument, options);
}
export function useGetUniversitiesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetUniversitiesQuery, GetUniversitiesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetUniversitiesQuery, GetUniversitiesQueryVariables>(GetUniversitiesDocument, options);
}
export function useGetUniversitiesSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUniversitiesQuery, GetUniversitiesQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetUniversitiesQuery, GetUniversitiesQueryVariables>(GetUniversitiesDocument, options);
}
export type GetUniversitiesQueryHookResult = ReturnType<typeof useGetUniversitiesQuery>;
export type GetUniversitiesLazyQueryHookResult = ReturnType<typeof useGetUniversitiesLazyQuery>;
export type GetUniversitiesSuspenseQueryHookResult = ReturnType<typeof useGetUniversitiesSuspenseQuery>;
export type GetUniversitiesQueryResult = Apollo.QueryResult<GetUniversitiesQuery, GetUniversitiesQueryVariables>;
export const GetAiAssessmentsDocument = gql`
  query GetAIAssessments {
    me {
      assessments {
        title
        status
        description
        id
        remainingQuestions
        totalEstimatedTime
        totalQuestions
        skill {
          description
          title
        }
        results {
          evaluation {
            score
            userFeedback
          }
          question {
            text
            status
          }
        }
      }
    }
  }
`;

/**
 * __useGetAiAssessmentsQuery__
 *
 * To run a query within a React component, call `useGetAiAssessmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAiAssessmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAiAssessmentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAiAssessmentsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetAiAssessmentsQuery, GetAiAssessmentsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAiAssessmentsQuery, GetAiAssessmentsQueryVariables>(GetAiAssessmentsDocument, options);
}
export function useGetAiAssessmentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetAiAssessmentsQuery, GetAiAssessmentsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAiAssessmentsQuery, GetAiAssessmentsQueryVariables>(GetAiAssessmentsDocument, options);
}
export function useGetAiAssessmentsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetAiAssessmentsQuery, GetAiAssessmentsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetAiAssessmentsQuery, GetAiAssessmentsQueryVariables>(
    GetAiAssessmentsDocument,
    options,
  );
}
export type GetAiAssessmentsQueryHookResult = ReturnType<typeof useGetAiAssessmentsQuery>;
export type GetAiAssessmentsLazyQueryHookResult = ReturnType<typeof useGetAiAssessmentsLazyQuery>;
export type GetAiAssessmentsSuspenseQueryHookResult = ReturnType<typeof useGetAiAssessmentsSuspenseQuery>;
export type GetAiAssessmentsQueryResult = Apollo.QueryResult<GetAiAssessmentsQuery, GetAiAssessmentsQueryVariables>;
export const GetCanadaVisaDocument = gql`
  query GetCanadaVisa {
    me {
      canadaVisa {
        citizenshipDocument {
          file
        }
        id
        status
        nationality {
          name
          id
        }
      }
    }
  }
`;

/**
 * __useGetCanadaVisaQuery__
 *
 * To run a query within a React component, call `useGetCanadaVisaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCanadaVisaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCanadaVisaQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCanadaVisaQuery(
  baseOptions?: Apollo.QueryHookOptions<GetCanadaVisaQuery, GetCanadaVisaQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCanadaVisaQuery, GetCanadaVisaQueryVariables>(GetCanadaVisaDocument, options);
}
export function useGetCanadaVisaLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetCanadaVisaQuery, GetCanadaVisaQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCanadaVisaQuery, GetCanadaVisaQueryVariables>(GetCanadaVisaDocument, options);
}
export function useGetCanadaVisaSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCanadaVisaQuery, GetCanadaVisaQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetCanadaVisaQuery, GetCanadaVisaQueryVariables>(GetCanadaVisaDocument, options);
}
export type GetCanadaVisaQueryHookResult = ReturnType<typeof useGetCanadaVisaQuery>;
export type GetCanadaVisaLazyQueryHookResult = ReturnType<typeof useGetCanadaVisaLazyQuery>;
export type GetCanadaVisaSuspenseQueryHookResult = ReturnType<typeof useGetCanadaVisaSuspenseQuery>;
export type GetCanadaVisaQueryResult = Apollo.QueryResult<GetCanadaVisaQuery, GetCanadaVisaQueryVariables>;
export const GetCertificateAndLicensesDocument = gql`
  query getCertificateAndLicenses {
    me {
      certificateandlicenses {
        id
        expiredAt
        certifier
        issuedAt
        title
        status
      }
    }
  }
`;

/**
 * __useGetCertificateAndLicensesQuery__
 *
 * To run a query within a React component, call `useGetCertificateAndLicensesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCertificateAndLicensesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCertificateAndLicensesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCertificateAndLicensesQuery(
  baseOptions?: Apollo.QueryHookOptions<GetCertificateAndLicensesQuery, GetCertificateAndLicensesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCertificateAndLicensesQuery, GetCertificateAndLicensesQueryVariables>(
    GetCertificateAndLicensesDocument,
    options,
  );
}
export function useGetCertificateAndLicensesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetCertificateAndLicensesQuery, GetCertificateAndLicensesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCertificateAndLicensesQuery, GetCertificateAndLicensesQueryVariables>(
    GetCertificateAndLicensesDocument,
    options,
  );
}
export function useGetCertificateAndLicensesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetCertificateAndLicensesQuery, GetCertificateAndLicensesQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetCertificateAndLicensesQuery, GetCertificateAndLicensesQueryVariables>(
    GetCertificateAndLicensesDocument,
    options,
  );
}
export type GetCertificateAndLicensesQueryHookResult = ReturnType<typeof useGetCertificateAndLicensesQuery>;
export type GetCertificateAndLicensesLazyQueryHookResult = ReturnType<typeof useGetCertificateAndLicensesLazyQuery>;
export type GetCertificateAndLicensesSuspenseQueryHookResult = ReturnType<
  typeof useGetCertificateAndLicensesSuspenseQuery
>;
export type GetCertificateAndLicensesQueryResult = Apollo.QueryResult<
  GetCertificateAndLicensesQuery,
  GetCertificateAndLicensesQueryVariables
>;
export const GetEmployementPlatformMessagesDocument = gql`
  query getEmployementPlatformMessages {
    me {
      currentEmployement {
        cooperations {
          platformMessages {
            edges {
              node {
                id
                text
                title
                source
                readAt
                created
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetEmployementPlatformMessagesQuery__
 *
 * To run a query within a React component, call `useGetEmployementPlatformMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployementPlatformMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployementPlatformMessagesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEmployementPlatformMessagesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetEmployementPlatformMessagesQuery,
    GetEmployementPlatformMessagesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetEmployementPlatformMessagesQuery, GetEmployementPlatformMessagesQueryVariables>(
    GetEmployementPlatformMessagesDocument,
    options,
  );
}
export function useGetEmployementPlatformMessagesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetEmployementPlatformMessagesQuery,
    GetEmployementPlatformMessagesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetEmployementPlatformMessagesQuery, GetEmployementPlatformMessagesQueryVariables>(
    GetEmployementPlatformMessagesDocument,
    options,
  );
}
export function useGetEmployementPlatformMessagesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetEmployementPlatformMessagesQuery,
        GetEmployementPlatformMessagesQueryVariables
      >,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetEmployementPlatformMessagesQuery, GetEmployementPlatformMessagesQueryVariables>(
    GetEmployementPlatformMessagesDocument,
    options,
  );
}
export type GetEmployementPlatformMessagesQueryHookResult = ReturnType<typeof useGetEmployementPlatformMessagesQuery>;
export type GetEmployementPlatformMessagesLazyQueryHookResult = ReturnType<
  typeof useGetEmployementPlatformMessagesLazyQuery
>;
export type GetEmployementPlatformMessagesSuspenseQueryHookResult = ReturnType<
  typeof useGetEmployementPlatformMessagesSuspenseQuery
>;
export type GetEmployementPlatformMessagesQueryResult = Apollo.QueryResult<
  GetEmployementPlatformMessagesQuery,
  GetEmployementPlatformMessagesQueryVariables
>;
export const GetCoursesDocument = gql`
  query GetCourses($after: String, $before: String, $first: Int, $last: Int) {
    academy {
      courses(after: $after, before: $before, first: $first, last: $last) {
        edges {
          node {
            description
            externalId
            id
            logo
            name
            results {
              edges {
                node {
                  status
                }
              }
            }
            industries {
              edges {
                node {
                  id
                  title
                }
              }
            }
            isGeneral
          }
        }
      }
    }
  }
`;

/**
 * __useGetCoursesQuery__
 *
 * To run a query within a React component, call `useGetCoursesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoursesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoursesQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useGetCoursesQuery(baseOptions?: Apollo.QueryHookOptions<GetCoursesQuery, GetCoursesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCoursesQuery, GetCoursesQueryVariables>(GetCoursesDocument, options);
}
export function useGetCoursesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetCoursesQuery, GetCoursesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCoursesQuery, GetCoursesQueryVariables>(GetCoursesDocument, options);
}
export function useGetCoursesSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCoursesQuery, GetCoursesQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetCoursesQuery, GetCoursesQueryVariables>(GetCoursesDocument, options);
}
export type GetCoursesQueryHookResult = ReturnType<typeof useGetCoursesQuery>;
export type GetCoursesLazyQueryHookResult = ReturnType<typeof useGetCoursesLazyQuery>;
export type GetCoursesSuspenseQueryHookResult = ReturnType<typeof useGetCoursesSuspenseQuery>;
export type GetCoursesQueryResult = Apollo.QueryResult<GetCoursesQuery, GetCoursesQueryVariables>;
export const GetEmployementOverviewDocument = gql`
  query getEmployementOverview {
    me {
      currentEmployement {
        cooperations {
          jobPosition {
            title
            contractType
            workExperienceYearsRange
          }
          status
          employerSatisfactionRate
          endAt
          startAt
          createdAt
        }
        organization {
          name
          logo {
            file
          }
          city {
            country {
              name
            }
            name
          }
          size
          establishedAt
          industry {
            title
          }
          contacts {
            type
            value
          }
        }
      }
    }
    academy {
      courses(results_Status: COMPLETED) {
        totalCount
      }
    }
  }
`;

/**
 * __useGetEmployementOverviewQuery__
 *
 * To run a query within a React component, call `useGetEmployementOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployementOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployementOverviewQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEmployementOverviewQuery(
  baseOptions?: Apollo.QueryHookOptions<GetEmployementOverviewQuery, GetEmployementOverviewQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetEmployementOverviewQuery, GetEmployementOverviewQueryVariables>(
    GetEmployementOverviewDocument,
    options,
  );
}
export function useGetEmployementOverviewLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetEmployementOverviewQuery, GetEmployementOverviewQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetEmployementOverviewQuery, GetEmployementOverviewQueryVariables>(
    GetEmployementOverviewDocument,
    options,
  );
}
export function useGetEmployementOverviewSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetEmployementOverviewQuery, GetEmployementOverviewQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetEmployementOverviewQuery, GetEmployementOverviewQueryVariables>(
    GetEmployementOverviewDocument,
    options,
  );
}
export type GetEmployementOverviewQueryHookResult = ReturnType<typeof useGetEmployementOverviewQuery>;
export type GetEmployementOverviewLazyQueryHookResult = ReturnType<typeof useGetEmployementOverviewLazyQuery>;
export type GetEmployementOverviewSuspenseQueryHookResult = ReturnType<typeof useGetEmployementOverviewSuspenseQuery>;
export type GetEmployementOverviewQueryResult = Apollo.QueryResult<
  GetEmployementOverviewQuery,
  GetEmployementOverviewQueryVariables
>;
export const GetEducationsDocument = gql`
  query GetEducations {
    me {
      educations {
        id
        field {
          name
        }
        degree
        start
        end
        status
        university {
          name
        }
        city {
          name
          region {
            name
            country {
              name
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetEducationsQuery__
 *
 * To run a query within a React component, call `useGetEducationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEducationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEducationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEducationsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetEducationsQuery, GetEducationsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetEducationsQuery, GetEducationsQueryVariables>(GetEducationsDocument, options);
}
export function useGetEducationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetEducationsQuery, GetEducationsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetEducationsQuery, GetEducationsQueryVariables>(GetEducationsDocument, options);
}
export function useGetEducationsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEducationsQuery, GetEducationsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetEducationsQuery, GetEducationsQueryVariables>(GetEducationsDocument, options);
}
export type GetEducationsQueryHookResult = ReturnType<typeof useGetEducationsQuery>;
export type GetEducationsLazyQueryHookResult = ReturnType<typeof useGetEducationsLazyQuery>;
export type GetEducationsSuspenseQueryHookResult = ReturnType<typeof useGetEducationsSuspenseQuery>;
export type GetEducationsQueryResult = Apollo.QueryResult<GetEducationsQuery, GetEducationsQueryVariables>;
export const GetInterestedJobsDocument = gql`
  query GetInterestedJobs {
    me {
      profile {
        interestedJobs {
          edges {
            node {
              title
              id
              requireAppearanceData
            }
          }
        }
        employmentStatus
        eyeColor
        fullBodyImage {
          file
        }
        hairColor
        height
        skinColor
        weight
        jobCities {
          edges {
            node {
              id
              name
            }
          }
        }
        jobLocationType
        jobType
      }
    }
  }
`;

/**
 * __useGetInterestedJobsQuery__
 *
 * To run a query within a React component, call `useGetInterestedJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInterestedJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInterestedJobsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetInterestedJobsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetInterestedJobsQuery, GetInterestedJobsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetInterestedJobsQuery, GetInterestedJobsQueryVariables>(GetInterestedJobsDocument, options);
}
export function useGetInterestedJobsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetInterestedJobsQuery, GetInterestedJobsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetInterestedJobsQuery, GetInterestedJobsQueryVariables>(
    GetInterestedJobsDocument,
    options,
  );
}
export function useGetInterestedJobsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetInterestedJobsQuery, GetInterestedJobsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetInterestedJobsQuery, GetInterestedJobsQueryVariables>(
    GetInterestedJobsDocument,
    options,
  );
}
export type GetInterestedJobsQueryHookResult = ReturnType<typeof useGetInterestedJobsQuery>;
export type GetInterestedJobsLazyQueryHookResult = ReturnType<typeof useGetInterestedJobsLazyQuery>;
export type GetInterestedJobsSuspenseQueryHookResult = ReturnType<typeof useGetInterestedJobsSuspenseQuery>;
export type GetInterestedJobsQueryResult = Apollo.QueryResult<GetInterestedJobsQuery, GetInterestedJobsQueryVariables>;
export const GetJobPositionAssignmentsDocument = gql`
  query GetJobPositionAssignments(
    $jobPositionStatus: [AuthAccountOrganizationJobPositionStatusChoices]
    $id: ID
    $first: Int
    $jobSeekerStatus: [AuthAccountJobPositionAssignmentStatusChoices]
  ) {
    me {
      jobPositionAssignments(
        id: $id
        first: $first
        jobPosition_Status_In: $jobPositionStatus
        status_In: $jobSeekerStatus
      ) {
        edges {
          node {
            id
            status
            statusHistories {
              createdAt
              status
              interview {
                id
                event {
                  datetime
                  meetUrl
                  status
                  attendees {
                    firstName
                    id
                    lastName
                  }
                }
                slot {
                  datetime
                  id
                  isAvailable
                }
              }
            }
            createdAt
            jobPosition {
              cities {
                edges {
                  node {
                    country {
                      name
                    }
                    name
                    displayName
                  }
                }
              }
              contractType
              description
              locationType
              organization {
                name
                logo {
                  file
                }
                shortName
                city {
                  country {
                    name
                  }
                  name
                  displayName
                }
                contacts {
                  id
                  type
                  value
                }
                establishedAt
                size
                id
                about
                businessType
              }
              salaryRange
              requiredDocuments
              otherBenefits
              ageRange
              benefits {
                id
                name
              }
              daysOff
              degrees
              fields {
                id
                name
              }
              id
              jobRestrictions
              languages
              nativeLanguages
              paymentTerm
              performanceExpectation
              skills {
                id
                title
              }
              status
              startAt
              title
              vaccancy
              validityDate
              workExperienceYearsRange
              workingEndAt
              workingStartAt
              interviewSlots {
                datetime
                id
                isAvailable
              }
            }
            interviews {
              event {
                attendees {
                  firstName
                  id
                  lastName
                }
                datetime
                meetUrl
                status
              }
              id
              slot {
                datetime
                id
                isAvailable
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetJobPositionAssignmentsQuery__
 *
 * To run a query within a React component, call `useGetJobPositionAssignmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobPositionAssignmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobPositionAssignmentsQuery({
 *   variables: {
 *      jobPositionStatus: // value for 'jobPositionStatus'
 *      id: // value for 'id'
 *      first: // value for 'first'
 *      jobSeekerStatus: // value for 'jobSeekerStatus'
 *   },
 * });
 */
export function useGetJobPositionAssignmentsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetJobPositionAssignmentsQuery, GetJobPositionAssignmentsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetJobPositionAssignmentsQuery, GetJobPositionAssignmentsQueryVariables>(
    GetJobPositionAssignmentsDocument,
    options,
  );
}
export function useGetJobPositionAssignmentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetJobPositionAssignmentsQuery, GetJobPositionAssignmentsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetJobPositionAssignmentsQuery, GetJobPositionAssignmentsQueryVariables>(
    GetJobPositionAssignmentsDocument,
    options,
  );
}
export function useGetJobPositionAssignmentsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetJobPositionAssignmentsQuery, GetJobPositionAssignmentsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetJobPositionAssignmentsQuery, GetJobPositionAssignmentsQueryVariables>(
    GetJobPositionAssignmentsDocument,
    options,
  );
}
export type GetJobPositionAssignmentsQueryHookResult = ReturnType<typeof useGetJobPositionAssignmentsQuery>;
export type GetJobPositionAssignmentsLazyQueryHookResult = ReturnType<typeof useGetJobPositionAssignmentsLazyQuery>;
export type GetJobPositionAssignmentsSuspenseQueryHookResult = ReturnType<
  typeof useGetJobPositionAssignmentsSuspenseQuery
>;
export type GetJobPositionAssignmentsQueryResult = Apollo.QueryResult<
  GetJobPositionAssignmentsQuery,
  GetJobPositionAssignmentsQueryVariables
>;
export const GetLanguagesCertificatesDocument = gql`
  query GetLanguagesCertificates {
    me {
      languagecertificates {
        allowSelfVerification
        expiredAt
        id
        issuedAt
        language
        status
        test {
          title
          id
        }
        values {
          id
          skill {
            id
            skillName
            slug
          }
          value
        }
      }
    }
  }
`;

/**
 * __useGetLanguagesCertificatesQuery__
 *
 * To run a query within a React component, call `useGetLanguagesCertificatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLanguagesCertificatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLanguagesCertificatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLanguagesCertificatesQuery(
  baseOptions?: Apollo.QueryHookOptions<GetLanguagesCertificatesQuery, GetLanguagesCertificatesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetLanguagesCertificatesQuery, GetLanguagesCertificatesQueryVariables>(
    GetLanguagesCertificatesDocument,
    options,
  );
}
export function useGetLanguagesCertificatesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetLanguagesCertificatesQuery, GetLanguagesCertificatesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetLanguagesCertificatesQuery, GetLanguagesCertificatesQueryVariables>(
    GetLanguagesCertificatesDocument,
    options,
  );
}
export function useGetLanguagesCertificatesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetLanguagesCertificatesQuery, GetLanguagesCertificatesQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetLanguagesCertificatesQuery, GetLanguagesCertificatesQueryVariables>(
    GetLanguagesCertificatesDocument,
    options,
  );
}
export type GetLanguagesCertificatesQueryHookResult = ReturnType<typeof useGetLanguagesCertificatesQuery>;
export type GetLanguagesCertificatesLazyQueryHookResult = ReturnType<typeof useGetLanguagesCertificatesLazyQuery>;
export type GetLanguagesCertificatesSuspenseQueryHookResult = ReturnType<
  typeof useGetLanguagesCertificatesSuspenseQuery
>;
export type GetLanguagesCertificatesQueryResult = Apollo.QueryResult<
  GetLanguagesCertificatesQuery,
  GetLanguagesCertificatesQueryVariables
>;
export const GetNativeLanguagesDocument = gql`
  query GetNativeLanguages {
    me {
      profile {
        nativeLanguage
        fluentLanguages
      }
    }
  }
`;

/**
 * __useGetNativeLanguagesQuery__
 *
 * To run a query within a React component, call `useGetNativeLanguagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNativeLanguagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNativeLanguagesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNativeLanguagesQuery(
  baseOptions?: Apollo.QueryHookOptions<GetNativeLanguagesQuery, GetNativeLanguagesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetNativeLanguagesQuery, GetNativeLanguagesQueryVariables>(
    GetNativeLanguagesDocument,
    options,
  );
}
export function useGetNativeLanguagesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetNativeLanguagesQuery, GetNativeLanguagesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetNativeLanguagesQuery, GetNativeLanguagesQueryVariables>(
    GetNativeLanguagesDocument,
    options,
  );
}
export function useGetNativeLanguagesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetNativeLanguagesQuery, GetNativeLanguagesQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetNativeLanguagesQuery, GetNativeLanguagesQueryVariables>(
    GetNativeLanguagesDocument,
    options,
  );
}
export type GetNativeLanguagesQueryHookResult = ReturnType<typeof useGetNativeLanguagesQuery>;
export type GetNativeLanguagesLazyQueryHookResult = ReturnType<typeof useGetNativeLanguagesLazyQuery>;
export type GetNativeLanguagesSuspenseQueryHookResult = ReturnType<typeof useGetNativeLanguagesSuspenseQuery>;
export type GetNativeLanguagesQueryResult = Apollo.QueryResult<
  GetNativeLanguagesQuery,
  GetNativeLanguagesQueryVariables
>;
export const GetProfileDocument = gql`
  query GetProfile {
    me {
      email
      firstName
      lastName
      hasResume
      resumeAssessmentsReady
      resume {
        file {
          file
        }
      }
      cv {
        file
      }
      referral {
        code
      }
      profile {
        birthDate
        gender
        credits
        score
        scores
        allowNotifications
        acceptTermsAndConditions
        avatar {
          file
        }
        city {
          country {
            id
            name
          }
          id
          name
          region {
            name
            id
          }
        }
        contacts {
          value
          type
          id
        }
        completionPercentage
        isOnboardingCompleted
        industry {
          id
        }
        interestedJobs {
          edges {
            node {
              id
            }
          }
        }
        country {
          id
        }
      }
      workexperiences {
        jobTitle
      }
      jobPositionAssignments(status_In: AWAITING_JOBSEEKER_APPROVAL) {
        totalCount
      }
    }
  }
`;

/**
 * __useGetProfileQuery__
 *
 * To run a query within a React component, call `useGetProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProfileQuery(baseOptions?: Apollo.QueryHookOptions<GetProfileQuery, GetProfileQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetProfileQuery, GetProfileQueryVariables>(GetProfileDocument, options);
}
export function useGetProfileLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetProfileQuery, GetProfileQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetProfileQuery, GetProfileQueryVariables>(GetProfileDocument, options);
}
export function useGetProfileSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProfileQuery, GetProfileQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetProfileQuery, GetProfileQueryVariables>(GetProfileDocument, options);
}
export type GetProfileQueryHookResult = ReturnType<typeof useGetProfileQuery>;
export type GetProfileLazyQueryHookResult = ReturnType<typeof useGetProfileLazyQuery>;
export type GetProfileSuspenseQueryHookResult = ReturnType<typeof useGetProfileSuspenseQuery>;
export type GetProfileQueryResult = Apollo.QueryResult<GetProfileQuery, GetProfileQueryVariables>;
export const GetProfileCompletionDataDocument = gql`
  query GetProfileCompletionData {
    me {
      firstName
      lastName
      email
      profile {
        gender
        industry {
          id
          title
        }
        contacts {
          id
          type
          value
        }
        interestedJobs {
          edges {
            node {
              title
              id
            }
          }
        }
        country {
          code2
          name
          id
        }
      }
      canadaVisa {
        id
        status
        nationality {
          id
          name
          code2
        }
      }
    }
  }
`;

/**
 * __useGetProfileCompletionDataQuery__
 *
 * To run a query within a React component, call `useGetProfileCompletionDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProfileCompletionDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProfileCompletionDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProfileCompletionDataQuery(
  baseOptions?: Apollo.QueryHookOptions<GetProfileCompletionDataQuery, GetProfileCompletionDataQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetProfileCompletionDataQuery, GetProfileCompletionDataQueryVariables>(
    GetProfileCompletionDataDocument,
    options,
  );
}
export function useGetProfileCompletionDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetProfileCompletionDataQuery, GetProfileCompletionDataQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetProfileCompletionDataQuery, GetProfileCompletionDataQueryVariables>(
    GetProfileCompletionDataDocument,
    options,
  );
}
export function useGetProfileCompletionDataSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetProfileCompletionDataQuery, GetProfileCompletionDataQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetProfileCompletionDataQuery, GetProfileCompletionDataQueryVariables>(
    GetProfileCompletionDataDocument,
    options,
  );
}
export type GetProfileCompletionDataQueryHookResult = ReturnType<typeof useGetProfileCompletionDataQuery>;
export type GetProfileCompletionDataLazyQueryHookResult = ReturnType<typeof useGetProfileCompletionDataLazyQuery>;
export type GetProfileCompletionDataSuspenseQueryHookResult = ReturnType<
  typeof useGetProfileCompletionDataSuspenseQuery
>;
export type GetProfileCompletionDataQueryResult = Apollo.QueryResult<
  GetProfileCompletionDataQuery,
  GetProfileCompletionDataQueryVariables
>;
export const GetUserSkillsDocument = gql`
  query GetUserSkills {
    me {
      profile {
        rawSkills
        skills {
          id
          title
        }
      }
    }
  }
`;

/**
 * __useGetUserSkillsQuery__
 *
 * To run a query within a React component, call `useGetUserSkillsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserSkillsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserSkillsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserSkillsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetUserSkillsQuery, GetUserSkillsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetUserSkillsQuery, GetUserSkillsQueryVariables>(GetUserSkillsDocument, options);
}
export function useGetUserSkillsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetUserSkillsQuery, GetUserSkillsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetUserSkillsQuery, GetUserSkillsQueryVariables>(GetUserSkillsDocument, options);
}
export function useGetUserSkillsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserSkillsQuery, GetUserSkillsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetUserSkillsQuery, GetUserSkillsQueryVariables>(GetUserSkillsDocument, options);
}
export type GetUserSkillsQueryHookResult = ReturnType<typeof useGetUserSkillsQuery>;
export type GetUserSkillsLazyQueryHookResult = ReturnType<typeof useGetUserSkillsLazyQuery>;
export type GetUserSkillsSuspenseQueryHookResult = ReturnType<typeof useGetUserSkillsSuspenseQuery>;
export type GetUserSkillsQueryResult = Apollo.QueryResult<GetUserSkillsQuery, GetUserSkillsQueryVariables>;
export const GetSupportTicketsDocument = gql`
  query GetSupportTickets {
    me {
      supportTickets {
        category {
          id
          title
        }
        contactMethod
        contactValue
        created
        description
        id
        priority
        status
        ticketId
        title
        modified
      }
    }
  }
`;

/**
 * __useGetSupportTicketsQuery__
 *
 * To run a query within a React component, call `useGetSupportTicketsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSupportTicketsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSupportTicketsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSupportTicketsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetSupportTicketsQuery, GetSupportTicketsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetSupportTicketsQuery, GetSupportTicketsQueryVariables>(GetSupportTicketsDocument, options);
}
export function useGetSupportTicketsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetSupportTicketsQuery, GetSupportTicketsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetSupportTicketsQuery, GetSupportTicketsQueryVariables>(
    GetSupportTicketsDocument,
    options,
  );
}
export function useGetSupportTicketsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetSupportTicketsQuery, GetSupportTicketsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetSupportTicketsQuery, GetSupportTicketsQueryVariables>(
    GetSupportTicketsDocument,
    options,
  );
}
export type GetSupportTicketsQueryHookResult = ReturnType<typeof useGetSupportTicketsQuery>;
export type GetSupportTicketsLazyQueryHookResult = ReturnType<typeof useGetSupportTicketsLazyQuery>;
export type GetSupportTicketsSuspenseQueryHookResult = ReturnType<typeof useGetSupportTicketsSuspenseQuery>;
export type GetSupportTicketsQueryResult = Apollo.QueryResult<GetSupportTicketsQuery, GetSupportTicketsQueryVariables>;
export const GetSupportTicketCategoryDocument = gql`
  query GetSupportTicketCategory(
    $after: String = ""
    $before: String = ""
    $first: Int = 100
    $last: Int = 100
    $types_Contains: [AuthAccountSupportTicketCategoryTypesChoices]
  ) {
    supportTicketCategory(first: $first, before: $before, after: $after, last: $last, types_Contains: $types_Contains) {
      edges {
        node {
          id
          title
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
  }
`;

/**
 * __useGetSupportTicketCategoryQuery__
 *
 * To run a query within a React component, call `useGetSupportTicketCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSupportTicketCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSupportTicketCategoryQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      types_Contains: // value for 'types_Contains'
 *   },
 * });
 */
export function useGetSupportTicketCategoryQuery(
  baseOptions?: Apollo.QueryHookOptions<GetSupportTicketCategoryQuery, GetSupportTicketCategoryQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetSupportTicketCategoryQuery, GetSupportTicketCategoryQueryVariables>(
    GetSupportTicketCategoryDocument,
    options,
  );
}
export function useGetSupportTicketCategoryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetSupportTicketCategoryQuery, GetSupportTicketCategoryQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetSupportTicketCategoryQuery, GetSupportTicketCategoryQueryVariables>(
    GetSupportTicketCategoryDocument,
    options,
  );
}
export function useGetSupportTicketCategorySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetSupportTicketCategoryQuery, GetSupportTicketCategoryQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetSupportTicketCategoryQuery, GetSupportTicketCategoryQueryVariables>(
    GetSupportTicketCategoryDocument,
    options,
  );
}
export type GetSupportTicketCategoryQueryHookResult = ReturnType<typeof useGetSupportTicketCategoryQuery>;
export type GetSupportTicketCategoryLazyQueryHookResult = ReturnType<typeof useGetSupportTicketCategoryLazyQuery>;
export type GetSupportTicketCategorySuspenseQueryHookResult = ReturnType<
  typeof useGetSupportTicketCategorySuspenseQuery
>;
export type GetSupportTicketCategoryQueryResult = Apollo.QueryResult<
  GetSupportTicketCategoryQuery,
  GetSupportTicketCategoryQueryVariables
>;
